import type { Dict } from '../types';

export const ja: Dict = {
  "collab.contentUpdate.available": "クラウドに新しいバージョンがあります",
  "collab.contentUpdate.updating": "更新中…",
  "collab.contentUpdate.askAgain": "更新通知を再開",
  "collab.contentUpdate.title": "クラウドに更新があります",
  "collab.contentUpdate.description": "他のデバイスの最新内容をこのデバイスに同期しますか？ローカルのプロジェクト内容が上書きされます。ページはローカルのバージョン履歴から復元できますが、画像やその他のファイルは復元できない場合があります。",
  "collab.contentUpdate.dontPrompt": "このプロジェクトの通知を24時間表示しない",
  "collab.contentUpdate.later": "今は更新しない",
  "collab.contentUpdate.replace": "クラウド版で上書き",
  "collab.contentUpdate.failed": "更新に失敗しました。再試行してください。",
  "collab.contentUpdate.busy": "生成またはアップロード中です。完了後に再試行してください。",
  "collab.contentUpdate.unsupported": "インポートしたフォルダーのクラウド上書きには対応していません。",
  "fileViewer.versions.sourceSync": "同期",
  'billing.wallet': 'ウォレット残高',
  'billing.codingPlanDesignPlan': 'Design Plan',
  'billing.codingPlanPeriodHours': '{count} 時間',
  'billing.codingPlanPeriodDays': '{count} 日間',
  'billing.codingPlanRemainingPercent': '残り {percent}%',
  "campaign.testReplay": "テストアクティビティを再表示",
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in OpenDesign.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening OpenDesign so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open OpenDesign",
  'invite.open.opening': "Opening OpenDesign…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have OpenDesign installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download OpenDesign",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "このワークスペースには空き席がありません。席数を追加すると招待できます。",
  "workspaceInvite.seatsExhaustedAction": "席数とプランを見る",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "このメールアドレスは既にチームメンバーです。",
  "workspaceInvite.errorPendingInvite": "このメールアドレスには保留中の招待が既にあります。",
  "workspaceInvite.errorNoSession": "メンバーを招待する前に Vela アカウントにサインインしてください。",
  "workspaceInvite.errorNoWorkspace": "メンバーを招待できるチームワークスペースがまだありません。",
  "workspaceInvite.errorUnreachable": "招待を送信できませんでした。しばらくしてからもう一度お試しください。",
  'chat.amrCard.switchTitle': 'モデル呼び出しに失敗しました — このタスクは一時停止中です',
  'chat.amrCard.switchBody': 'OpenDesign Cloud 公式のモデルサービスに切り替えてください — API キーの設定は不要です。サインイン・認可・チャージが完了すると、このタスクは自動で再試行されます。',
  'chat.amrCard.chipOfficial': '公式ホスティング',
  'chat.amrCard.chipNoKey': 'API キー不要',
  'chat.amrCard.chipAutoRetry': 'サインイン後に自動再試行',
  'chat.amrCard.switchCta': 'OpenDesign Cloud に切り替える',
  "chat.amrCard.switchedResend": "OpenDesign Cloud に切り替えました。タスクを再送信してください。",
  'chat.amrError.authMessage': 'OpenDesign Cloud アカウントがまだ認可されていません。認可するとこのタスクは自動で再試行されます。',
  'chat.amrError.balanceMessage': 'OpenDesign Cloud の残高が不足しています。チャージしてこのタスクを続行してください。',
  'chat.amrError.authorizeCta': '認可して再試行',
  'chat.amrError.rechargeCta': 'チャージ',
  'chat.amrBalanceGate.title': '利用可能な残高が不足しています',
  'chat.amrBalanceGate.message': '残高が不足しています。チャージするかプランをアップグレードしてから、もう一度お試しください。',
  'chat.amrBalanceGate.benefitsTitle': 'OpenDesign Cloud で得られるもの',
  'chat.amrBalanceGate.benefit1': 'API キー不要、豊富なモデルを自由に',
  'chat.amrBalanceGate.benefit2': 'SOTA デザインエージェント内蔵、設定不要',
  'chat.amrBalanceGate.benefit3': '公式サービスで安心',
  'chat.amrBalanceGate.benefit4': '進化し続ける：ワンクリック公開・マルチモーダル・チーム版など',
  'chat.amrBalanceGate.laterCta': '今はしない',
  'chat.amrBalanceGate.plansCta': 'プランをアップグレード',
  'chat.amrBalanceGate.signedOutTitle': 'Open Design にサインインしていません',
  'chat.amrBalanceGate.signedOutMessage': 'プロジェクトを表示して会話を続けるには、ログインしてください。',
  'chat.amrBalanceGate.signInCta': 'サインイン',
  'chat.amrBalanceGate.watchingWallet': '残高が反映されると自動的に続行します。',
  'chat.amrArtifactUpgrade.title': 'より強力なモデルでさらに磨き上げる',
  'chat.amrArtifactUpgrade.message': '高度なモデル、より多くの並列タスク、毎月の追加クレジットを利用できます。',
  'chat.amrArtifactUpgrade.benefit1': 'Fable 5、GPT-5.6 など、より多くの高性能モデル',
  'chat.amrArtifactUpgrade.benefit2': '同時実行できるタスク数が最大10倍',
  'chat.amrArtifactUpgrade.benefit3': '毎月のクレジットが最大300倍',
  'chat.amrArtifactUpgrade.benefit4': '混雑時も優先処理で、生成を高速化',
  'chat.amrArtifactUpgrade.promoBanner': '期間限定：サブスクリプションが最大67%オフ',
  'chat.amrArtifactUpgrade.countdownLabel': '終了まで',
  'chat.amrArtifactUpgrade.plansCta': '今すぐアップグレード、最大67%オフ',
  'chat.amrArtifactUpgrade.homePlansCta': '67%オフでアップグレード',
  'chat.amrArtifactUpgrade.laterCta': 'Freeのまま送信する',
  'chat.amrArtifactUpgrade.homeTitle': '作品が完成しました。次のアイデアをさらに先へ。',
  'chat.amrArtifactUpgrade.homeMessage': 'より強力なモデル、並列タスク、毎月の追加クレジットを利用できます。',
  'chat.amrArtifactUpgrade.homeArtifactCta': '作品を見る',
  'chat.antigravityError.launchTerminalCta': 'ターミナルでサインイン',
  'chat.antigravityError.launchSwitchModelCta': 'ターミナルでモデルを切り替え',
  'chat.connectionDropped': 'ネットワーク接続が正常か確認してから、もう一度お試しください。',
  'chat.runError.title.authRequired': '認証が必要です',
  'chat.runError.title.balance': '残高不足',
  'chat.runError.title.connectionDropped': 'ネットワーク接続が切断されました',
  'chat.runError.title.signInRequired.other': '{agent} にサインインしていません',
  'chat.runError.title.signInRequired.amr': 'Open Design にサインインしていません',
  'chat.runError.title.rateLimited': 'モデルサービスが混雑しています',
  'chat.runError.title.modelWindowLimit': 'アクセスが集中しています',
  'chat.runError.title.membershipConcurrencyLimit': '同時実行タスクの上限に達しました',
  'chat.runError.title.strategyTaskHalted': "タスクは品質ゲートで停止されました",
  "chat.runError.title.agentReplyIncomplete": "タスクを完了できませんでした",
  'chat.runError.title.noDeliverable': "今回は何も出力されませんでした",
  'chat.runError.title.clarificationRepeated': "エージェントが再び質問しました",
  "chat.runError.title.regionNotSupported": "現在、この地域ではこのサービスを利用できません",
  'chat.runError.title.clientEnvironment': 'ネットワーク環境の問題',
  "chat.runError.title.certificateFailure": "サービスに安全に接続できません",
  "chat.runError.certificateFailureMessage": "サービスへの接続時にセキュリティ検証に失敗しました。別のネットワークをお試しください。",
  "chat.runError.title.proxyConfiguration": "プロキシに接続できません",
  "chat.runError.proxyConfigurationMessage": "設定されたプロキシに接続できません。プロキシが有効で、正しく設定されていることを確認して、もう一度お試しください。",
  "chat.runError.title.networkConfiguration": "サービスに接続できません",
  "chat.runError.networkConfigurationMessage": "一時的にサービスにアクセスできません。ネットワーク接続を確認して、もう一度お試しください。",
  "chat.runError.title.hostPolicyBlock": "プログラムの起動が制限されています",
  "chat.runError.hostPolicyBlockMessage": "Windows がプログラムの起動をブロックしました。システムのセキュリティ設定を確認してください。",
  "chat.runError.title.localStorageFailure": "ファイルを保存できません",
  "chat.runError.localStorageFailureMessage": "ファイルをディスクに書き込めません。十分な空き容量があることを確認してから、もう一度お試しください。",
  "chat.runError.title.tierUpgradeRequired": "現在のプランではこのタスクに対応していません",
  "chat.runError.tierUpgradeRequiredMessage": "現在のプランではこのタスクを続行できません。プランをアップグレードして、もう一度お試しください。",
  "chat.runError.title.generic": "タスクを完了できませんでした",
  'chat.runError.title.artifactMissing': "プレビューできるファイルがありません",
  'chat.runError.artifactMissingMessage': "このタスクではプレビューできるファイルが生成されませんでした。生成したい内容を補足してから、もう一度お試しください。",
  'chat.runError.signInMessage.amr': 'プロジェクトを表示して会話を続けるには、ログインしてください。',
  'chat.runError.signInMessage.other': 'まず {agent} にログインしてから、もう一度お試しください。',
  'chat.runError.agentFallback': 'エージェント',
  'chat.runError.sourceLabel': 'エラーの詳細',
  'chat.runError.sourceExpandAria': 'エラーのソースを展開',
  'chat.runError.sourceCollapseAria': 'エラーのソースを折りたたむ',
  'chat.runError.title.cliMissing': '{agent} を検出できません',
  'chat.runError.title.promptTooLarge': '会話が長すぎます',
  'chat.runError.title.modelUnavailable': "現在のモデルは利用できません",
  'chat.runError.title.modelCapabilityUnsupported': "現在のモデルはこのタスクに対応していません",
  'chat.runError.title.upstreamUnavailable': 'モデルサービスを利用できません',
  "chat.runError.title.toolLoop": "タスクを続行できません",
  'chat.runError.title.outputInvalid': '有効な回答を生成できませんでした',
  'chat.runError.title.runtimeConfig': "Open Design の実行エラー",
  'chat.runError.title.apiKeyInvalid': 'モデル設定が未完了です',
  'chat.runError.cliMissingMessage': 'このコンピューターに {agent} がインストールされているか確認してから、もう一度お試しください。',
  "chat.runError.promptTooLargeMessage": "現在のコンテキストがモデルで処理できる長さを超えています。新しい会話を作成して、もう一度お試しください。",
  'chat.runError.modelUnavailableMessage': "利用できる別のモデルを選んでから、もう一度お試しください。",
  'chat.runError.modelCapabilityUnsupportedMessage': "このモデルはタスクに必要な機能に対応していません。モデルを変更してから、もう一度お試しください。",
  'chat.runError.rateLimitedMessage': '現在このモデルサービスへのリクエストが多く、プロバイダーのリクエスト頻度の上限に達しました。しばらくしてから再試行するか、別のモデルへの切り替えをお試しください。',
  'chat.runError.modelWindowLimitMessage': 'アクセスが集中しています。{retryAt} 以降に再度お試しください（今回のリクエストは課金されていません）。',
  'chat.runError.modelWindowLimitMessageNoTime': 'アクセスが集中しています。しばらくしてから再度お試しください（今回のリクエストは課金されていません）。',
  'chat.runError.membershipConcurrencyLimitMessage': 'メンバーシップの同時実行タスク上限に達しています。{retryAt} まで待って再試行するか、別のエージェントに切り替えてください。すぐに再試行しても解消しません。',
  'chat.runError.membershipConcurrencyLimitMessageNoTime': 'メンバーシップの同時実行タスク上限に達しています。ほかのタスクが完了してから再試行するか、別のエージェントに切り替えてください。',
  'chat.runError.upstreamUnavailableMessage': '現在のモデルは一時的に利用できません。しばらくしてから再試行するか、モデルを変更してください。',
  "chat.runError.toolLoopMessage": "AI が同じ手順で止まり、何度試しても続行できませんでした。再試行するか、モデルを変更してもう一度お試しください。",
  'chat.runError.outputInvalidMessage': 'もう一度生成するか、モデルを変更して再試行してください。繰り返し発生する場合は、サポートまでご連絡ください。',
  'chat.runError.runtimeConfigMessage': 'もう一度生成するか、モデルを変更して再試行してください。繰り返し発生する場合は、サポートまでご連絡ください。',
  'chat.runError.apiKeyInvalidMessage': 'API キーの設定が正しくありません。入力し直してから、もう一度お試しください。',
  'chat.runError.title.quotaExhausted': "利用上限に達しました",
  'chat.runError.title.timedOut': "応答待ちがタイムアウトしました",
  "chat.runError.title.emptyOutput": "コンテンツを生成できませんでした",
  "chat.runError.title.sessionExpired": "前のタスクを再開できません",
  'chat.runError.title.gitBashMissing': "Git Bash がありません",
  "chat.runError.title.cpuUnsupported": "このデバイスではプログラムを実行できません",
  "chat.runError.title.osUnsupported": "Windows のバージョンが古すぎます",
  'chat.runError.title.cliSessionRefused': "エージェントのバージョンが非対応",
  'chat.runError.quotaExhaustedMessage': "利用中のモデルサービスの割り当てまたは請求上限に達したため、再試行しても回復しません。プロバイダーでチャージするか、別のモデル／サービスに切り替えてください。",
  'chat.runError.workspaceCreditsMessage': "ワークスペースのクレジットがなくなりました。クレジットを追加する（またはワークスペース管理者に補充を依頼する）か、別のモデル／サービスに切り替えてください。",
  'chat.runError.timedOutMessage': "AI からの新しい応答が長時間なかったため、この実行を停止しました。しばらくしてからもう一度お試しください。",
  'chat.runError.inactivityTimeoutMessage': "AI からの新しい応答が長時間なかったため、この実行を停止しました。しばらくしてからもう一度お試しください。",
  "chat.runError.emptyOutputMessage": "AI がコンテンツを生成できませんでした。タスクを開始し直すか、モデルを変更してもう一度お試しください。",
  "chat.runError.sessionExpiredMessage": "前のタスクは続行できなくなりました。タスクを開始し直してください。",
  'chat.runError.gitBashMissingMessage': "Windows でこのエージェントを実行するには Git Bash が必要ですが、見つかりませんでした。Git for Windows をインストールして再試行してください。",
  "chat.runError.cpuUnsupportedMessage": "このコンピューターのプロセッサーは、プログラムに必要な機能に対応していません。動作要件を満たすデバイスをご使用ください。",
  "chat.runError.osUnsupportedMessage": "この Windows のバージョンは古いため、AMR ランタイムを実行できません。Windows 10 バージョン 1809（ビルド 17763）以降に更新してから、もう一度お試しください。",
  'chat.runError.title.agentCrashed': 'タスクが予期せず中断されました',
  'chat.runError.agentCrashedMessage': 'もう一度生成するか、モデルを変更して再試行してください。繰り返し発生する場合は、サポートまでご連絡ください。',
  'chat.runError.title.accountSuspended': 'アカウントが停止されました',
  'chat.runError.accountSuspendedMessage': '理由の確認や復旧の申請は、サポートまでご連絡ください。',
  "chat.runError.fallbackMessage": "今回のタスクの実行に失敗しました。もう一度お試しください。再度失敗する場合は、サポートにお問い合わせください。",
  "chat.runError.cliSessionRefusedMessage": "Open Design は現在このエージェントのバージョンに対応していません。対応するバージョンに変更して、もう一度お試しください。",
  'chat.runError.strategyTaskStateMismatchMessage': "このタスクはストラテジーの品質ゲートによってすでに停止されているため、このラウンドのフォームは続行できません。リクエストを再試行するか、新しく開始してください。",
  "chat.runError.agentReplyIncompleteMessage": "今回のタスクの実行に失敗しました。もう一度お試しください。再度失敗する場合は、サポートにお問い合わせください。",
  'chat.runError.noDeliverableMessage': "エージェントの処理は終わりましたが、プロジェクトにまだ開けるファイルがないため、完了として記録できませんでした。送信した内容は失われていません。もう一度実行するか、ほしいものを一言足して送り直してください。",
  'chat.runError.clarificationRepeatedMessage': "エージェントが2回目の詳細確認を求めましたが、1つのタスクで質問できるのは1回までのため、ここで停止しました。ご入力いただいた回答は会話に残っています。再試行するとリクエストを最初から実行し直すので、補足したい内容もまとめて書いておけば、たいてい1回のやり取りで済みます。",
  "chat.runError.regionNotSupportedMessage": "サービス提供元は現在、お住まいの地域にサービスを提供していないため、現在のタスクを続行できません。",
  'chat.runError.clientEnvironmentMessage': 'プロキシまたは社内ネットワーク経由のようで、{agent} がリクエストを拒否しました（{cause}）。別のネットワーク経路に切り替えるか、設定でプロキシを調整してください。',
  'chat.runError.clientEnvironmentCause.certificate': '証明書の検証に失敗',
  'chat.runError.clientEnvironmentCause.proxy': 'プロキシ設定の問題',
  'chat.runError.clientEnvironmentCause.network': 'ネットワークに到達できません',
  'chat.runError.clientEnvironmentCause.hostPolicy': 'システムポリシーによりブロック',
  'chat.runError.clientEnvironmentCause.localStorage': 'ローカルストレージの読み書きに失敗',
  'common.cancel': 'キャンセル',
  'chat.selectFromLibrary': 'ライブラリからインポート',
  'chat.importFigma': 'Figma からインポート',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the OpenDesign project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'ライブラリからインポート',
  'designFiles.library.title': 'ライブラリからインポート',
  'libraryPicker.title': 'ライブラリからインポート',
  'libraryPicker.searchPlaceholder': 'ライブラリを検索…',
  'libraryPicker.empty': 'ライブラリにアセットがまだありません',
  'libraryPicker.allKinds': 'すべて',
  'libraryPicker.add': 'インポート',
  'libraryPicker.loading': '読み込み中…',
  'common.save': '保存',
  'common.close': '閉じる',
  'common.clear': 'クリア',
  'common.delete': '削除',
  'common.rename': '名前を変更',
  'common.edit': '編集',
  'common.preview': 'プレビュー',
  'common.share': '共有',
  'common.search': '検索',
  'common.searchEllipsis': '検索…',
  'common.loading': '読み込み中…',
  'common.all': 'すべて',
  'common.none': 'なし',
  'common.default': 'デフォルト',
  'common.installed': 'インストール済み',
  'common.notInstalled': '未インストール',
  'common.active': 'アクティブ',
  'common.inactive': '非アクティブ',
  'common.offline': 'オフライン',
  'common.selected': '選択中',
  'common.create': '作成',
  'common.openPreview': 'プレビューを開く',
  'common.exitFullscreen': 'フルスクリーンを終了',
  'common.fullscreen': 'フルスクリーン',
  'common.openInNewTab': '新しいタブで開く',
  'common.exportPdf': 'PDFとしてエクスポート',
  'common.exportZip': '.zipとしてダウンロード',
  'common.exportHtml': 'スタンドアロンHTMLとしてエクスポート',
  'common.exportImage': '画像としてエクスポート',
  'common.exportImageFailed': '画像のキャプチャに失敗しました。再試行するか、ブラウザのスクリーンショットツールを使用してください。',
  'common.justNow': 'たった今',
  'common.minutesAgo': '{n}分前',
  'common.hoursAgo': '{n}時間前',
  'common.daysAgo': '{n}日前',
  'common.weeksAgo': '{n}週間前',
  'common.now': '今',
  'common.minutesShort': '{n}分',
  'common.hoursShort': '{n}時間',
  'common.daysShort': '{n}日',
  'common.untitled': '無題',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.viewport.desktop': 'デスクトップ',
  'designBrowser.viewport.desktopTitle': 'ブラウザタブのフルサイズを使用',
  'designBrowser.viewport.tablet': 'タブレット',
  'designBrowser.viewport.tabletTitle': '幅820pxでプレビュー',
  'designBrowser.viewport.mobile': 'モバイル',
  'designBrowser.viewport.mobileTitle': '幅390pxでプレビュー',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'チャットに追加',
  'designBrowser.status.imageAddedToChat': '画像をチャットに追加しました。',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': '来歴',
  'plugins.availableDetails.provenanceLine': '{source} より · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': '{source} より · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'インストール',
  'plugins.availableDetails.version': 'バージョン',
  'plugins.availableDetails.pluginVersion': 'プラグインのバージョン',
  'plugins.availableDetails.copyInstallCommand': 'インストールコマンドをコピー',
  'plugins.availableDetails.copied': 'コピーしました',
  'plugins.availableDetails.deprecatedPrefix': '非推奨: {message}',
  'plugins.availableDetails.deprecatedFallback': 'このバージョンは非推奨に指定されています。',
  'plugins.availableDetails.yanked': '取り下げ済み。',
  'plugins.availableDetails.yankedWithReason': '取り下げ済み: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': '（非推奨）',
  'plugins.availableDetails.versionYankedSuffix': '（取り下げ済み）',
  'plugins.availableDetails.ref': '参照',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': '権限',
  'plugins.availableDetails.capabilitySummary': '機能の概要',
  'plugins.actions.copyInstallCommand': 'インストールコマンドをコピー',
  'plugins.actions.copyPluginId': 'プラグイン ID をコピー',
  'plugins.actions.copyReadmeBadge': 'README バッジをコピー',
  'plugins.actions.openSourceGithub': 'GitHub でソースを開く',
  'plugins.actions.openSource': 'ソースを開く',
  'plugins.actions.openHomepage': 'ホームページを開く',
  'plugins.actions.openMarketplace': 'マーケットプレイスで開く',
  'app.brand': 'OpenDesign',
  'app.brandPill': 'リサーチプレビュー',
  'app.brandSubtitle': 'by Nexu Labs',
  'app.welcomeLoading': 'ワークスペースを読み込み中…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'OpenDesign へようこそ',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': '概要から始める',
  'settings.onboardingCreateBody': '作成したいサイト、アプリ、スライド、画像、動画を記述してください。OpenDesign がプロジェクトを作成し、編集可能な状態で作業を保持します。',
  'settings.onboardingMemoryTitle': '作業コンテキストを保存',
  'settings.onboardingMemoryBody': '設定、プロジェクトの情報、繰り返し使うルールを追加すると、今後のチャットで適切なコンテキストが引き継がれます。',
  'settings.onboardingMemoryCalloutTitle': 'メモリに保存しました',
  'settings.onboardingMemoryCalloutBody': 'これらの回答はメモリのプロフィールの基礎になります。OpenDesign はすべてのタスクでこれを再利用し、作業を進めるほど学習を続けます。',
  'settings.onboardingMemoryBenefitIntent': '短いリクエストから意図を理解します',
  'settings.onboardingMemoryBenefitFewerQuestions': '繰り返しのセットアップ質問を省きます',
  'settings.onboardingMemoryBenefitPersonalized': '役割、対象読者、好みに合わせて出力を調整します',
  'settings.onboardingSystemsTitle': 'デザインシステムを取り込む',
  'settings.onboardingSystemsBody': 'ブランドシステムを選択または作成すると、生成される成果物が実際の色、タイポグラフィ、プロダクトの言語表現に従います。',
  'settings.onboardingExecutionTitle': 'モデルの提供元を選択',
  'settings.onboardingExecutionBody': 'OpenDesign Hosted、ローカルエージェント、または自分のモデルキーから選べます。',
  'settings.onboardingAmrCloudBenefitOfficial': '公式おすすめ',
  'settings.onboardingAmrCloudBenefitReady': 'デプロイ不要',
  'settings.onboardingAmrCloudBenefitModels': 'Claude、GPT、Fable 5、5.6 sol を期間限定割引と高い同時実行数で利用できます。',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA ハーネス',
  'settings.onboardingAmrCloudUpcomingLabel': '近日対応',
  'settings.onboardingAmrCloudUpcomingImageVideo': '画像/動画生成',
  'settings.onboardingAmrCloudUpcomingSkills': '豊富な Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'スマートルーティング',
  'settings.onboardingAmrModelSourceLabel': 'OpenDesign Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'OpenDesign Cloud を認証',
  'settings.onboardingAmrCloudAuthorizedAction': '認証済み',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'デザインシステムを構築',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': '最新情報を受け取る',
  'settings.onboardingNewsletterTitle': '最新情報をお届け',
  'settings.onboardingNewsletterBody': '製品アップデート、新しいテンプレート、デザインシステム、アンバサダーの活動をメールでお届けします。任意 — スキップできます。',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'OpenDesign へようこそ',
  'settings.onboardingCloudBody': 'アイデアをデザインに。',
  'settings.onboardingCloudSignIn': 'ログイン / 新規登録',
  'settings.onboardingFreeCredits': '無料クレジット',
  'settings.onboardingFreeCreditsHint': '新規ユーザーには、DeepSeek V4.1 Flash を試せる無料クレジットをプレゼント。',
  'settings.onboardingOwnAi': 'または自分の AI を使う',
  'settings.onboardingLocalAi': 'ローカル AI',
  'settings.onboardingApiKey': 'API キー',
  'settings.onboardingCloudContinue': '続行（ログイン済み）',
  'settings.onboardingCloudAlternative': 'ローカル CLI または自分の API キーを使う',
  'settings.onboardingCloudRights': 'All rights reserved.',
  'settings.onboardingCloudOr': 'または',
  'settings.onboardingGateTooltipNoRuntime': 'この先のステップは AI で実行されます。続けるには実行方法を選んでください。',
  'settings.onboardingGateTooltipAmr': 'この先のステップは AI で実行されます。続けるには OpenDesign Cloud にサインインしてください。',
  'settings.onboardingGateTooltipLocal': 'この先のステップは AI で実行されます。続けるには利用可能なローカル CLI を選んでください。',
  'settings.onboardingGateTooltipByok': 'この先のステップは AI で実行されます。続けるにはモデルキーを追加してテストしてください。',
  'settings.onboardingRecommended': 'おすすめ',
  'settings.onboardingAmrCloudOfficialBadge': '公式',
  'settings.onboardingLocalTitle': 'ローカルエージェント',
  'settings.onboardingLocalBody': 'Claude Code、Codex、Cursor、OpenCode、Kimi、Qwen、Hermes、Kiro などを利用できます。',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': '自分のキーを使用',
  'settings.onboardingByokBody': '自分の API キーで、希望するモデルプロバイダーに安全に接続します。',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'あなたについて',
  'settings.onboardingProfileBody': 'より適切な初期設定のための任意項目です。',
  'settings.onboardingRoleLabel': 'あなたの役割',
  'settings.onboardingOrgSizeLabel': '組織の規模',
  'settings.onboardingUseCaseLabel': 'ユースケース',
  'settings.onboardingSourceLabel': '当サービスをどこで知りましたか？',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 検索（Google / Bing）',
  'settings.onboardingSourceAiTool': '🤖 AIツール（ChatGPT / Perplexity）',
  'settings.onboardingSourceFriend': '👥 友人・同僚',
  'settings.onboardingSourceCommunity': '💬 Discord / コミュニティ',
  'settings.onboardingSourceEmail': '✉️ メール / ニュースレター',
  'settings.onboardingSourceBlog': '📝 ブログ / 記事',
  'settings.onboardingSourceOther': '✨ その他',
  'settings.onboardingSourceOtherPlaceholder': 'どこで知ったか教えてください（任意）',
  'settings.onboardingSelectPlaceholder': '1つ選択',
  'settings.onboardingSelectMultiplePlaceholder': '1つ以上選択',
  'settings.onboardingOrgSolo': '個人 / 個人利用 (1)',
  'settings.onboardingOrgTeam': '小規模チーム (2-10)',
  'settings.onboardingOrgStartup': 'スタートアップ / 中小企業 (11-50)',
  'settings.onboardingOrgGrowth': '成長企業 (51-200)',
  'settings.onboardingOrgMidMarket': '中堅企業 (201-1000)',
  'settings.onboardingOrgEnterprise': '大企業 (1000+)',
  'settings.onboardingRolePm': '📋 プロダクトマネージャー',
  'settings.onboardingRoleDesigner': '🎨 デザイナー',
  'settings.onboardingRoleEngineer': '💻 エンジニア',
  'settings.onboardingRoleMarketing': '📣 マーケティング',
  'settings.onboardingRoleAgency': '📣 マーケティング代理店',
  'settings.onboardingRoleGrowth': '📈 成長',
  'settings.onboardingRoleOps': '⚙️ オペレーション',
  'settings.onboardingRoleFounder': '🚀 創業者 / 経営層',
  'settings.onboardingRoleStudent': '🎓 学生 / 教育者',
  'settings.onboardingRoleOther': '✨ その他',
  'settings.onboardingUseProduct': '🎨 プロダクトデザイン',
  'settings.onboardingUseDesignSystem': '🧩 デザインシステム',
  'settings.onboardingUsePrototype': '📱 プロトタイプ / アプリUI',
  'settings.onboardingUseLanding': '🌐 ランディングページ',
  'settings.onboardingUseAds': '📣 広告 / ソーシャルコンテンツ',
  'settings.onboardingUseDashboard': '📊 ダッシュボード / 社内ツール',
  'settings.onboardingUseDeck': '🖥️ プレゼン資料 / スライド',
  'settings.onboardingUseMarketing': '📈 マーケティング / 成長',
  'settings.onboardingUseEngineering': '🤝 エンジニアへの引き継ぎ',
  'settings.onboardingUseAgency': '💼 代理店 / クライアントワーク',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': '設定',
  'settings.title': 'モデルとプロバイダー',
  'settings.subtitle': 'ローカル CLI と BYOK のどちらを使うか選択します。',
  'settings.general': '一般',
  'settings.generalHint': '言語、外観、通知、プロジェクトの場所、プライバシー、アプリ詳細。',
  'settings.modeAria': '実行モード',
  'settings.protocolAria': 'API プロトコル',
  'settings.modeDaemon': 'ローカル CLI',
  'settings.modeDaemonHelp': 'マシン上のコードエージェント CLI 経由で実行',
  'settings.modeDaemonOffline': 'デーモンが起動していません',
  'settings.modeDaemonOfflineMeta': 'デーモンオフライン',
  'settings.modeDaemonInstalledMeta': '{count} インストール済み',
  'settings.modeApi': 'API プロバイダー',
  'settings.cloudCalloutTitle': 'OpenDesign Cloud を使う',
  'settings.cloudCalloutBody': 'クラウド版にサインインすると、チームスペース、共有プロジェクト、メンバー権限、監査ダッシュボードが利用できます。',
  'settings.cloudCalloutButton': 'ログイン / 登録',
  'settings.modeApiMeta': 'API プロバイダー',
  'settings.byokNoFileToolsNotice': 'BYOK ではプロジェクトファイルの読み取り、書き込み、編集はできません。コードを変更する場合は Local CLI を使用してください。',
  'settings.byokDraftNotice': '必須項目を入力すると、このプロバイダーを保存できます。現在の設定は引き続き有効です。',
  'settings.codeAgent': 'コードエージェント',
  'settings.codeAgentHint': 'PATH をスキャンして検出されます。生成に使用する CLI を選択してください。',
  'settings.rescan': '↻ 再スキャン',
  'settings.rescanTitle': 'PATH を再スキャン',
  'settings.rescanRunning': 'スキャン中...',
  'settings.rescanSuccess': 'スキャン完了。{count} 件が利用可能です。',
  'settings.designSystemRenameFailed': '名前の変更に失敗しました。デーモンを確認して再試行してください。',
  'settings.rescanFailed': 'スキャンに失敗しました。デーモンを確認して再試行してください。',
  'settings.test': 'テスト',
  'settings.testTitle': '接続を確認するため、ごく短いテストプロンプトを送信します',
  'settings.testRunning': '接続をテスト中…',
  'settings.byokReadyToTest': 'テスト準備完了',
  'settings.testCancel': 'キャンセル',
  'settings.testRetry': 'テストを再試行',
  'settings.required': '必須',
  'settings.testMissingFields': '接続をテストするには {fields} を入力してください。',
  'settings.testSuccessApi': '接続成功。{ms} ms で応答 — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} が {ms} ms で応答 — \'{sample}\'',
  'settings.testAuthFailed': '認証に失敗しました。API キーを確認してください。',
  'settings.testForbidden': 'アクセスが拒否されました。アカウント、リージョン、組織を確認してください。',
  'settings.testNotFoundModel': 'このエンドポイントにモデル \'{model}\' は見つかりません。',
  'settings.testInvalidModelId': 'モデル ID \'{model}\' は無効です。カスタム ID は英数字で始まり、空白を含めないでください。',
  'settings.testInvalidBaseUrl': 'Base URL が無効か到達できません。',
  'settings.testRateLimited': 'プロバイダがテストをレート制限しました。設定は有効に見えます。',
  'settings.testUpstream': 'プロバイダが {status} を返しました。少し時間をおいて再試行してください。',
  'settings.testTimeout': '{ms} ms 後にテストがタイムアウトしました。',
  'settings.testAgentMissing': '{agentName} がインストールされていないか、PATH にありません。',
  'settings.testAgentSpawn': '{agentName} を起動できませんでした: {detail}。',
  'settings.testUnknown': 'テストに失敗しました: {detail}',
  'settings.agentInstall.install': 'インストール',
  'settings.agentInstall.docs': 'ドキュメント',
  'settings.agentInstall.pathHint': 'npm または Homebrew で CLI をインストールしたのに未インストールのまま表示される場合は、OpenDesign daemon が引き継ぐ PATH にツールの bin ディレクトリが含まれていることを確認してください（macOS では Terminal と GUI アプリで PATH が異なる場合があります）。QUICKSTART.md（"Local agent CLI and PATH" セクション）を参照してください。',
  'settings.agentInstall.stepOpenLinks': '利用したいエージェントの「インストール」または「ドキュメント」を開きます。',
  'settings.agentInstall.stepAuth': 'OpenDesign に戻る前に、ベンダー CLI で認証（サインインまたは API 資格情報の追加）を行います。',
  'settings.agentInstall.stepRescan': 'このセクションで「再スキャン」をクリックします。',
  'settings.agentInstall.stepSelect': 'インストール済みとして表示されたらエージェントカードを選択します。',
  'settings.noAgentsDetected': 'エージェントが検出されませんでした。Claude Code、Codex、OpenCode、Cursor Agent、Qwen、または GitHub Copilot CLI のいずれかをインストールして、再スキャンをクリックしてください。',
  'settings.agentInstalledGroup': 'あなたの CLI（{count}）',
  'settings.agentInstallGroup': 'インストール可能（{count}）',
  'settings.agentAuthRequired': '認証が必要です',
  'settings.agentAuthUnknown': '認証状態は不明です',
  'settings.amrCloud': 'OpenDesign Cloud',
  'settings.amrAuthorize': '認証',
  'settings.amrBenefitOfficial': '公式',
  'settings.amrBenefitLowerPrice': '低コスト',
  'settings.amrBenefitManyModels': '多数のモデル',
  'settings.amrPromoBonus': '期間限定ボーナス: +100%',
  'settings.amrSignInToContinue': '続行するにはサインインしてください',
  'settings.amrSignIn': 'サインイン',
  'settings.amrSignedIn': 'サインイン済み',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh OpenDesign Cloud wallet balance',
  'settings.amrNotSignedIn': 'サインインしていません',
  'settings.amrSigningIn': 'サインイン中…',
  'settings.amrActivationHint': 'サインインページが開きませんか？下のボタンをタップして再度開いてください。',
  'settings.amrActivationBrowserFailedTitle': 'ログインページを開けません',
  'settings.amrActivationBrowserFailedDescription': 'ブラウザーを自動で開けませんでした。もう一度ログインをお試しください。',
  'settings.amrActivationOpen': 'サインインページを開く',
  'settings.amrCancelSignIn': 'サインインをキャンセル',
  'settings.onboardingActivationPrompt': 'ログインページが開きませんか？',
  'settings.onboardingActivationBrowserFailed': 'ブラウザを自動で開けませんでした。',
  'settings.onboardingActivationReopen': 'もう一度開く',
  'settings.amrAccountStatus': 'OpenDesign Cloud アカウントの状態',
  'settings.amrConsole': '管理',
  'settings.amrBalance': '利用枠',
  'settings.amrPlan': 'プラン',
  'settings.amrUpgrade': 'アップグレード',
  'settings.amrModelUpgradeHint': 'アップグレード後に利用',
  'settings.amrLoginErrorCompact': 'OpenDesign Cloud へのサインインに失敗しました。',
  'settings.advanced': '詳細設定',
  'settings.amrLogin': 'サインイン',
  'settings.amrLogout': 'サインアウト',
  'settings.amrLoggingIn': 'サインイン中…',
  'settings.amrLoggingOut': 'サインアウト中…',
  'settings.amrLoggedInAs': '{email} でサインイン中',
  'settings.amrLoggedInWithPlan': '{email} としてサインイン中 · {plan}',
  'settings.amrLoggedInPill': 'サインイン済み',
  'settings.amrNotLoggedIn': 'サインインしていません',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'プロバイダーをクイック入力',
  'settings.providerPreset': 'プロバイダープリセット',
  'settings.protocolGroupProtocols': 'プロトコル',
  'settings.protocolGroupGateways': 'ゲートウェイ',
  'settings.customProvider': 'カスタムプロバイダー',
  'settings.apiKey': 'APIキー',
  'settings.apiKeyGetLink': 'キーを取得 ↗',
  'settings.showKey': 'キーを表示',
  'settings.hideKey': 'キーを隠す',
  'settings.show': '表示',
  'settings.hide': '隠す',
  'settings.model': 'モデル',
  'settings.apiKeyInvalid': 'API key が無効です。',
  'settings.apiKeyCleaned': 'API key から余分な空白を削除しました。',
  'settings.modelsLoadedFromAccount': '✓ アカウントから {count} 個のモデルを読み込みました。',
  'settings.modelsLoadedCount': '✓ {count} 個のモデルを読み込みました。',
  'settings.modelSourceAccount': 'アカウントから',
  'settings.modelSourceSuggested': 'おすすめ',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': '低コスト',
  'modelCost.halfToOne': '中コスト',
  'modelCost.oneToFour': '高コスト',
  'modelCost.overFour': '最高コスト',
  'settings.fetchModels': 'モデルを取得',
  'settings.fetchModelsTitle': 'このプロバイダーから利用可能なモデルを取得',
  'settings.fetchModelsRunning': 'モデルを取得中…',
  'settings.fetchModelsMissingFields': 'モデルを取得するには {fields} を入力してください。',
  'settings.fetchModelsInvalidBaseUrl': 'モデルを取得するには有効な Base URL を入力してください。',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI はデプロイ名を使用するため、ここではモデルの検出を利用できません。',
  'settings.fetchModelsUnsupportedOllama': 'Ollama Cloud のモデル検出はまだ利用できません。モデルを選択するか入力してください。',
  'settings.fetchModelsSuccess': '{count} 件のモデルを取得しました。',
  'settings.fetchModelsEmpty': '互換性のあるテキストモデルが返されませんでした。',
  'settings.fetchModelsUnsupported': 'このプロトコルではモデルの検出を利用できません。',
  'settings.fetchModelsFailed': 'モデルを取得できませんでした: {detail}',
  'settings.suggestedModelsHint': 'これはこのプロトコル向けの推奨モデルです。プロバイダーによっては別のモデルをサポートしている場合があります。',
  'settings.baseUrl': 'ベース URL',
  'settings.baseUrlInvalid': '公開 http:// または https:// URL を使用してください。',
  'settings.baseUrlCustomize': 'URL をカスタマイズ',
  'settings.baseUrlDefaultHint': 'プロキシまたは互換ゲートウェイを使用する場合のみ変更してください。',
  'settings.azureBaseUrlPlaceholder': 'Azure エンドポイント URL を貼り付け',
  'settings.azureBaseUrlHint': 'Azure ポータル → 対象リソース → エンドポイント で確認できます。',
  'settings.azureDeploymentModel': 'デプロイ名',
  'settings.azureCustomDeploymentName': 'カスタムデプロイ名',
  'settings.azureDeploymentModelHint': 'Azure OpenAI では、このフィールドが /openai/deployments/<model> のデプロイ名として使われます。Azure で作成したデプロイ名を入力してください。',
  'settings.azureModelFetchHint': 'Azure リソースのデプロイ名を入力してください。Azure のデプロイは自動取得できません。',
  'settings.apiVersion': 'API バージョン',
  'settings.byokImageModel': '画像生成モデル',
  'settings.byokVideoModel': '動画生成モデル',
  'settings.byokVideoI2vHint': '画像から動画モデル:参照画像が必要です(指定しない場合はプロジェクト内の最新画像を自動使用)',
  'settings.byokSpeechModel': '音声生成モデル',
  'settings.byokSpeechVoice': '音声(ボイス)',
  'settings.byokModelDefaultOption': 'デフォルト',
  'settings.maxTokens': '最大トークン（任意）',
  'settings.maxTokensHint': '応答の最大長。空欄の場合はモデルのデフォルト値を使用します。',
  'settings.apiHint': 'このデバイスにローカル保存されます。',
  'settings.skipForNow': '今はスキップ',
  'settings.getStarted': '始める',
  'settings.envConfigure': 'モデルとプロバイダー',
  'settings.localCli': 'ローカル CLI',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'OpenDesign will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the OpenDesign profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'エージェント未選択',
  'settings.language': '言語',
  'settings.languageHint': 'インターフェースの言語を切り替えます。このブラウザに保存されます。',
  'settings.agentModelHead': 'モデル：',
  'settings.modelPicker': 'モデル',
  'settings.modelSourceLive': 'CLI から取得',
  'settings.modelUsesCliDefault': 'CLI デフォルト',
  'settings.modelSourceFallback': '組み込みリスト',
  'settings.reasoningPicker': '推論の強さ',
  'settings.serviceTierPicker': 'サービス階層',
  'settings.modelPickerHint': 'CLI が `models` コマンドを公開している場合に取得されます。「デフォルト」は CLI 自身の設定に委ね、「カスタム…」は CLI が受け付ける任意のモデル ID を入力できます。',
  'settings.modelPickerLiveHint': 'インストール済みの CLI からモデルを更新しました。デフォルトは引き続き CLI 設定を使用します。',
  'settings.modelPickerLiveCatalogOnlyHint': 'インストール済みの CLI からモデルを更新しました。',
  'settings.modelPickerFallbackHint': '組み込みのデフォルトを表示しています。再スキャンをクリックすると CLI から最新モデルを取得します。',
  'settings.cliEnvTitle': '詳細設定: プロキシとカスタムパス',
  'settings.cliEnvHint': '選択した CLI の環境を上書きするために使用します: API key、プロキシ base URL、カスタム home、標準以外の実行ファイルパス。base URL を設定しない場合、CLI は既定の endpoint を使用します。シークレットはローカルのアプリ設定内に保持され、選択した CLI のみが参照します。',
  'settings.cliEnvClaudeConfigDir': 'Claude Code 設定ディレクトリ',
  'settings.cliEnvClaudeBaseUrl': 'Claude プロキシの Base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'Codex ホーム',
  'settings.cliEnvCodexBin': 'Codex 実行ファイルのパス',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI プロキシの Base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': 'カスタム（下に入力）…',
  'settings.modelCustomLabel': 'カスタムモデル ID',
  'settings.modelCustomPlaceholder': '例: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'メディアプロバイダー',
  'settings.mediaProvidersHint': '画像・動画・音声生成のための API キー。ローカルに保存され、ローカルデーモンに同期されます。',
  'settings.mcpServerTitle': 'OpenDesign MCP',
  'settings.mcpServerHint': 'OpenDesign を MCP サーバーとしてコーディングエージェントに公開します。',
  'settings.externalMcpTitle': '外部 MCP',
  'settings.externalMcpHint': '外部サービス（Higgsfield、GitHub など）の MCP ツールを追加します。',
  'settings.mediaProviderApiKey': 'APIキー',
  'settings.mediaProviderBaseUrl': 'ベース URL',
  'settings.mediaProviderConfigured': '設定済み',
  'settings.mediaProviderUnset': '未設定',
  'settings.mediaProviderClear': 'クリア',
  'settings.mediaProviderClearConfirm': '保存された {name} の設定を削除しますか？{name} を使うには再度入力する必要があります。',
  'settings.mediaProviderPlaceholder': 'APIキーを貼り付け',
  'settings.mediaProviderBaseUrlPlaceholder': 'デフォルトのベース URL を上書き',
  'settings.mediaProviderReload': 'デーモンから再読み込み',
  'settings.mediaProviderReloadError': 'ローカルデーモンからメディアプロバイダー設定を再読み込みできませんでした。',
  'settings.mediaProviderReloadSuccess': 'ローカルデーモンからメディアプロバイダー設定を再読み込みしました。',
  'settings.mediaProviderLoadError': 'ローカルデーモンからメディアプロバイダー設定を読み込めませんでした。今のところブラウザーに保存された設定を使用します。',
  'settings.mediaProviderComingSoonHint': 'これらはロードマップで追跡しています。デーモンはまだクライアントを提供していないため、設定するものはありません。',
  'settings.privacy': 'プライバシー',
  'settings.privacyHint': 'OpenDesign チームと共有されるデータ',
  'settings.privacyConsentKicker': 'OpenDesign の改善にご協力ください',
  'settings.privacyConsentLead': '使用状況データを共有すると、OpenDesign が実際のワークフローでどう動いているかを理解し、体験に最も影響する部分を優先して改善できます。',
  'settings.privacyConsentFooter': 'これらはいつでも 設定 → プライバシー で変更できます。',
  'settings.privacyConsentShare': '共有',
  'settings.privacyConsentDecline': '共有しない',
  'settings.privacyConsentAccept': '了解しました',
  'settings.privacyConsentBannerFooter': 'データ共有はデフォルトで有効です。いつでも 設定 → プライバシー で無効にできます。',
  'settings.privacyConsentPolicyLink': 'プライバシーポリシーを読む',
  'settings.privacyMetrics': '匿名メトリクス',
  'settings.privacyMetricsHint': '実行回数、Token使用量、エラー率、所要時間などの基本的な使用指標。',
  'settings.privacyContent': '会話とツールのコンテンツ',
  'settings.privacyContentHint': 'シークレットなどの機密情報を削除したうえで、プロンプト、アシスタントの応答、ツールの入力/出力、品質レビューに必要なコンテキストを使用します。',
  'settings.privacyInstallationId': '匿名ID',
  'settings.privacyOptedOut': 'オプトアウト済み',
  'settings.privacyDataDeletion': 'データを削除',
  'settings.privacyDataDeletionHint': '匿名IDをローテーションし、送信を停止します。既存のトレースは当社の保持ポリシーに従って期限切れになります。',
  'settings.about': '概要',
  'settings.aboutHint': 'バージョンと実行環境の詳細',
  'settings.appVersion': 'バージョン',
  'settings.appChannel': 'チャンネル',
  'settings.appRuntime': '実行環境',
  'settings.appPlatform': 'プラットフォーム',
  'settings.appArchitecture': 'アーキテクチャ',
  'settings.runtimePackaged': 'パッケージ版アプリ',
  'settings.runtimeDevelopment': '開発環境',
  'settings.versionUnavailable': 'daemon がオフラインの間はバージョン詳細を取得できません。',
  "settings.allowSilentUpdates": "今後のアプリ内更新を自動インストールする",
  "settings.allowSilentUpdatesDesc": "アプリ内更新の準備ができたら、次回起動時に自動でインストールします。現在のセッションはすぐには更新しません。インストーラー更新は引き続き確認します。",
  'settings.installLatest': '最新版をインストール',
  'settings.alreadyLatest': '最新バージョンです',
  'settings.updateCheck': '更新を確認',
  'settings.updateNow': '今すぐ更新',
  'settings.updateRecheck': '再確認',
  'settings.updateRetry': '再試行',
  'settings.updateViewReleases': 'リリースノート',
  'settings.updateActionFailed': '更新操作を完了できませんでした。',
  'settings.updateQuitFailed': 'インストーラは開きましたが、OpenDesign を自動終了できませんでした。',
  'settings.updateStatusNotChecked': 'まだ確認していません',
  'settings.updateStatusDevelopment': '開発ビルドはアプリ内更新に対応していません。',
  'settings.updateStatusUnsupported': 'この環境はアプリ内更新に対応していません。',
  'settings.updateStatusChecking': '更新を確認中...',
  'settings.updateStatusUpToDate': 'すでに最新バージョンです。',
  'settings.updateStatusAvailable': 'バージョン {version} が見つかりました。ダウンロードを準備中です。',
  'settings.updateStatusAvailableUnknown': '新しいバージョンが見つかりました。ダウンロードを準備中です。',
  'settings.updateStatusDownloading': '更新をダウンロード中...',
  'settings.updateStatusDownloadingPercent': '更新をダウンロード中 {percent}%。',
  'settings.updateStatusReady': 'バージョン {version} をインストールできます。',
  'settings.updateStatusReadyUnknown': '更新をインストールできます。',
  'settings.updateStatusInstalling': '更新をインストール中...',
  'settings.updateStatusFailed': '確認に失敗しました。再試行してください。',
  'settings.mcpTitle': 'MCPサーバー',
  'settings.mcpHint': 'コーディング Agent（Cursor、Claude Code、VS Code など）が OpenDesign プロジェクトを直接読み取れるようにします。',
  'settings.mcpDaemonError': 'インストールパスを解決するためのローカルデーモンに接続できませんでした（{error}）。OpenDesignが実行中であることを確認してから、このパネルを再度開いてください。',
  'settings.mcpBuildDaemon': '先にデーモンをビルドしてください。',
  'settings.mcpNodeMissing': 'Nodeバイナリが見つかりません。',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js が見つかりません。`pnpm --filter @open-design/daemon build` を実行して更新してください。',
  'settings.mcpMethodCli': 'CLIコマンド',
  'settings.mcpInstructionCli': 'ターミナルでこれを実行してください。',
  'settings.mcpMethodToml': 'TOML設定',
  'settings.mcpInstructionCodex': 'このテーブルを {path} に追記してください。同じ設定がCodex CLIとCodex IDE拡張機能で共有されます。',
  'settings.mcpMethodOneClick': 'ワンクリックインストール',
  'settings.mcpInstructionCursor': '「Install in Cursor」をクリックして承認ダイアログ付きでインストールするか、このJSONを {path} にマージしてください。',
  'settings.mcpDeeplinkInstallCursor': 'Cursor にインストール',
  'settings.mcpMethodJson': 'JSON設定',
  'settings.mcpInstructionKiro': '{path} を開き、このJSONをマージしてください。ワークスペースレベルの設定には .kiro/settings/mcp.json を使用します。',
  'settings.mcpInstructionCopilot': 'コマンドパレット（{shortcut}）を開き、「MCP: Open User Configuration」を実行して、このJSONをマージしてください。ツールを表示するには、Copilot ChatがAgentモードである必要があります。',
  'settings.mcpInstructionAntigravity': 'Antigravity の場合：Agent パネルの「...」メニュー → MCP Servers → Manage MCP Servers → View raw config。この JSON をマージしてください。',
  'settings.mcpInstructionZed': 'Zedの設定（{shortcut}）を開き、これをトップレベルのオブジェクトにマージしてください。Zedは「mcpServers」ではなく「context_servers」を使用します。',
  'settings.mcpInstructionWindsurf': '{path} を開く（または Cascade の MCPs アイコン → Configure を使用）してマージしてください：',
  'settings.mcpCopyAria': 'MCP設定スニペットをコピー',
  'settings.mcpResolvingFailed': '# パスの解決に失敗しました。上記のエラーを参照してください',
  'settings.mcpLoadingPaths': '# ローカルデーモンからインストールパスを読み込み中…',
  'settings.mcpCopied': 'コピーしました',
  'settings.mcpCopy': 'コピー',
  'settings.mcpCursorApproval': 'Cursorは設定を書き込む前に承認ダイアログを表示します。',
  'settings.mcpCodexOneClickInstall': 'Codex にインストール',
  'settings.mcpCodexOneClickUninstall': 'Codexから削除',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI が PATH 上に見つかりません — Codex をインストールするか、スニペットを手動で貼り付けてください。',
  'settings.mcpCodexInstallSuccess': 'インストールしました。新しいサーバーを読み込むにはCodexを再起動してください。',
  'settings.mcpCodexUninstallSuccess': 'Codexから削除しました。',
  'settings.mcpCodexBusy': '処理中…',
  'settings.mcpCodexInstallError': '操作に失敗しました: {error}',
  'settings.mcpRestartNote': '新しいサーバーを認識させるには、クライアントを再起動してください。',
  'settings.mcpRestartDetail': 'ほとんどのエディタは起動時にのみMCPサーバーを読み込みます。Cursor / VS Code / Antigravity / Windsurf では、完全な再起動の代わりにコマンドパレットから `Developer: Reload Window` を実行できます。ZedとClaude Codeは終了して再度開く必要があります。',
  'settings.mcpCapabilitiesTitle': 'Agentでできること',
  'settings.mcpCapabilityRead': 'プロジェクト内の任意のファイル（HTML、JSX、CSS、JSON、SVG、Markdown）を読み取り・検索する。',
  'settings.mcpCapabilityPull': 'デザインバンドルを1回の呼び出しで取得する: エントリファイルに加えて、参照されているすべてのCSS変数、コンポーネント、フォント。',
  'settings.mcpCapabilityDefault': 'OpenDesignで開いているプロジェクトとファイルをデフォルトにするため、どのデザインかを言い直すことなく「これを私のアプリで作って」と言えます。',
  'settings.mcpRunningNote': 'MCPツールの呼び出しを成功させるには、OpenDesignが実行中である必要があります。OpenDesignを開く前にコーディングAgentを起動した場合は、ライブデーモンに接続できるようAgentを再起動してください。',
  'entry.tabDesigns': 'デザイン',
  'entry.tabTemplates': 'テンプレート',
  'entry.tabDesignSystems': 'デザインシステム',
  'entry.tabConnectors': 'コネクタ',
  'entry.openSettingsTitle': '設定',
  'entry.openSettingsAria': '設定を開く',
  'entry.discordLabel': 'Discord に参加',
  'entry.discordAria': 'Discord に参加して Credit を受け取る',
  'entry.discordAriaWithOnline': 'OpenDesign の Discord に参加 - {online}',
  'entry.discordOnlineLabel': '{count} 人がオンライン',
  'entry.xAria': '@OpenDesignHQ をフォローして最新情報をチェック',
  'entry.mailAria': 'ご質問はメールでどうぞ',
  'entry.accountSettings': '設定',
  'chat.collapsePane': '会話パネルを折りたたむ',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'X で @OpenDesignHQ をフォロー',
  'entry.followThreadsLabel': 'Follow OpenDesign on Threads',
  'entry.youtubeLabel': 'OpenDesign on YouTube',
  'entry.followInstagramLabel': 'Instagram で @opendesign.ai をフォロー',
  'entry.followLinkedinLabel': 'LinkedIn で OpenDesign をフォロー',
  'entry.followXiaohongshuLabel': 'Xiaohongshu で OpenDesign をフォロー',
  'entry.resizeAria': 'サイドバーをリサイズ',
  'entry.loadingWorkspace': 'ワークスペースを読み込み中…',
  'entry.useEverywhereTitle': 'どこでも使う',
  'entry.useEverywhereAria': '「どこでも使う」ガイドを開く（CLI、MCP、HTTP、Skills）',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.invite': 'メンバーを招待',
  'workspaceSwitcher.createTeam': '新しいチーム',
  "workspaceSwitcher.draftsTooltip": "すべてのプロジェクト",
  "workspaceSwitcher.allProjectsTooltip": "チームプロジェクト",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingTierPlus": "Plus",
  "entry.billingTierMax": "Max",
  "entry.billingTierGo": "Go",
  "entry.billingFamilyCreator": "クリエイター会員",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "アップグレード",
  "entry.creditsManage": "管理",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "利用枠",
  "entry.creditsUsage": "使用状況を表示",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "テーマを切り替え",
  "entry.accountSwitchLanguage": "言語を切り替え",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "ヘルプを見る",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountBilling": "請求",
  "entry.accountAddAccount": "アカウントを追加",
  "entry.accountSignOut": "ログアウト",
  "signOut.confirmTitle": "ログアウト",
  "signOut.confirmMessage": "ログアウトしてもよろしいですか？",
  "signOut.confirmAction": "ログアウト",
  "entry.navRecents": "ホーム",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.projectsLoadFailed": "プロジェクトを読み込めませんでした。もう一度お試しください。",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace チーム版 — チームのニーズをお聞かせください',
  'entry.workspaceTeamsAria': 'Workspace チーム版のページを開く',
  'entry.navExpand': 'サイドバーを展開',
  'entry.navCollapse': 'サイドバーを折りたたむ',
  'entry.navNewProject': '新規プロジェクト',
  'entry.navHome': 'ホーム',
  'entry.navProjects': 'プロジェクト',
  'entry.navTasks': 'オートメーション',
  'entry.navPlugins': 'プラグイン',
  'entry.navDesignSystems': 'デザインシステム',
  'entry.navBrands': 'ブランドキット',
  'entry.navIntegrations': 'インテグレーション',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'すべてのプロジェクト',
  'entry.navAllProjects': 'チームプロジェクト',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "OpenDesign Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'Open Design にサインインしていません\nプロジェクトを表示して会話を続けるには、ログインしてください。',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'ローカル接続が切断されました\nこのコンピューター上の Open Design サービスに一時的に接続できません。クライアントを再起動してください。',
  'home.createTimedOut': 'プロジェクトの準備がタイムアウトし、開始できませんでした。もう一度送信してください。',
  'home.amrGateUnavailable': 'OpenDesign Cloud の残高を確認できませんでした。もう一度送信してください。',
  'home.bundledScenarioMissing': 'Bundled scenario "{scenarioId}" is not installed. Reinstall the daemon to restore the default plugin set.',
  "entry.cloudCalloutBody": "サインインして OpenDesign Cloud を利用し、クラウドでコラボレーションしましょう",
  "entry.cloudCreditsTitle": "登録で無料クレジット",
  "entry.cloudCreditsBody": "OpenDesign アカウントを新規登録すると無料クレジットを受け取れ、最先端のモデルでデザイン制作ができます。",
  "entry.cloudCreditsCta": "登録 / ログイン",
  "entry.localAccountName": "ローカルモード",
  "entry.cloudCalloutDismissAria": "OpenDesign Cloud の案内を閉じる",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'OpenDesign updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.archive': 'アーカイブ',
  'messageCenter.unarchive': '受信箱に戻す',
  'messageCenter.archivedTitle': 'アーカイブ済み',
  'messageCenter.emptyArchivedTitle': 'アーカイブはありません',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'goPlanSunset.closeAria': 'お知らせを閉じる',
  'goPlanSunset.title': 'Go サブスクリプション販売終了のお知らせ',
  'goPlanSunset.subtitle': 'OpenDesign ユーザーの皆さまへ：OpenDesign Go の提供開始以来、多くの関心とご意見をいただきました。現在の OpenDesign には、利用枠のルールや製品体験などに不十分な点があることを認識しており、心よりお詫び申し上げます。',
  'goPlanSunset.decisionsAria': 'お知らせの決定事項',
  'goPlanSunset.decisionsIntro': '皆さまに最良のデザイン体験を提供するため、以下のとおり決定しました：',
  'goPlanSunset.decisionStopSales': 'Go の新規サブスクリプション販売を本日より停止します',
  'goPlanSunset.decisionRefund': '8月31日までに元のお支払い方法へ全額返金します。返金後は特典が終了します（着金時期は決済方法によって異なります）',
  'goPlanSunset.decisionUnaffected': 'Go 以外のサブスクリプションをご利用の方への影響はありません',
  'goPlanSunset.closing': 'ご理解とご支援、そして率直なご意見をお寄せくださった皆さまに感謝いたします。これからも、すべての個人とチームが誇れるデザインを届けられるよう、よりスマートなデザイン提供に注力してまいります。',
  'goPlanSunset.dismissError': '確認できませんでした。もう一度お試しください。',
  'goPlanSunset.viewSubscriptions': 'ほかのサブスクリプションを見る',
  'goPlanSunset.confirming': '確認中…',
  'goPlanSunset.acknowledge': '確認しました',
  'workspaceTabs.project': 'プロジェクト',
  'workspaceTabs.pluginDetails': 'プラグインの詳細',
  'workspaceTabs.marketplace': 'マーケットプレイス',
  'homeHero.title': '{word}をつくろう',
  'homeHero.titleWords': 'プロトタイプ,スライド,ドキュメント',
  'homeHero.subtitle': '良い作品は、ここから始まる',
  'homeHero.startWithTemplate': 'テンプレートから始める…',
  'homeHero.startBlankProject': '空のプロジェクトを作成',
  'homeHero.templatePicker.label': '作成タイプ',
  'homeHero.templatePicker.searchPlaceholder': 'テンプレートを検索',
  'homeHero.templatePicker.projectTypes': 'プロジェクトタイプ',
  'homeHero.subtitlePrefix': 'ソースアベイラブルな Claude Design 代替。',
  'homeHero.placeholder': '生成したい内容を記述してください…',
  'homeHero.placeholderActive': 'サンプルクエリを編集するか、独自に記述してください…',
  'homeHero.carousel.hint': 'ファイルを添付、デザインシステムをリンク、または作りたいものを説明してください',
  'homeHero.carousel.onePageBrief': '1ページのプロジェクト概要を作成する',
  'homeHero.carousel.notesToDeck': 'メモをプレゼン資料にする',
  'homeHero.carousel.signupFlow': 'サインアップフローを作る',
  'homeHero.carousel.improveBrief': '既存のプロジェクト概要を改善する',
  'homeHero.carousel.loadingAnimation': 'ローディングアニメーションを作成する',
  'homeHero.carousel.teamUpdateSlides': 'チーム報告用のスライドをデザインする',
  'homeHero.carousel.ordersDashboard': '注文管理ダッシュボードのプロトタイプを作る',
  'homeHero.carousel.productDetail': '商品詳細ページをレイアウトする',
  'homeHero.carousel.caseStudy': 'ケーススタディの構成を考える',
  'homeHero.carousel.landingIntro': 'ランディングページの短い導入をデザインする',
  'homeHero.carousel.pitchDeck': '新製品のピッチデックを作る',
  'homeHero.carousel.appIdea': 'アプリのアイデアを説明する',
  'homeHero.carousel.landingLayout': 'ランディングページのレイアウトを描く',
  'homeHero.skills': 'スキル',
  'homeHero.addMenu': 'コンテキストを追加',
  'homeHero.addPlugin': 'プラグインを追加',
  'homeHero.addConnectors': 'コネクタを追加',
  'homeHero.addMcp': 'MCP サーバーを追加',
  'homeHero.noPlugins': 'インストール済みのプラグインがありません',
  'homeHero.noMcp': 'MCP サーバーがありません',
  'homeHero.noConnectors': '接続済みのコネクタがありません',
  'homeHero.applying': '適用中…',
  'homeHero.pluginTitle': 'プラグイン：{title}',
  'homeHero.pluginPrefix': 'プラグイン：{title}',
  'homeHero.skillPrefix': 'スキル：{title}',
  'homeHero.removePlugin': 'プラグインを削除',
  'homeHero.removePluginAria': 'プラグイン {title} を削除',
  'homeHero.clearActivePlugin': '有効なプラグインをクリア',
  'homeHero.clearActiveSkill': '有効なスキルをクリア',
  'homeHero.contextItemsResolved': '{n} 件のコンテキスト項目を解決しました',
  'homeHero.attachmentsScrollPrev': '添付ファイルを左へスクロール',
  'homeHero.attachmentsScrollNext': '添付ファイルを右へスクロール',
  'homeHero.removeFile': 'ファイルを削除',
  'homeHero.contextSearchResults': 'コンテキスト検索結果',
  'homeHero.contextSurfaces': 'コンテキストサーフェス',
  'homeHero.loadingContext': 'コンテキストを読み込み中…',
  'homeHero.noResults': '「{query}」に該当する結果はありません。',
  'homeHero.searchPrompt': 'ファイル、プラグイン、スキル、MCP サーバー、コネクターを検索。',
  'homeHero.parameters': '{n} 個のパラメーター',
  'homeHero.details': '詳細',
  'homeHero.toRun': 'で実行',
  'homeHero.forNewLine': 'で改行',
  'homeHero.run': '実行',
  'homeHero.typeSomethingToRun': '実行する内容を入力してください',
  'homeHero.promptExamples': '例',
  'homeHero.footer.designSystem': 'スタイル',
  'homeHero.footer.autoDesignSystem': '自動',
  'homeHero.footer.autoDesignSystemSummary': '現在のプロンプトに最適なデザインシステムと視覚スタイルを自動で選びます。',
  'homeHero.footer.ratio': '比率',
  'homeHero.footer.duration': '長さ',
  'homeHero.footer.resolution': '解像度',
  'homeHero.footer.speakerNotes': 'ノート',
  'homeHero.footer.noSpeakerNotes': 'ノートなし',
  'homeHero.footer.availableCount': '{n} 件利用可能',
  'homeHero.footer.noMatches': '一致なし',
  'homeHero.moreShortcuts': 'その他',
  'homeHero.railAria': 'プロジェクトカテゴリーまたはスターターショートカットを選択',
  'homeHero.subTypeAria': 'サブタイプを選択',
  'homeHero.subTypeMore': 'その他',
  'homeHero.confirmReplaceTitle': '現在のプロンプトを置き換えますか？',
  'homeHero.confirmReplaceBody': '{title} を使用すると、入力欄の現在のテキストが置き換えられます。',
  'homeHero.confirmReplace': '置き換える',
  'homeHero.chip.prototype': 'プロトタイプ',
  'homeHero.chip.webClone': 'ウェブサイト複製',
  'homeHero.chip.liveArtifact': 'ライブアーティファクト',
  'homeHero.chip.deck': 'スライドデッキ',
  'homeHero.chip.image': '画像',
  'homeHero.chip.video': '動画',
  "homeHero.chip.motionDesign": "モーションデザイン",
  "homeHero.chip.motionDesignDesc": "モーショングラフィックス、アート、製品紹介動画",
  "homeHero.chip.motionDesignHint": "アイデア、ビジュアルスタイル、長さを指定してアニメーション動画を作成します。",
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'シェーダー・3D・ジェネラティブ GPU ビジュアル',
  'homeHero.chip.worker': 'Worker ビジュアライザー',
  'homeHero.chip.workerDesc': 'メインスレッド外のシミュレーション・パーティクル・データ可視化',
  'homeHero.chip.audio': '音声',
  'homeHero.chip.createBrandKit': 'ブランドキットを作成',
  'homeHero.chip.createPlugin': 'プラグインを作成',
  'homeHero.chip.figma': 'Figma から',
  'homeHero.chip.folder': 'フォルダーから',
  'homeHero.chip.template': 'テンプレートから',
  'homeHero.chip.liveArtifactHint': 'ライブでプレビューできるインタラクティブな HTML/CSS/JS アーティファクトを構築します。',
  'homeHero.chip.hyperframesHint': 'HTML ベースのモーションを作成：キャプション、オーディオリアクティブなビジュアル、シーン遷移。',
  'homeHero.chip.createBrandKitHint': 'ウェブサイトからブランドキットを抽出し、任意のチャットで適用します。',
  'homeHero.chip.createPluginHint': '再利用可能な OpenDesign プラグインを作成し、マイプラグインに追加します。',
  'homeHero.chip.figmaHint': 'Figma フレームを有効なデザインシステムに移行します。',
  'homeHero.chip.folderHint': '既存のローカルフォルダーをインポートして編集を続けます。',
  'homeHero.chip.templateHint': '付属のテンプレートから開始します。',
  'homeHero.chip.wireframe': 'ワイヤーフレーム',
  'homeHero.chip.mobile': 'モバイルアプリ',
  'homeHero.chip.document': 'ドキュメント',
  'homeHero.chip.prototypeDesc': 'インタラクティブなアプリモックアップ',
  'homeHero.chip.webCloneDesc': 'ソース重視のサイト再現',
  'homeHero.chip.wireframeDesc': 'ローファイの画面とフロー',
  'homeHero.chip.mobileDesc': 'iOS・Android の画面',
  'homeHero.chip.deckDesc': 'プレゼンとピッチ資料',
  'homeHero.chip.documentDesc': '履歴書・レポート・PDF',
  'homeHero.chip.imageDesc': 'ポスター・グラフィック・アート',
  'homeHero.chip.videoDesc': 'クリップ・リール・プロモ',
  'homeHero.chip.audioDesc': 'ナレーション・音楽・効果音',
  'homeHero.chip.hyperframesDesc': 'モーショングラフィックスとループ',
  'homeHero.chip.liveArtifactDesc': 'データ連動のライブダッシュボード',
  'homeHero.chip.createBrandKitDesc': 'ブランドのデザインシステムを抽出',
  'homeHero.chip.prototypeNext': 'クリック可能な高忠実度のウェブプロトタイプを作り、ターンごとに磨き上げるチャットを開きます。',
  'homeHero.chip.webCloneNext': '対象 URL を尋ね、サイトを再構築してクローンを検証するチャットを開きます。',
  'homeHero.chip.wireframeNext': 'まず構造を検証するために、ローファイの画面とフローを描くチャットを開きます。',
  'homeHero.chip.mobileNext': 'iOS と Android 向けのモバイル画面をレイアウトするチャットを開きます。',
  'homeHero.chip.deckNext': '発表やエクスポートができるスライドを作るチャットを開きます。',
  'homeHero.chip.documentNext': '履歴書・レポート・PDF など、整ったドキュメントを作成するチャットを開きます。',
  'homeHero.chip.imageNext': 'ブランドに沿った画像を生成し、繰り返し調整できるチャットを開きます。',
  'homeHero.chip.videoNext': '短い動画を制作し、磨き上げられるチャットを開きます。',
  'homeHero.chip.audioNext': 'ナレーション、音楽、効果音を作成するチャットを開きます。',
  'homeHero.chip.webClonePromptSeed': '複製したいサイトの URL：',
  'homeWorkingDir.trigger': '作業ディレクトリを選択',
  'homeWorkingDir.triggerShort': '作業ディレクトリ',
  'homeWorkingDir.pick': 'フォルダを選択',
  'homeWorkingDir.replace': '作業ディレクトリを変更',
  'homeWorkingDir.recent': '最近使ったフォルダ',
  'homeWorkingDir.clear': '作業ディレクトリを解除',
  'homeWorkingDir.hint': 'エージェントにこのローカルフォルダの読み取りを許可します（Design Files にはインポートされません）',
  'homeWorkingDir.missing': 'この作業フォルダはもう存在しません — 別のフォルダを選んでください',
  'homeWorkingDir.applyFailed': '作業ディレクトリを設定できませんでした — フォルダが存在しない可能性があります',
  'workingDirPicker.title': 'フォルダ',
  'workingDirPicker.homeTitle': 'ローカルストレージに保存 — クリックしてフォルダを選択',
  'workingDirPicker.processing': '処理中…',
  'workingDirPicker.select': 'ローカルストレージ',
  'workingDirPicker.clearAria': '作業ディレクトリをクリア',
  'workingDirPicker.replaceFailed': '作業ディレクトリを置き換えられませんでした',
  'workingDirPicker.unavailable': 'このビルドではフォルダ選択を利用できません。フォルダを選択するにはデスクトップアプリを実行してください。',
  'workingDirPicker.openUnavailable': 'フォルダを表示するには、このプロジェクトをデスクトップアプリで開いてください。',
  'workingDirPicker.openFailed': 'このフォルダを表示できませんでした',
  'workingDirPicker.showInFileManager': 'ファイルマネージャーで表示',
  'workingDirPicker.replace': 'フォルダを選択…',
  'workingDirPicker.recent': '最近使用したディレクトリ',
  'workingDirPicker.defaultLabel': 'ローカルストレージ',
  'handoff.toTarget': '{target}に引き継ぐ',
  'handoff.openInTarget': '{target}で開く',
  'handoff.openAction': '開く',
  'handoff.menuTitle': 'どのエディタで開きますか？',
  'handoff.action': '引き継ぐ',
  'handoff.fallbackTitle': '$PATH上にエディタが見つかりません - {target}で開きます',
  'handoff.chooseTargetAria': '引き継ぎ先を選択',
  'handoff.optionsAria': '引き継ぎオプション',
  'handoff.editorSection': 'エディタで開く',
  'handoff.cliSection': 'CLI用にコピー',
  'handoff.clickOpen': 'クリックして開く',
  'handoff.framework': 'コードフレームワーク',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'バニラJavaScript、HTML、CSS',
  'handoff.amrWebsite': 'OpenDesign CloudのWebサイトを開く',
  'handoff.copyPrompt': 'プロンプトをコピー',
  'handoff.copyPromptForTarget': '{target}用のプロンプトをコピー',
  'handoff.copied': 'コピーしました',
  'handoff.projectPathUnavailable': 'プロジェクトパスを読み込み中です。しばらくしてからもう一度お試しください。',
  'handoff.copyFailed': 'クリップボードへの書き込みがブロックされました。しばらくしてからもう一度お試しください。',
  'handoff.promptIntro': 'このローカルのOpenDesignプロジェクトフォルダから続行してください:',
  'handoff.promptTarget': '引き継ぎ先',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': '{cli}で作業を引き継ぎます。以下を実行してください:',
  'handoff.promptReadFiles': 'まずこのディレクトリに入るか読み込んでください。DESIGN.md、README、既存のHTML/CSS/JS、アセット、存在する場合はpackage.jsonを優先してください。',
  'handoff.promptKeepDesign': '現在のビジュアルデザイン、レイアウト、インタラクション、アセットを維持してください。計画の段階で止めないでください。',
  'handoff.promptProduceCode': '実際に実行可能な{framework}コードを生成または変更してください。プロジェクトに既により明確なスタックがある場合は、その矛盾を指摘し、結果が実行可能な状態を保ってください。',
  'handoff.promptVerify': '最後に、実行、プレビュー、検証のコマンドを教えてください。',
  'handoff.promptCommandHint': 'プロジェクトディレクトリから開始するには、以下を使用してください:',
  'handoff.promptProject': 'プロジェクト',
  'handoff.promptProjectId': 'プロジェクトID',
  'handoff.notInstalled': '未インストール',
  'handoff.notDetectedTitle': '{target} - $PATH上で検出されませんでした',
  'designSystemPicker.select': 'デザインシステムを選択',
  'designSystemPicker.loading': 'デザインシステムを読み込み中…',
  'designSystemPicker.searchPlaceholder': 'デザインシステムを検索（タイトル / カテゴリ / 概要）',
  'designSystemPicker.searchCompactPlaceholder': 'デザインシステムを検索',
  'designSystemPicker.noneTitle': 'デザインシステムなし',
  'designSystemPicker.noneSummary': 'モデルに自由に選ばせる',
  'designSystemPicker.empty': '一致するデザインシステムがありません',
  'designSystemPicker.openPreview': 'プレビューを開く',
  'designSystemPicker.loadingPreview': 'プレビューを読み込み中…',
  'designSystemPicker.noPreview': 'プレビューページがありません。完全なプレビューを表示するには Design Systems を開いてください。',
  'designSystemPicker.previewHint': 'デザインシステムにカーソルを合わせるとプレビューが表示されます',
  'designSystemPicker.fullscreenAria': '{title} の全画面プレビュー',
  'designSystemPicker.closeFullscreen': '全画面プレビューを閉じる',
  'designSystemPicker.closeEsc': '閉じる（Esc）',
  'designSystemPicker.previewFrameTitle': '{title} のプレビュー',
  'designSystemPicker.fullscreenFrameTitle': '{title} の全画面プレビュー',
  'recentProjects.title': '最近のプロジェクト',
  'recentProjects.viewAll': 'すべて表示',
  'recentProjects.empty': 'プロジェクトはまだありません — プロンプトを入力して開始してください。',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindDocument': 'Document',
  'recentProjects.kindImage': '画像',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.collectionRecent': 'Recently viewed',
  'recentProjects.collectionPersonalProjects': '個人プロジェクト',
  'recentProjects.collectionTeamProjects': 'チームプロジェクト',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.duplicateInProgress': '複製中…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'フィルターをクリア',
  'pluginsHome.title': 'コミュニティ',
  'pluginsHome.subtitle': 'このランタイムに同梱された、すぐに使える OpenDesign ワークフロー。1つ選んでスタータープロンプトを読み込むか、レジストリでさらに探せます。',
  'pluginsHome.browseRegistry': 'レジストリを見る',
  'pluginsHome.count': '{total}件中{filtered}件',
  'pluginsHome.loadingCatalog': 'カタログを読み込み中…',
  'pluginsHome.emptyCatalog': 'カタログは空です。バンドルされたプラグインは OpenDesign に同梱されており、ここに自動的に表示されるはずです — 解消しない場合はデーモンを再起動してみてください。',
  'pluginsHome.emptyFiltered': '現在のフィルターに一致するプラグインはありません。',
  'pluginsHome.clearFilters': 'フィルターをクリア',
  'pluginsHome.modeAria': 'プラグインモード',
  'pluginsHome.featured': '保存済み',
  'pluginsHome.totalInCatalog': 'カタログに{n}件',
  'pluginsHome.categoryFilterAria': 'カテゴリフィルター',
  'pluginsHome.subcategoryFilterAria': '{label}のサブカテゴリフィルター',
  'pluginsHome.allCategory': 'すべての{label}',
  'pluginsHome.searchPlaceholder': 'プラグインを検索…',
  'pluginsHome.searchAria': 'プラグインを検索',
  'pluginsHome.clearSearch': '検索をクリア',
  'pluginsHome.sortAria': '並び順',
  'pluginsHome.sortHot': '人気',
  'pluginsHome.sortNewest': '新着',
  'pluginsHome.facet.import': 'インポート',
  'pluginsHome.facet.create': '作成',
  'pluginsHome.facet.export': 'エクスポート',
  'pluginsHome.facet.share': '共有',
  'pluginsHome.facet.deploy': 'デプロイ',
  'pluginsHome.facet.refine': '調整',
  'pluginsHome.facet.extend': '拡張',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'コード / フォルダ',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'スクリーンショット',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'スライド',
  'pluginsHome.facet.publicLink': '公開リンク',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'ダッシュボード',
  'pluginsHome.subfacet.app-prototypes': 'アプリ',
  'pluginsHome.subfacet.landing-marketing': 'LP / マーケ',
  'pluginsHome.subfacet.developer-tools': '開発者ツール',
  'pluginsHome.subfacet.docs-reports': 'ドキュメント / レポート',
  'pluginsHome.subfacet.brand-design': 'ブランド / デザイン',
  'pluginsHome.subfacet.pitch-business': 'ピッチ / ビジネス',
  'pluginsHome.subfacet.course-training': '講座 / 研修',
  'pluginsHome.subfacet.reports-briefings': 'レポート / ブリーフ',
  'pluginsHome.subfacet.product-sales': 'プロダクト / 営業',
  'pluginsHome.subfacet.engineering-talks': '技術トーク',
  'pluginsHome.subfacet.creative-decks': 'クリエイティブ資料',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / モックアップ',
  'pluginsHome.subfacet.brand-visuals': 'ブランド / ロゴ',
  'pluginsHome.subfacet.storyboards-motion-refs': '絵コンテ',
  'pluginsHome.subfacet.social-content': 'SNS / コンテンツ',
  'pluginsHome.subfacet.avatar-portrait': 'アバター / ポートレート',
  'pluginsHome.subfacet.illustration-style': 'イラスト / スタイル',
  'pluginsHome.subfacet.motion-effects': 'モーション / エフェクト',
  'pluginsHome.subfacet.social-short-form': 'SNS / ショート動画',
  'pluginsHome.subfacet.marketing-product': 'マーケ / プロダクト',
  'pluginsHome.subfacet.data-explainers': 'データ / 解説',
  'pluginsHome.subfacet.cinematic-story': 'シネマティック / ストーリー',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'インストール済みのワークフローを閲覧し、レジストリのエントリを探索し、ソースを管理して、チーム配布用のプラグインを準備します。',
  'pluginsView.importPlugin': 'プラグインをインポート',
  'pluginsView.agentContext': 'Agent コンテキスト',
  'pluginsView.summaryAria': 'プラグインの概要',
  'pluginsView.areasAria': 'プラグインエリア',
  'pluginsView.loading': 'プラグインを読み込み中…',
  'pluginsView.tab.installed': 'インストール済み',
  'pluginsView.tab.available': '利用可能',
  'pluginsView.tab.sources': 'ソース',
  'pluginsView.tab.team': 'チーム',
  'pluginsView.tabHint.installed': '自分のプラグイン',
  'pluginsView.tabHint.available': 'ソースから',
  'pluginsView.tabHint.sources': 'カタログ',
  'pluginsView.tabHint.team': 'エンタープライズ',
  'pluginsView.installedTitle': 'インストール済みプラグイン',
  'pluginsView.installedSubtitle': 'インポートした、またはマーケットプレイスのソースからインストールしたプラグイン。',
  'pluginsView.installedEmpty': 'インストール済みのユーザープラグインはまだありません。作成 / インポートを使用するか、利用可能なエントリをインストールしてください。',
  'pluginsView.availableTitle': 'ソースから利用可能',
  'pluginsView.availableSubtitle': '設定済みのマーケットプレイスから検出されたカタログエントリ。',
  'pluginsView.availableFiltersAria': '利用可能なプラグインのフィルター',
  'pluginsView.searchAvailableAria': '利用可能なプラグインを検索',
  'pluginsView.searchAvailablePlaceholder': '利用可能なプラグインを検索',
  'pluginsView.clearAvailableSearch': '利用可能なプラグインの検索をクリア',
  'pluginsView.source': 'ソース',
  'pluginsView.availableEmptyInstalled': '利用可能なエントリはまだありません。インストール済みのカタログエントリは「利用可能」から削除されます。再び利用可能にするには、アンインストールしてください。',
  'pluginsView.availableEmptyFiltered': 'フィルターに一致する利用可能なエントリはありません。',
  'pluginsView.availableEmptyNoSources': '利用可能なエントリはまだありません。「ソース」タブでソースを追加してください。',
  'pluginsView.installing': 'インストール中…',
  'pluginsView.installWaiting': '待機中…',
  'pluginsView.installQueuedHint': '別のプラグインをインストール中です。インストールは 1 件ずつ実行されます。完了するとこのボタンを使用できます。',
  'pluginsView.install': 'インストール',
  'pluginsView.sourcesTitle': 'レジストリソース',
  'pluginsView.sourcesSubtitle': '利用可能なプラグインエントリを供給するマーケットプレイスカタログ。',
  'pluginsView.sourceUrl': 'ソース URL',
  'pluginsView.defaultTrust': 'デフォルトの信頼レベル',
  'pluginsView.trust.restricted': '制限付き',
  'pluginsView.trust.trusted': '信頼済み',
  'pluginsView.trust.official': '公式',
  'pluginsView.adding': '追加中…',
  'pluginsView.addSource': 'ソースを追加',
  'pluginsView.sourcesEmpty': 'レジストリソースはまだ設定されていません。',
  'pluginsView.pluginsCount': '{n} 個のプラグイン',
  'pluginsView.catalogVersion': 'カタログ v{version}',
  'pluginsView.trustFor': '{name} の信頼レベル',
  'pluginsView.refreshing': '更新中…',
  'pluginsView.removing': '削除中…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to OpenDesign.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "OpenDesign official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. OpenDesign will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from OpenDesign official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "チームに同期",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "最新の「{title}」をチームに同期しました。",
  "pluginsView.syncUnavailable": "「{title}」を同期できませんでした。チームのワークスペースにいるか確認してください。",
  "pluginsView.syncFailed": "「{title}」のチームへの同期に失敗しました。しばらくしてからもう一度お試しください。",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'プライベートチームマーケットプレイス',
  'pluginsView.teamBody': 'このエリアは、エンタープライズおよびチームのカタログ、プライベートな信頼ポリシー、共有プラグインのライフサイクル管理のために予約されています。',
  'pluginCard.details': '詳細',
  'pluginCard.use': '使用',
  'pluginCard.useWithQuery': 'クエリ付きで使用',
  'pluginCard.applying': '適用中…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remix中…',
  'pluginCard.duplicateFailed': 'このテンプレートを Remix できませんでした。',
  'pluginCard.saved': '保存済み',
  'pluginCard.publish': '公開',
  'pluginCard.contribute': '貢献',
  'pluginCard.starting': '開始中…',
  'pluginCard.detailsAria': '{title} の詳細を表示',
  'pluginCard.chooseUseAria': '{title} の使用方法を選択',
  'pluginCard.useOptionsAria': '{title} の使用オプション',
  'pluginCard.duplicateAria': '{title} を新しいプロジェクトとして Remix',
  'pluginCard.saveAria': '{title} を保存',
  'pluginCard.savedAria': '{title} は保存済みです',
  'pluginCard.shareAria': '{title} を共有',
  'pluginCard.publishAria': '{title} を GitHub リポジトリとして公開',
  'pluginCard.publishTitle': 'プラグインを GitHub リポジトリとして公開',
  'pluginCard.contributeAria': '{title} を OpenDesign に貢献',
  'pluginCard.contributeTitle': 'プラグインを pull request で OpenDesign に貢献',
  'integrations.kicker': '連携',
  'integrations.lede': '外部システムを接続し、MCP ツールをエージェントループに取り込み、他の IDE やスクリプト、自動化から OpenDesign を利用できます。',
  'integrations.agentReady': 'Agent 対応',
  'integrations.areasAria': '連携エリア',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'スキル',
  'integrations.tabHint.mcp': '外部ツール',
  'integrations.tabHint.connectors': 'アカウントと API',
  'integrations.tabHint.useEverywhere': 'CLI、HTTP、MCP',
  'integrations.skillsTitle': 'Skills 連携',
  'integrations.skillsBody': 'Skill レベルの連携管理は別ブランチから移行中です。このタブは予約済みで、MCP、Connectors、今後の Skills 設定を同じ Integration ルートにまとめるためのものです。',
  'mcpClient.title': '外部 MCP サーバー',
  'mcpClient.subtitle': 'コーディング Agent 向けのサードパーティツール。',
  'mcpClient.addServer': 'サーバーを追加',
  'mcpClient.emptyTitle': 'MCP サーバーが設定されていません。',
  'mcpClient.emptyBody': '「サーバーを追加」をクリックして始めましょう — テンプレート（Higgsfield OpenClaw、Pollinations、Allyson、Imagician、EdgeOne Pages、GitHub、Filesystem…）を選ぶか、カスタムの stdio / HTTP サーバーを設定します。',
  'mcpClient.saveChanges': '変更を保存',
  'mcpClient.storedAt': '保存先',
  'mcpClient.daemonError': 'ローカルデーモンに接続できませんでした。OpenDesign が実行中であることを確認してから、このパネルを再度開いてください。',
  'mcpClient.saveFailed': '保存に失敗しました。デーモンが実行中であることを確認して、もう一度お試しください。',
  'useEverywhere.modalAria': 'OpenDesign をあらゆる場所で使う',
  'useEverywhere.modalTitle': 'OpenDesign をあらゆる場所で使う',
  'useEverywhere.modalSubtitle': 'OpenDesign をあらゆる IDE、Agent、スクリプトに組み込めます — CLI、HTTP、MCP、Skills 対応。「Agent 用のガイドをコピー」を使って Claude Code、Codex、Cursor、openclaw、hermes に貼り付ければ、すべてをセットアップできます。',
  'useEverywhere.closeAria': '「あらゆる場所で使う」を閉じる',
  'useEverywhere.closeTitle': '閉じる（Esc）',
  'useEverywhere.tabsAria': '連携サーフェス',
  'useEverywhere.footStrong': 'ワンクリックで引き渡し。',
  'useEverywhere.footBody': 'Agent がすぐに実行できる構造化された Markdown ガイドをコピーします — インストール、検証、利用まで。',
  'useEverywhere.configureMcp': 'MCP サーバーを設定',
  'useEverywhere.copyGuide': 'Agent 用ガイドをコピー',
  'useEverywhere.copy': 'コピー',
  'useEverywhere.copied': 'コピーしました',
  'useEverywhere.copyFailed': 'コピーに失敗しました',
  'useEverywhere.copySnippetAria': 'スニペットをコピー: {label}',
  'useEverywhere.section.overview.tab': '概要',
  'useEverywhere.section.overview.heading': 'OpenDesign は、お使いの Agent が動く場所ならどこでも動作します',
  'useEverywhere.section.overview.intro': 'OpenDesign は単なるウィンドウ以上のものです — ローカルの特権デーモン（`od`）に加え、Skills + Design-Systems + Atoms のレジストリを備えています。マシン上で起動すれば、あらゆるコード Agent（Claude Code、Codex、Cursor、OpenCode/openclaw、Hermes、独自のスクリプト）が、4 つの相互に交換可能なインターフェースを通じて、生成の実行、プロジェクトの検査、デザイン成果物の作成を行えます。',
  'useEverywhere.section.overview.bullet1': 'CLI — ヘッドレスなスクリプト、CI、シェル自動化向けの `od <command>`。',
  'useEverywhere.section.overview.bullet2': 'MCP サーバー — OpenDesign を Model Context Protocol サーバーとして接続し、MCP 対応のあらゆる Agent がスキルの一覧表示、シナリオの実行、成果物の読み取りを行えるようにします。',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` の REST + SSE エンドポイント。Web UI が使うのと同じインターフェースです。',
  'useEverywhere.section.overview.bullet4': 'Skills — ドロップインで使える `SKILL.md` パック（Claude 互換）。PATH 上にあるあらゆる Agent が、OpenDesign なしでも呼び出せます。',
  'useEverywhere.section.overview.bullet5': '標準成果物 — デーモンが起動する前に、Skills、同梱のデフォルトプラグイン、コミュニティのプラグイン例から実際の HTML プロジェクトをシードします。',
  'useEverywhere.section.overview.snippet1': 'ローカルでデーモン（と web UI）を起動する',
  'useEverywhere.section.overview.snippet2': '到達可能かどうかを確認する',
  'useEverywhere.section.overview.snippet3': '起動前に標準アーティファクトを取り込む',
  'useEverywhere.section.overview.footer': 'デーモンはデフォルトで `./.od/`（プロジェクトローカル）に書き込みます。プロジェクト間でデータを共有するには `OD_DATA_DIR=~/.open-design` を設定してください。',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': '任意のシェルから OpenDesign を操作する',
  'useEverywhere.section.cli.intro': '`od` バイナリはデーモンに同梱されており、Claude Code / Codex が生成を実行する際に使用するものと同じバイナリです。ほとんどのサブコマンドはローカルデーモンに POST するシンクライアントなので、`pnpm tools-dev` で起動した場合でもパッケージ化されたアプリとして起動した場合でも同じように動作します。',
  'useEverywhere.section.cli.bullet1': '`od`（引数なし）— デーモンを起動し、Web UI を開きます。',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — 統合メディアプロトコルを通じて画像 / 動画 / 音声のバイトデータを生成します。',
  'useEverywhere.section.cli.bullet3': '`od run ...` — プロンプト + スキルからプロジェクトの実行を開始します。',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — コミュニティプラグインのインストールと適用を行います。',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — ローカルで利用可能なものを確認します。',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — デーモンの状態を確認し、PATH 上の Agent CLI を検出します。',
  'useEverywhere.section.cli.snippet1': '画像を生成する（設定済みのメディアプロバイダーに委譲）',
  'useEverywhere.section.cli.snippet2': 'シナリオプラグインをヘッドレスで実行し、イベントを JSON 行としてストリーミングする',
  'useEverywhere.section.cli.snippet3': 'ローカルで利用可能なスキルとデザインシステムを一覧表示する',
  'useEverywhere.section.cli.snippet4': 'CLI からシードされたアーティファクトを確認する',
  'useEverywhere.section.cli.snippet5': '環境と検出された Agent（Claude、Codex、Cursor、…）を検証',
  'useEverywhere.section.cli.footer': 'すべてのサブコマンドは `--daemon-url http://127.0.0.1:<port>` を受け付け、特定の実行中デーモンを対象にできます — テスト用にサンドボックス化した 2 つ目のインスタンスを実行する際に便利です。',
  'useEverywhere.section.mcp.tab': 'MCP サーバー',
  'useEverywhere.section.mcp.heading': 'OpenDesign を MCP サーバーとして任意のコーディング Agent に公開する',
  'useEverywhere.section.mcp.intro': 'OpenDesign には Model Context Protocol サーバー（`od mcp`）が同梱されており、MCP 対応のあらゆるクライアント — Cursor、Claude Code、Antigravity、VS Code Copilot Chat、openclaw、hermes — が、手動でシェルを呼び出すことなく OpenDesign のツール（スキルの一覧表示、プレビューのレンダリング、メディアの生成、プラグインの実行）を検出できます。デーモンは主要な各クライアント向けに、貼り付けるだけで使えるインストール用スニペットを `GET /api/mcp/install-info` で公開します。',
  'useEverywhere.section.mcp.bullet1': 'stdio トランスポート — 追加のポート不要で、クライアントが `od mcp` を直接起動します。',
  'useEverywhere.section.mcp.bullet2': 'サイドカーとして起動された場合、ローカル IPC ステータスソケット経由で稼働中のデーモン URL を自動検出します。',
  'useEverywhere.section.mcp.bullet3': '通常のインストールでは `--daemon-url http://127.0.0.1:<port>` にフォールバックするため、MCP プロセスは常に稼働中のデーモンを見つけられます。',
  'useEverywhere.section.mcp.bullet4': '`OD_DATA_DIR` を固定することで、起動された MCP プロセスがデーモンが既に使用しているのと同じ場所に書き込むようにします（パッケージ化された macOS アプリバンドルでの EPERM を回避）。',
  'useEverywhere.section.mcp.snippet1': '汎用 MCP クライアント設定（Cursor、Claude Code、Codex、… で動作）',
  'useEverywhere.section.mcp.snippet2': 'または: お使いのインストール環境に合わせたスニペットをデーモンに問い合わせる',
  'useEverywhere.section.mcp.snippet3': 'ライブアーティファクト MCP バリアント（ダッシュボードの読み取りと更新）',
  'useEverywhere.section.mcp.footer': 'OpenDesign アプリで「設定 → 連携」を開くと、JSON を手作業で編集する代わりに、クライアント別のインストールコマンド（Cursor、Claude Code、Antigravity、VS Code）をコピーできます。',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'web UI が使用するものと同じ REST + SSE サーフェス',
  'useEverywhere.section.http.intro': 'ローカルデーモンは `http://127.0.0.1:7456`（ポートは設定可能）で HTTP API を提供します。web UI が呼び出すすべてのエンドポイントは、あなたのスクリプトからも自由に利用できます。ストリーミングエンドポイント（チャットターン、プロジェクト実行）は、`@open-design/contracts` のコントラクト型を伴う Server-Sent Events を発行します。',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — デーモンの稼働状態。',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` と `GET /api/design-systems` — 利用可能なレジストリ。',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` と `POST /api/projects` — プロジェクトの一覧表示と作成（POST はプロジェクトと最初の会話を返します）。',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — 会話の Agent イベントの SSE ストリーム。',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — インストール済みプラグインをバインドし、レンダリングされたクエリ例と入力を取得します。',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — PATH 上で検出されたコード Agent の CLI。',
  'useEverywhere.section.http.snippet1': 'インストール済みのスキルを一覧表示する（Agent はこれらをテンプレートとして使用します）',
  'useEverywhere.section.http.snippet2': 'プロンプトからプロジェクトを作成する（サーバーサイドのフロー全体）',
  'useEverywhere.section.http.snippet3': 'チャットのターンをストリーミング（SSE — 各行は JSON-Lines 互換）',
  'useEverywhere.section.http.footer': 'すべてのリクエスト/レスポンスの純粋な TypeScript 型は `@open-design/contracts` にあります — ジェネレーターを組み込まなくても、スクリプトにインポートするだけで完全な補完が得られます。',
  'useEverywhere.section.skills.tab': 'スキルとヘッドレス',
  'useEverywhere.section.skills.heading': 'あらゆる Agent 向けのドロップイン Skills — OpenDesign が起動していなくても利用可能',
  'useEverywhere.section.skills.intro': 'Skill は、Claude 互換の `SKILL.md`（YAML フロントマター + 本文）を含むディレクトリです。OpenDesign はこのフォーマットを `od:` 名前空間（`mode`、`preview`、`design_system`、`inputs`、…）で拡張し、同じ成果物を OpenDesign 内でも、Claude Code、Codex、openclaw、hermes のような素の Agent でも利用できるようにしています。検出は優先順位のチェーンに従うため、プロジェクトは自身のスキルを上書きできます。',
  'useEverywhere.section.skills.bullet1': '検出: `./.claude/skills/` → `./skills/` → `~/.claude/skills/`（プロジェクトが優先）。',
  'useEverywhere.section.skills.bullet2': '1 つのスキルを複数のプロジェクトにシンボリックリンクすることで、コピーせずに共有できます。',
  'useEverywhere.section.skills.bullet3': '各スキルは、コネクター、アトム、デザインシステム要件、およびギャラリー用の `preview` サンプル出力を宣言できます。',
  'useEverywhere.section.skills.bullet4': 'ヘッドレス: PATH に `od` を持つ Agent は `od skills list` を呼び出してから任意のスキルを実行できます。読み取り専用のフローではデーモンは任意です。',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` は、デフォルトのプラグイン例とコミュニティプラグイン例で同じアーティファクト形状を実行し、その結果の `index.html` プロジェクトを再利用可能なテストデータとして保存します。',
  'useEverywhere.section.skills.snippet1': '最小限の SKILL.md（Claude 互換のフロントマター + OpenDesign の追加項目）',
  'useEverywhere.section.skills.snippet2': '共有スキルをプロジェクトにシンボリックリンクする（cc-switch 方式）',
  'useEverywhere.section.skills.snippet3': 'ヘッドレス: デーモンが現在認識しているスキルを一覧表示する',
  'useEverywhere.section.skills.snippet4': 'ヘッドレスアーティファクトフィクスチャバンドル',
  'useEverywhere.section.skills.footer': '仕様: `docs/skills-protocol.md` と `docs/agent-adapters.md` は、アダプターサーフェス全体（Claude Code、Codex、Cursor、MCP 対応 Agent、BYOK API フォールバック）とアダプターごとのスキル注入戦略を網羅しています。',
  'tasks.kicker': '自動化ワークスペース',
  'tasks.comingSoon': '近日公開',
  'tasks.lede': '自動化はプロンプトを永続的な作業へと変えます。Orbit が実行し、ルーティンが定義を保持し、スケジュールが実行タイミングを決定し、ライブアーティファクトが変更内容を表示します。',
  'tasks.newAutomation': '新規自動化',
  'tasks.previewNote': 'プレビュー画面のみです。Orbit 設定は現在ご利用いただけます。ルーティン、スケジュール、ライブアーティファクトの連携は、バックエンドのブランチがマージされ次第提供されます。',
  'tasks.primitivesAria': '自動化プリミティブ',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': '長時間または定期的に実行される Agent 作業のための永続ランタイム。',
  'tasks.primitive.orbit.enabled': '日次サマリー有効',
  'tasks.primitive.orbit.manualOnly': '手動のみ',
  'tasks.primitive.routines.title': 'ルーティン',
  'tasks.primitive.routines.body': '単一のチャット終了後も保持される永続的なタスク定義。',
  'tasks.primitive.routines.meta': 'プロダクトシェル準備完了',
  'tasks.primitive.schedules.title': 'スケジュール',
  'tasks.primitive.schedules.body': 'ルーティンの実行タイミングを決定する時間またはイベントトリガー。',
  'tasks.primitive.schedules.meta': 'ブランチ保留中',
  'tasks.primitive.liveArtifacts.title': 'ライブアーティファクト',
  'tasks.primitive.liveArtifacts.body': 'Agent の作業中に更新され続けるレポートやメモ。',
  'tasks.primitive.liveArtifacts.meta': 'プレビューモデル',
  'tasks.listAria': '自動化一覧',
  'tasks.routinesAndRuns': '{n} 件のルーティンと実行',
  'tasks.filtersAria': '自動化フィルター',
  'tasks.filter.scheduled': 'スケジュール済み',
  'tasks.filter.running': '実行中',
  'tasks.filter.done': '完了',
  'tasks.configurationAria': '自動化の設定',
  'tasks.slot.trigger': 'トリガー',
  'tasks.slot.pattern': 'パターン',
  'tasks.slot.runtime': 'ランタイム',
  'tasks.slot.output': '出力',
  'tasks.liveArtifact': 'ライブアーティファクト',
  'tasks.viewProgress': '進捗を表示',
  'tasks.pause': '一時停止',
  'tasks.runNow': '今すぐ実行',
  'tasks.openArtifact': 'アーティファクトを開く',
  'tasks.status.dailyAt': '毎日 · {time}',
  'tasks.status.pausedManual': '一時停止中 · 手動のみ',
  'tasks.sample.orbit.title': 'Orbit Daily コネクターサマリー',
  'tasks.sample.orbit.metaEnabled': 'コネクターダイジェストはスケジュール済み',
  'tasks.sample.orbit.metaDisabled': '有効にするには Orbit 設定を開く',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · ライブ成果物',
  'tasks.sample.orbit.previewDisabled': 'スケジュールされた実行はありません',
  'tasks.sample.orbit.triggerEnabled': 'スケジュール · 毎日 {time}',
  'tasks.sample.orbit.triggerDisabled': '手動 · オンデマンド実行',
  'tasks.sample.orbit.pattern': 'ルーティン · コネクターダイジェスト',
  'tasks.sample.orbit.runtime': 'Orbit · デーモンによるスケジュール実行',
  'tasks.sample.orbit.output': 'ライブ成果物 · 更新可能なレポート',
  'tasks.sample.orbit.artifactMetaEnabled': '実行ごとに更新されます',
  'tasks.sample.orbit.artifactMetaDisabled': 'スケジュール待ち',
  'tasks.sample.orbit.body1': '# Orbit Daily アクティビティサマリー',
  'tasks.sample.orbit.body2': 'コネクターを確認済み · 成功、スキップ、失敗',
  'tasks.sample.orbit.body3': 'ハイライトは更新可能なライブアーティファクトになります。',
  'tasks.sample.mcp.title': 'MCP 代替手段の調査',
  'tasks.sample.mcp.status': 'orbit で実行中 · 2時間14分',
  'tasks.sample.mcp.meta': '14 / 30 ソース処理済み',
  'tasks.sample.mcp.preview': 'research_notes.md · ライブ',
  'tasks.sample.mcp.trigger': '手動 · ワンショット',
  'tasks.sample.mcp.pattern': 'ディープリサーチプロンプト',
  'tasks.sample.mcp.runtime': 'リモート · 永続',
  'tasks.sample.mcp.output': 'ライブレポート · 自動更新',
  'tasks.sample.mcp.artifactMeta': '12秒前に更新',
  'tasks.sample.mcp.body1': '# MCP 代替手段 - 暫定的な調査結果',
  'tasks.sample.mcp.body2': '14 件のソースを精査 · 3 件の候補を選定',
  'tasks.sample.mcp.body3': '## 候補リスト',
  'tasks.sample.mcp.body4': '- JSON-RPC 経由のツール呼び出しスキーマ...',
  'tasks.sample.mcp.body5': '- gRPC ベースの Agent プロトコル...',
  'tasks.sample.weekly.title': '週次チームダイジェスト',
  'tasks.sample.weekly.status': '次回: 月 9:00 AM',
  'tasks.sample.weekly.meta': 'チーム週次ドキュメントを更新',
  'tasks.sample.weekly.preview': 'team_weekly.md · 次の成果物',
  'tasks.sample.weekly.trigger': 'スケジュール · 毎週',
  'tasks.sample.weekly.pattern': 'ルーティン · チームダイジェスト',
  'tasks.sample.weekly.runtime': 'リモート · 定期実行',
  'tasks.sample.weekly.output': 'ライブ成果物 · Markdown',
  'tasks.sample.weekly.artifactMeta': '最終更新 4日前',
  'tasks.sample.weekly.body1': '# チーム週次レポート',
  'tasks.sample.weekly.body2': '## 進行中',
  'tasks.sample.weekly.body3': '- デザインシステム統合パス',
  'tasks.sample.weekly.body4': '- コネクタ品質チェック',
  'tasks.sample.weekly.body5': '## リスク',
  'tasks.sample.pr.title': 'PR レビューのリマインダー',
  'tasks.sample.pr.status': '新しい PR 時 · 23分前に実行',
  'tasks.sample.pr.meta': 'Slack DM を送信',
  'tasks.sample.pr.preview': '前回の配信に成功しました',
  'tasks.sample.pr.trigger': 'イベント · 新規 PR',
  'tasks.sample.pr.pattern': 'ルーティン · 通知',
  'tasks.sample.pr.runtime': 'ローカル · クイック実行',
  'tasks.sample.pr.output': 'メッセージ · Slack DM',
  'tasks.sample.pr.artifactMeta': '最終実行: 23 分前',
  'tasks.sample.pr.body1': 'レビュー用に PR #184 をオープンしました',
  'tasks.sample.pr.body2': '一致したレビュアー: design-platform, web-runtime',
  'tasks.sample.pr.body3': '配信: Slack DM を送信しました',
  'tasks.sample.meeting.title': '会議前の準備',
  'tasks.sample.meeting.status': '明日 · 午前 10:00',
  'tasks.sample.meeting.meta': '単発 · サマリーを送信',
  'tasks.sample.meeting.preview': 'meeting_brief.md · キュー待ち',
  'tasks.sample.meeting.trigger': 'スケジュール · 単発',
  'tasks.sample.meeting.pattern': 'ブリーフィングプロンプト',
  'tasks.sample.meeting.runtime': 'リモート · 制限あり',
  'tasks.sample.meeting.output': '成果物 + メッセージ',
  'tasks.sample.meeting.artifactMeta': '生成待ち',
  'tasks.sample.meeting.body1': '# 会議ブリーフ',
  'tasks.sample.meeting.body2': 'アジェンダのソース: カレンダーイベント + リンクされたドキュメント',
  'tasks.sample.meeting.body3': '出力には決定事項、ブロッカー、質問が含まれます。',
  'tasks.sample.candidate.title': '候補者トラッキング',
  'tasks.sample.candidate.status': '失敗 · 要対応',
  'tasks.sample.candidate.meta': '認証の有効期限切れ',
  'tasks.sample.candidate.preview': '再開するには Greenhouse を再接続してください',
  'tasks.sample.candidate.trigger': 'スケジュール · 毎日',
  'tasks.sample.candidate.pattern': 'ルーティン · 応募者の同期',
  'tasks.sample.candidate.runtime': 'リモート · 繰り返し',
  'tasks.sample.candidate.output': 'ライブアーティファクト · テーブル',
  'tasks.sample.candidate.artifactMeta': '認証が復元されるまで一時停止中',
  'tasks.sample.candidate.body1': '# 候補者パイプライン',
  'tasks.sample.candidate.body2': '最後に成功した同期: 2 日前',
  'tasks.sample.candidate.body3': '対応が必要: ソースアカウントを再接続してください。',
  'routines.title': '自動化',
  'routines.subtitle': '無人で実行されるスケジュール自動化。',
  'routines.newAutomation': '新規自動化',
  'routines.loading': '読み込み中…',
  'routines.empty': '自動化はまだありません。',
  'routines.emptyHint': '「新規自動化」をクリックして、無人で実行する Agent をスケジュールします。',
  'routines.runHistoryLoading': '実行を読み込み中…',
  'routines.runHistoryEmpty': '実行履歴はまだありません。',
  'routines.fieldName': '名前',
  'routines.fieldNamePlaceholder': '朝のブリーフィング',
  'routines.fieldPrompt': 'プロンプト',
  'routines.fieldPromptPlaceholder': '昨日の GitHub と Linear のアクティビティを取得し、変更点を要約します。',
  'routines.fieldSchedule': 'スケジュール',
  'routines.fieldMinute': '毎時の分',
  'routines.fieldTime': '時刻',
  'routines.fieldTimezone': 'タイムゾーン',
  'routines.fieldsetProject': 'プロジェクト',
  'routines.kind.hourly': '毎時',
  'routines.kind.daily': '毎日',
  'routines.kind.weekdays': '平日',
  'routines.kind.weekly': '毎週',
  'routines.weekday.short.0': '日',
  'routines.weekday.short.1': '月',
  'routines.weekday.short.2': '火',
  'routines.weekday.short.3': '水',
  'routines.weekday.short.4': '木',
  'routines.weekday.short.5': '金',
  'routines.weekday.short.6': '土',
  'routines.weekday.long.0': '日曜日',
  'routines.weekday.long.1': '月曜日',
  'routines.weekday.long.2': '火曜日',
  'routines.weekday.long.3': '水曜日',
  'routines.weekday.long.4': '木曜日',
  'routines.weekday.long.5': '金曜日',
  'routines.weekday.long.6': '土曜日',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': '毎時 :{minute} に実行',
  'routines.describe.daily': '毎日 {time} {tz} に実行',
  'routines.describe.weekdays': '月〜金 {time} {tz} に実行',
  'routines.describe.weekly': '毎週 {day} の {time} {tz} に実行',
  'routines.modeCreate': '実行ごとに新規プロジェクトを作成',
  'routines.modeCreateHint': '起動ごとに新しい独立したワークスペース。',
  'routines.modeReuse': '既存のプロジェクトを再利用',
  'routines.modeReuseHint': '各実行はプロジェクト内の新しい会話として扱われます。',
  'routines.pickProject': '— プロジェクトを選択 —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ 実行ごとに新規プロジェクト',
  'routines.tagPaused': '一時停止中',
  'routines.metaNext': '次回: {when}',
  'routines.metaLast': '前回:',
  'routines.triggerManual': '手動',
  'routines.triggerScheduled': 'スケジュール',
  'routines.openProject': 'プロジェクトを開く',
  'routines.openProjectTitle': 'この実行が書き込んだプロジェクトを開く',
  'routines.runNow': '今すぐ実行',
  'routines.edit': '編集',
  'routines.pause': '一時停止',
  'routines.resume': '再開',
  'routines.history': '履歴',
  'routines.hideHistory': '履歴を非表示',
  'routines.delete': '削除',
  'routines.deleteTitle': 'この自動化を削除',
  'routines.cancel': 'キャンセル',
  'routines.save': '保存',
  'routines.saving': '保存中…',
  'routines.create': '作成',
  'routines.creating': '作成中…',
  'routines.status.queued': '待機中',
  'routines.status.running': '実行中',
  'routines.status.succeeded': '成功',
  'routines.status.failed': '失敗',
  'routines.status.canceled': 'キャンセル済み',
  'routines.confirmDelete': 'この自動化を削除しますか？過去の実行とそのプロジェクトは保持されます。',
  'routines.errorPickProject': '再利用するプロジェクトを選択するか、「実行ごとに新規作成」に切り替えてください',
  'routines.errorAgentEmptyOutput': 'Agent は出力を生成せずに完了しました。モデルまたはプロバイダーが空のレスポンスを返した可能性があります。上流のエラーがないか Agent のログを確認してください。',
  'entry.githubStarLabel': 'スター',
  'entry.githubStarTitle': 'GitHub でスターを付ける',
  'entry.githubStarAria': 'GitHub で OpenDesign にスターを付ける',
  'entry.tabImageTemplates': '画像テンプレート',
  'entry.tabVideoTemplates': '動画テンプレート',
  'promptTemplates.emptyNoMatch': '検索に一致するテンプレートがありません。',
  'promptTemplates.fetchError': 'テンプレートの本文を読み込めませんでした。',
  'promptTemplates.promptLabel': 'プロンプト本文',
  'promptTemplates.copyPrompt': 'プロンプトをコピー',
  'promptTemplates.copyDone': 'コピーしました！',
  'promptTemplates.allSources': 'すべてのソース',
  'promptTemplates.retry': '再試行',
  'connectors.title': 'コネクター',
  'connectors.subtitle': 'ライブアーティファクトを支えるローカルおよび将来のデータソース。',
  'connectors.account': 'アカウント',
  'connectors.noAccount': '未接続',
  'connectors.tools': 'ツール',
  'connectors.connect': '接続',
  'connectors.disconnect': '接続解除',
  'connectors.authorizationPending': '認証を待機しています…',
  'connectors.authorizationPendingHint': '開いたウィンドウで認証を完了してください。',
  'connectors.cancelAuthorization': 'キャンセル',
  'connectors.configure': '設定',
  'connectors.unavailable': '利用不可',
  'connectors.phaseStubTitle': 'コネクター API はフェーズ 3 で提供されます。これはプレビュー画面です。',
  'connectors.statusAvailable': '利用可能',
  'connectors.statusConnected': '接続済み',
  'connectors.statusError': 'エラー',
  'connectors.statusDisabled': '無効',
  'connectors.gateTitle': '続行するには Composio API key を追加してください',
  'connectors.gateBody': '上にキーを貼り付けて「キーを保存」をクリックすると、利用可能な連携が読み込まれます。',
  'connectors.aboutLabel': '概要',
  'connectors.detailsLabel': '詳細',
  'connectors.statusLabel': 'ステータス',
  'connectors.category.aiAgents': 'AI Agent',
  'connectors.category.aiInfrastructure': 'AI インフラ',
  'connectors.category.accounting': '会計',
  'connectors.category.admin': '管理',
  'connectors.category.advertising': '広告',
  'connectors.category.analytics': 'アナリティクス',
  'connectors.category.automation': '自動化',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'カレンダー',
  'connectors.category.commerce': 'コマース',
  'connectors.category.communication': 'コミュニケーション',
  'connectors.category.contacts': '連絡先',
  'connectors.category.dataPlatform': 'データプラットフォーム',
  'connectors.category.database': 'データベース',
  'connectors.category.design': 'デザイン',
  'connectors.category.developer': '開発者',
  'connectors.category.documentation': 'ドキュメント',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': '教育',
  'connectors.category.email': 'メール',
  'connectors.category.events': 'イベント',
  'connectors.category.fieldService': 'フィールドサービス',
  'connectors.category.finance': 'ファイナンス',
  'connectors.category.fitness': 'フィットネス',
  'connectors.category.forms': 'フォーム',
  'connectors.category.gaming': 'ゲーム',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'ホスピタリティ',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': '連携',
  'connectors.category.localization': 'ローカライゼーション',
  'connectors.category.logistics': 'ロジスティクス',
  'connectors.category.maps': 'マップ',
  'connectors.category.marketing': 'マーケティング',
  'connectors.category.media': 'メディア',
  'connectors.category.meetings': '会議',
  'connectors.category.nonprofit': '非営利',
  'connectors.category.observability': 'オブザーバビリティ',
  'connectors.category.payments': '決済',
  'connectors.category.personal': '個人',
  'connectors.category.presentations': 'プレゼンテーション',
  'connectors.category.procurement': '調達',
  'connectors.category.product': 'プロダクト',
  'connectors.category.productivity': '生産性',
  'connectors.category.projectManagement': 'プロジェクト管理',
  'connectors.category.recruiting': '採用',
  'connectors.category.research': 'リサーチ',
  'connectors.category.salesIntelligence': 'セールスインテリジェンス',
  'connectors.category.scheduling': 'スケジューリング',
  'connectors.category.search': '検索',
  'connectors.category.security': 'セキュリティ',
  'connectors.category.signing': '署名',
  'connectors.category.social': 'ソーシャル',
  'connectors.category.spreadsheets': 'スプレッドシート',
  'connectors.category.storage': 'ストレージ',
  'connectors.category.support': 'サポート',
  'connectors.category.surveys': 'アンケート',
  'connectors.category.tasks': 'タスク',
  'connectors.category.timeTracking': '時間追跡',
  'connectors.category.video': '動画',
  'connectors.category.whiteboard': 'ホワイトボード',
  'connectors.categoryLabel': 'カテゴリ',
  'connectors.providerLabel': 'プロバイダー',
  'connectors.toolsSection': 'ツール',
  'connectors.toolsLoading': 'ツールを読み込み中…',
  'connectors.noToolsAvailable': '利用可能なツールはまだありません。接続して、この連携が公開する内容を確認してください。',
  'connectors.toolDetailsUnavailable': 'ツールの詳細は利用できませんが、このコネクターは {n} 個のツールを報告しています。',
  'connectors.loadMoreTools': 'さらにツールを読み込む',
  'connectors.openDetailsAria': '{name} の詳細を開く',
  'connectors.toolsBadgeNone': 'ツールなし',
  'connectors.toolsBadgeOne': '{n} 個のツール',
  'connectors.toolsBadgeMany': '{n} 個のツール',
  'connectors.searchPlaceholder': 'コネクターを検索…',
  'connectors.searchAriaLabel': '名前、プロバイダー、ツールでコネクターを検索',
  'connectors.searchClear': '検索をクリア',
  'connectors.emptyNoMatchTitle': '「{query}」に一致するコネクターはありません',
  'connectors.emptyNoMatchBody': '別のキーワードをお試しいただくか、検索をクリアしてカタログ全体を参照してください。',
  'connectors.emptyNoMatchAction': '検索をクリア',
  'newproj.tabPrototype': 'プロトタイプ',
  'newproj.tabLiveArtifact': 'ライブアーティファクト',
  'newproj.tabDeck': 'スライド',
  'newproj.tabTemplate': 'テンプレートから',
  'newproj.tabMedia': 'メディア',
  'newproj.tabOther': 'その他',
  'newproj.titlePrototype': '新しいプロトタイプ',
  'newproj.titleLiveArtifact': '新しいライブアーティファクト',
  'newproj.titleDeck': '新しいスライドデッキ',
  'newproj.titleTemplate': 'テンプレートから開始',
  'newproj.titleImage': '新しい画像',
  'newproj.titleVideo': '新しい動画',
  'newproj.titleAudio': '新しい音声',
  'newproj.titleMedia': '新しいメディア',
  'newproj.titleOther': '新しいプロジェクト',
  'newproj.namePlaceholder': 'プロジェクト名',
  'newproj.fidelityLabel': '品質',
  'newproj.fidelityWireframe': 'ワイヤーフレーム',
  'newproj.fidelityHigh': '高品質',
  'newproj.toggleSpeakerNotes': 'スピーカーノートを使用',
  'newproj.toggleSpeakerNotesHint': 'スライドのテキストを減らし、話す内容をノートに残します。',
  'newproj.toggleAnimations': 'アニメーションを含める',
  'newproj.toggleAnimationsHint': 'テンプレートにモーション（入場・ホバー・トランジション）を追加します。',
  'newproj.targetPlatformsLabel': 'ターゲットプラットフォーム',
  'newproj.targetPlatformsHint': '1つ以上選択してください。Responsive web はブラウザのブレークポイントのみに対応します。ネイティブのクロスプラットフォーム版が必要な場合は、iOS、Android、タブレットアプリ、デスクトップアプリを追加してください。',
  'newproj.platform.responsive.label': 'レスポンシブ Web',
  'newproj.platform.responsive.hint': 'デスクトップ、タブレット、モバイルのブラウザに対応した1つのウェブ体験',
  'newproj.platform.webDesktop.label': 'デスクトップ Web',
  'newproj.platform.webDesktop.hint': 'ブラウザを主体とするプロダクトまたはランディングページ',
  'newproj.platform.mobileIos.label': 'iOS アプリ',
  'newproj.platform.mobileIos.hint': 'iPhone のフレームと iOS のインタラクションルール',
  'newproj.platform.mobileAndroid.label': 'Android アプリ',
  'newproj.platform.mobileAndroid.hint': 'Pixel のフレームと Material のインタラクションルール',
  'newproj.platform.tablet.label': 'タブレットアプリ',
  'newproj.platform.tablet.hint': '分割ビューを備えたネイティブ風のタブレット体験',
  'newproj.platform.desktopApp.label': 'デスクトップアプリ',
  'newproj.platform.desktopApp.hint': 'macOS/Windows のアプリクローム',
  'newproj.surfaceOptionsLabel': 'コンパニオンサーフェス',
  'newproj.includeLandingPage': 'ランディングページを含める',
  'newproj.includeLandingPageHint': '広告、ウェイトリスト、ローンチキャンペーン、アプリのダウンロード、プロダクト説明のためのレスポンシブなマーケティングページを追加します。',
  'newproj.includeOsWidgets': 'OS ウィジェットを含める',
  'newproj.includeOsWidgetsHint': 'モバイル/タブレットアプリ向けに、プラットフォームネイティブのホーム画面、ロック画面、クイックアクセスウィジェットを追加します。',
  'newproj.includeOsWidgetsDisabledHint': 'ターゲットプラットフォームとして iOS、Android、またはタブレットアプリを選択すると利用できます。',
  'newproj.templateLabel': 'テンプレート',
  'newproj.noTemplatesTitle': 'テンプレートがまだありません',
  'newproj.noTemplatesBody': 'プロジェクトを開き、ファイルビューア内の共有メニューからテンプレートに変換してください。テンプレートはここに表示されます。',
  'newproj.savedTemplate': '保存済みテンプレート',
  'newproj.fileSingular': 'ファイル',
  'newproj.filePlural': 'ファイル',
  'newproj.create': '作成',
  'newproj.locationLabel': '保存先',
  'newproj.locationDefault': 'OpenDesign プロジェクト',
  'newproj.locationExternalBase': '外部ベース',
  'newproj.createLiveArtifact': 'ライブアーティファクトを作成',
  'newproj.createFromTemplate': 'テンプレートから作成',
  'newproj.createDisabledTitle': '最初にプロジェクトをテンプレートとして保存してください（プロジェクト内の共有メニュー）。',
  'newproj.openFolder': 'フォルダを開く',
  'newproj.openingFolder': '開いています…',
  'newproj.importClaudeZip': 'Claude Design ZIP をインポート',
  'newproj.importClaudeZipTitle': 'Claude Design の .zip エクスポートをインポート',
  'newproj.importingClaudeZip': 'インポート中…',
  'newproj.privacyFooter': 'デフォルトではあなただけがプロジェクトを見ることができます。',
  'newproj.designSystem': 'デザインシステム',
  'newproj.dsNoneFreeform': 'なし — フリーフォーム',
  'newproj.dsNoneSubtitleEmpty': 'システムトークンなし、独自のパレットを選択',
  'newproj.dsNoneSubtitleSelected': 'システムトークンをスキップ。エージェントが独自のパレットを選択します。',
  'newproj.dsCategoryFallback': 'デザインシステム',
  'newproj.dsSearch': 'デザインシステムを検索…',
  'newproj.dsModeAria': '選択モード',
  'newproj.dsModeSingle': 'シングル',
  'newproj.dsModeMulti': 'マルチ',
  'newproj.dsNoneTitle': 'なし — フリーフォーム',
  'newproj.dsNoneSub': 'システムトークンをスキップ。エージェントが独自のパレットを選択します。',
  'newproj.dsEmpty': '"{query}" に一致するデザインシステムがありません。',
  'newproj.dsFootSingular': 'はインスピレーションのみです。',
  'newproj.dsFootPlural': 'はインスピレーションのみです。',
  'newproj.dsFootClear': 'クリア',
  'newproj.dsBadgeDefault': 'デフォルト',
  'newproj.dsPrimaryFallback': 'プライマリ',
  'newproj.surfaceImage': '画像',
  'newproj.surfaceVideo': '動画',
  'newproj.surfaceAudio': '音声',
  'newproj.modelLabel': 'モデル',
  'newproj.modelSearch': 'モデルを検索…',
  'newproj.modelEmpty': '一致するモデルがありません。',
  'newproj.modelRecommended': '推奨',
  'newproj.modelMissingTitle': 'モデルを選択',
  'newproj.modelMissingSub': 'このサーフェスに使うモデルを選択します。',
  'newproj.aspectLabel': 'アスペクト',
  'newproj.videoLengthLabel': '長さ',
  'newproj.videoLengthSeconds': '{n}秒',
  'newproj.audioKindLabel': '音声タイプ',
  'newproj.audioKindMusic': '音楽',
  'newproj.audioKindSpeech': 'スピーチ / TTS',
  'newproj.audioKindSfx': '効果音',
  'newproj.audioDurationLabel': '長さ',
  'newproj.audioDurationSeconds': '{n}秒',
  'newproj.voiceLabel': '音声',
  'newproj.voicePlaceholder': 'プロバイダーの音声 ID（省略可）',
  'newproj.connectorsLabel': 'コネクタ',
  'newproj.connectorsHint': 'このアーティファクトがデータを取得できるデータソース。',
  'newproj.connectorsEmptyTitle': 'コネクタが設定されていません',
  'newproj.connectorsEmptyBody': 'データソースを接続すると、ライブアーティファクトがプレースホルダーではなく実際の数値を取得できるようになります。',
  'newproj.connectorsEmptyCta': 'コネクターを設定 →',
  'newproj.connectorsLoading': 'コネクターを読み込み中…',
  'newproj.connectorsCountOne': '{n} 件接続済み',
  'newproj.connectorsCountMany': '{n} 件接続済み',
  'newproj.connectorsManage': '管理',
  'newproj.promptTemplateLabel': '参照テンプレート',
  'newproj.promptTemplateNoneTitle': 'なし — 自分で書く',
  'newproj.promptTemplateNoneSub': 'ギャラリーをスキップして、自分でブリーフを書きます',
  'newproj.promptTemplateRefSub': '参照テンプレート',
  'newproj.promptTemplateSearch': 'テンプレートを検索…',
  'newproj.promptTemplateEmpty': 'この種類のテンプレートはまだインストールされていません。',
  'newproj.promptTemplateBodyLabel': 'プロンプト（編集可能）',
  'newproj.promptTemplateOptimizeHint': '自由に編集できます — 変更内容はエージェントのブリーフに反映されます。',
  'newproj.promptTemplateBodyEmpty': '本文が空です — エージェントはテンプレート参照を受け取りません。',
  'newproj.deleteTemplateTitle': 'テンプレートを削除',
  'newproj.deleteTemplateConfirm': '"{name}" を削除しますか？この操作は取り消せません。',
  'newproj.deleteTemplateConfirmCta': 'テンプレートを削除',
  'newproj.deleteTemplateError': 'テンプレートを削除できませんでした。もう一度お試しください。',
  'designs.subRecent': '最近',
  'designs.subYours': 'あなたのデザイン',
  'designs.filterAria': 'プロジェクトをフィルター',
  'designs.searchPlaceholder': '検索…',
  'designs.emptyNoProjects': 'プロジェクトがまだありません。',
  'designs.emptyNoMatch': '検索に一致するプロジェクトがありません。',
  'designs.deleteTitle': 'プロジェクトを削除',
  'designs.deleteConfirm': '"{name}" を削除しますか？',
  'designs.cardFreeform': 'フリーフォーム',
  'designs.badgeLive': 'ライブ',
  'designs.liveArtifactBadgesAria': 'ライブアーティファクトのバッジ',
  'designs.liveCount': '{n} 件ライブ',
  'designs.statusLive': 'ライブアーティファクト',
  'designs.statusArchived': 'アーカイブ済み',
  'designs.statusError': 'エラー',
  'designs.statusRefreshing': '更新中…',
  'designs.statusRefreshFailed': '更新に失敗しました',
  'designs.statusRefreshed': '更新しました',
  'designs.status.notStarted': '未開始',
  'designs.status.queued': 'キュー中',
  'designs.status.running': '実行中',
  'designs.status.awaitingInput': '入力待ち',
  'designs.status.incomplete': '未完了',
  'designs.status.succeeded': '完了',
  'designs.status.published': '公開済み',
  'designs.status.failed': '失敗',
  'designs.status.canceled': 'キャンセル済み',
  'designs.viewToggleAria': '表示モード',
  'designs.viewGrid': 'グリッド表示',
  'designs.viewKanban': 'ボード表示',
  'designs.kanbanEmptyColumn': 'デザインなし',
  'designs.deleteAria': 'プロジェクト {name} を削除',
  'designs.menuMore': 'その他の操作',
  'designs.menuRename': '名前を変更',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': '削除',
  'designs.renamePrompt': '「{name}」の新しい名前',
  'designs.selectMode': '選択',
  'designs.cancelSelect': 'キャンセル',
  'designs.deleteSelected': '選択した項目を削除',
  'designs.selectedCount': '{n} 件選択中',
  'designs.deleteSelectedConfirm': '{n} 件のプロジェクトを削除しますか？',
  'designs.deleteSelectedSuccess': '{n} 件のプロジェクトを削除しました。',
  'designs.deleteSelectedPartial': '{deleted} 件のプロジェクトを削除しました（{failed} 件は失敗）。',
  'designs.tagPrototype': 'プロトタイプ',
  'designs.tagLiveArtifact': 'ライブアーティファクト',
  'designs.tagWebClone': 'ウェブサイト複製',
  'designs.tagSlide': 'スライド',
  'designs.tagMedia': 'メディア',
  'designs.renameTitle': 'プロジェクト名を変更',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'キャンセル',
  'examples.typeLabel': 'タイプ',
  'examples.surfaceLabel': 'サーフェス',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': '画像',
  'examples.surfaceVideo': '動画',
  'examples.surfaceAudio': '音声',
  'examples.scenarioLabel': 'シナリオ',
  'examples.modeAll': 'すべて',
  'examples.modePrototypeDesktop': 'プロトタイプ · デスクトップ',
  'examples.modePrototypeMobile': 'プロトタイプ · モバイル',
  'examples.modeDeck': 'スライド',
  'examples.modeDocument': 'ドキュメント & テンプレート',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'ライブ',
  'examples.scenarioGeneral': '一般',
  'examples.scenarioEngineering': 'エンジニアリング',
  'examples.scenarioProduct': 'プロダクト',
  'examples.scenarioDesign': 'デザイン',
  'examples.scenarioMarketing': 'マーケティング',
  'examples.scenarioSales': 'セールス',
  'examples.scenarioFinance': 'ファイナンス',
  'examples.scenarioHr': '人事',
  'examples.scenarioOperations': 'オペレーション',
  'examples.scenarioSupport': 'サポート',
  'examples.scenarioLegal': '法務',
  'examples.scenarioEducation': '教育',
  'examples.scenarioPersonal': '個人',
  'examples.searchPlaceholder': 'サンプルを検索…',
  'examples.searchAria': '名前でサンプルを検索',
  'examples.emptyNoSkills': 'スキルがありません。デーモンは起動していますか？',
  'examples.emptyNoMatch': 'このフィルターに一致するサンプルがありません。',
  'examples.openPreview': '⤢ プレビューを開く',
  'examples.loadingPreview': 'プレビューを読み込み中…',
  'examples.hoverPreview': 'ホバーでプレビュー',
  'examples.usePrompt': 'このプロンプトを使用',
  'examples.previewModalTitle': 'フルプレビューを開く（モーダル）',
  'examples.shareTitle': 'このサンプルを共有',
  'examples.shareLoadFirst': 'プレビューを読み込むためにホバーしてください',
  'examples.unavailablePlaceholder': '{kind} プレビューは同梱されていません — 詳細は開いて確認',
  'examples.shareUnavailable': '共有できる {kind} プレビューは同梱されていません',
  'examples.shareMenu': '共有 ▾',
  'examples.exportPdfAllSlides': 'PDFとしてエクスポート（全スライド）',
  'examples.exportPptxLocked': 'PPTXとしてエクスポート…（先にテンプレートを開いてください）',
  'examples.tagSlideDeck': 'スライドデッキ',
  'examples.tagTemplate': 'テンプレート',
  'examples.tagDesignSystem': 'デザインシステム',
  'examples.tagMobilePrototype': 'モバイルプロトタイプ',
  'examples.tagDesktopPrototype': 'デスクトッププロトタイプ',
  'examples.tagImage': '画像',
  'examples.tagVideo': '動画',
  'examples.tagAudio': '音声',
  'examples.previewLabel': 'プレビュー',
  'ds.surfaceLabel': 'サーフェス',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': '画像',
  'ds.surfaceVideo': '動画',
  'ds.surfaceAudio': '音声',
  'ds.searchPlaceholder': 'デザインシステムを検索…',
  'ds.emptyNoMatch': '検索に一致するデザインシステムがありません。',
  'ds.badgeDefault': 'デフォルト',
  'ds.preview': 'プレビュー',
  'ds.previewTitle': 'デザインシステムをプレビュー',
  'ds.categoryAll': 'すべて',
  'ds.categoryUncategorized': '未分類',
  'ds.showcase': 'ショーケース',
  'ds.tokens': 'トークン',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md を読み込み中…',
  'avatar.title': 'アカウントと設定',
  'avatar.localCli': 'ローカル CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'ローカル CLI を使用',
  'avatar.useApi': 'API · BYOK を使用',
  'avatar.codeAgent': 'コードエージェント',
  'avatar.rescan': 'PATH を再スキャン',
  'avatar.amrConsole': 'OpenDesign Cloud アカウント',
  'avatar.amrConsoleMeta': '残高とチャージ',
  'avatar.settings': '設定',
  'avatar.backToProjects': 'プロジェクトに戻る',
  'avatar.metaActive': 'アクティブ',
  'avatar.metaOffline': 'オフライン',
  'avatar.metaSelected': '選択中',
  'avatar.noAgentSelected': 'エージェント未選択',
  'avatar.modelSection': 'モデル',
  'avatar.modelLabel': 'モデル',
  'avatar.reasoningLabel': '推論',
  'avatar.serviceTierLabel': 'サービス階層',
  'avatar.customSuffix': '（カスタム）',
  'socialShare.openDesignSection': 'OpenDesign を共有',
  'socialShare.openDesignTitle': 'GitHub の OpenDesign',
  'socialShare.openDesignText': 'OpenDesign は、デザイン成果物の作成・編集・デプロイ・引き継ぎを行うためのソースアベイラブルなワークスペースです。',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'ソーシャル共有',
  'socialShare.publishPageTitle': '共有ページを公開',
  'socialShare.publishPageSubtitle': 'このプレビューを公開して、ソーシャルプラットフォームで共有できるようにします。',
  'socialShare.projectTitle': '{title} · OpenDesign',
  'socialShare.projectText': 'OpenDesign で作成: {title}。デプロイされた成果物を見て、リポジトリにスターを付けてください: {repo}',
  'socialShare.projectCopyText': 'OpenDesign で作成: {title}\n{url}\nOpenDesign リポジトリ: {repo}',
  'socialShare.deployFirst': 'デプロイして共有…',
  'socialShare.copied': 'コピーしました',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': '小紅書',
  'inlineSwitcher.chipTitle': 'CLI / モデルを切り替え',
  'inlineSwitcher.chipCli': 'ローカル CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'デフォルト',
  'inlineSwitcher.noAgent': 'エージェント未選択',
  'inlineSwitcher.modeLabel': 'モード',
  'inlineSwitcher.agentLabel': 'エージェント',
  'inlineSwitcher.providerLabel': 'プロバイダー',
  'inlineSwitcher.modelLabel': 'モデル',
  'inlineSwitcher.useCli': 'ローカル CLI を使用',
  'inlineSwitcher.useByok': '自分の API キーを使用',
  'inlineSwitcher.daemonOffline': 'デーモンがオフライン — 設定を開く',
  'inlineSwitcher.noAgentsDetected': 'PATH に CLI が見つかりません',
  'inlineSwitcher.openSettingsForModel': '設定でプロバイダーを構成してください',
  'inlineSwitcher.missingApiKey': 'API キー未設定 — 設定から追加してください。',
  'inlineSwitcher.openFullSettings': '実行設定を開く',
  'inlineSwitcher.customSuffix': '（カスタム）',
  'inlineSwitcher.unlimitedBadge': '無制限',
  'project.backToProjects': 'プロジェクトに戻る',
  'project.brandReadyTitle': '{name} のデザインシステムが準備できました',
  'project.brandReadyTitleGeneric': 'デザインシステムが準備できました',
  'project.brandReadyCta': 'デザインシステムでプレビュー',
  'project.brandReadyDismiss': '閉じる',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'デザインシステムのプレビューを開きました。',
  'project.previewCommentSaveFailed': 'コメントを保存できませんでした。もう一度お試しください。',
  'project.previewCommentSaveFailedTitle': 'コメントの保存に失敗しました',
  'project.previewCommentSaveFailedDescription': 'このコメントは保存されませんでした。もう一度お試しください。',
  'project.previewCommentReorderFailed': 'コメントの並び順を保存できませんでした。再読み込みすると元に戻る場合があります。',
  'project.metaFreeform': 'フリーフォーム',
  'project.typePrototype': 'プロトタイプ',
  'project.typeDeck': 'スライド',
  'project.typeTemplate': 'テンプレート',
  'project.typeImage': '画像',
  'project.typeVideo': '動画',
  'project.typeAudio': '音声',
  'project.customInstructions': 'プロジェクト指示',
  'project.customInstructionsPlaceholder': 'このプロジェクトへの指示（すべてのメッセージに挿入されます）…',
  'project.resizeChatPanel': 'チャットパネルのサイズを変更',
  'project.instructionsActive': '有効 — すべてのメッセージに含まれます',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'チャット',
  'chat.tabComments': 'コメント',
  'chat.commentsSoon': 'コメント — 近日公開',
  'chat.comments.attached': 'チャットに添付済み',
  'chat.comments.emptyAttached': '添付されたコメントはありません。',
  'chat.comments.saved': '保存済みコメント',
  'chat.comments.emptySaved': '保存されたコメントはありません。',
  'chat.comments.add': '追加',
  'chat.comments.addAll': 'すべて追加',
  'chat.comments.remove': '削除',
  'chat.comments.placeholder': 'この要素にコメント…',
  'chat.comments.addSend': '追加して送信',
  'chat.comments.updateSend': '更新して送信',
  'chat.comments.removeAttachment': 'コメントの添付を削除',
  'chat.comments.removeAttachmentAria': '{name} のコメント添付を削除',
  'chat.comments.comment': 'コメント',
  'chat.comments.sendToChat': 'チャットに送信',
  'chat.comments.viewAll': 'すべてのコメントを表示',
  'chat.comments.sending': '送信中…',
  'chat.comments.edit': '編集',
  'chat.comments.select': '選択',
  'chat.comments.selectAll': 'すべて選択',
  'chat.comments.deselect': '選択解除',
  'chat.comments.nSelected': '{n} 件選択中',
  'chat.comments.pin': 'ピン留め',
  'chat.comments.addNote': 'メモを追加',
  'chat.comments.savedToast': 'コメントを保存しました',
  'chat.comments.pinSavedToast': 'ピンを保存しました',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} 件のキャプチャ項目',
  'chat.comments.clear': 'クリア',
  'chat.comments.targetImage': '画像',
  'chat.comments.targetControl': 'コントロール',
  'chat.comments.targetLink': 'リンク',
  'chat.comments.targetText': 'テキスト',
  'chat.comments.targetSection': 'セクション',
  'chat.comments.targetPage': 'ページ',
  'chat.comments.targetArea': 'エリア',
  'chat.annotationNotePlaceholder': 'このマークにメモを追加',
  'chat.annotationAttachImage': '画像を添付',
  'chat.annotationAttachedImages': '添付した画像',
  'chat.annotationAttachedRemove': '最後の画像を削除',
  'chat.annotationAddToInput': '入力に追加',
  'chat.annotationAddingToInput': '追加中...',
  'chat.annotationQueue': 'キューに追加',
  'chat.annotationQueueing': 'キューに追加中...',
  'chat.annotationSubmitOptions': '送信オプション',
  'chat.annotationSending': '送信中...',
  'chat.annotationSendDisabledReason': 'タスクが実行中です',
  'chat.annotationPreviewMissing': 'プレビューをキャプチャできませんでした。もう一度お試しください。',
  'chat.annotationPreviewMissingInk': 'プレビューをキャプチャできませんでした。インクのみの送信を避けるため、もう一度お試しください。',
  'chat.annotationSentWithoutScreenshot': 'プレビューをキャプチャできませんでした。注釈はスクリーンショットなしで送信されました。',
  'chat.annotationTimeout': '注釈の送信がタイムアウトしました。もう一度お試しください。',
  'chat.annotationFailed': '注釈の送信に失敗しました。もう一度お試しください。',
  'chat.annotationProjectCreateFailed': 'プロジェクトを作成できなかったため、注釈は送信されませんでした。',
  'chat.annotationUploadFailed': '添付ファイルのアップロードに失敗しました。もう一度お試しください。',
  'chat.attachmentFolderUnsupported': 'フォルダはここに添付できません。代わりにフォルダ内のファイルを添付してください。',
  'chat.conversationsTitle': '会話',
  'chat.conversationsAria': '会話履歴',
  'chat.newConversation': '新しい会話',
  'chat.newSession': '新しい会話',
  'chat.newConversationsTitle': '新しい会話',
  'chat.conversationsHeading': '会話',
  'chat.emptyConversations': 'まだ会話がありません。',
  'chat.deleteConversation': '会話を削除',
  'chat.renameConversationLabel': '「{title}」の名前を変更',
  'chat.deleteConversationConfirm': '"{title}" を削除しますか？メッセージも削除されます。',
  'chat.untitledConversation': '無題の会話',
  'chat.forkConversationFailed': '新しい会話を開始できませんでした。',
  'chat.startTitle': '会話を始める',
  'chat.startHint': '生成したい内容を説明するか、以下の例から始めてください:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so OpenDesign can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.memoryWrittenSummary': '{count} 件の好みを記憶しました',
  'chat.brandBrowserAssistMessage': 'OpenDesign needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "AI 最適化",
  'brandEnrichment.body': "OpenDesign がバックグラウンドでより深い抽出を実行し、適切なデザインシステム skills を自動適用して、このシステムをその場で更新します。10-20 分かかる場合があります。作業は続けられます。",
  'brandEnrichment.cta': "AI 最適化",
  'brandEnrichment.busy': "AI 最適化を開始中...",
  'brandExtractionTranscript.sourceDesignMd': '貼り付けた DESIGN.md',
  'brandExtractionTranscript.user': '{source} からデザインシステムを抽出する。',
  'brandExtractionTranscript.doneTitle': '{name} のプログラム抽出が完了しました。',
  'brandExtractionTranscript.doneBody': '{source} から {designSystemId} デザインシステムを作成して登録しました。プレビュー可能で、新しいデザインにも使用できます。',
  'brandExtractionTranscript.next': '次に、AI Optimize でさらに深い抽出を実行するか、このシステムで新しいデザインを作成できます。',
  'chat.fillInputTitle': 'クリックして入力欄に入力',
  'chat.jumpToLatest': '最新にジャンプ',
  'chat.scrollToLatest': '最新にスクロール',
  'chat.messageRail.aria': 'ユーザーメッセージのナビゲーション',
  'chat.messageRail.jumpAria': 'ユーザーメッセージ {index} にジャンプ',
  'chat.messageRail.empty': '（内容なし）',
  'chat.you': 'あなた',
  'chat.record.retryImage': '配套イラストのうち {count} 枚が生成に失敗しました。もう一度生成してください',
  'chat.quote.add': '会話に追加',
  'chat.quote.count': '{count} 件のメモ',
  'chat.quote.duplicate': 'すでに会話に追加されています',
  'chat.quote.removeAria': 'メモを削除',
  'chat.support.title': 'サポートに連絡',
  'chat.support.join': '参加',
  'chat.sendFailedRetryAria': '送信に失敗しました。再試行',
  'chat.audio.play': '再生',
  'chat.audio.pause': '一時停止',
  'chat.audio.download': '{name} をダウンロード',
  'chat.upgrade.balance': '残り残高',
  'chat.upgrade.whyLow': '次のタスクを最後まで賄えない可能性があります。途中で尽きると作りかけで止まります',
  'chat.upgrade.whyOut': '今は新しいタスクを開始できません',
  'chat.upgrade.pausedTitle': '残高不足のため、タスクを一時停止しました',
  'chat.upgrade.pausedMessage': '残高が不足しています。チャージするかプランをアップグレードしてから、もう一度お試しください。',
  'chat.upgrade.pausedTeamTitle': 'チームの残高不足のため、タスクを一時停止しました',
  'chat.upgrade.pausedTeamMessage': 'チームの残高が不足しています。チーム管理者にチャージまたはサブスクリプションのアップグレードを依頼してください。',
  'chat.openFile': '{name} を開く',
  'chat.copyPrompt': 'プロンプトをコピー',
  'chat.copyErrorDiagnostic': 'エラー診断をコピー',
  'chat.copyDone': 'コピーしました！',
  'chat.inspect.noEditableTargets': '編集可能なテキストまたはスタイルの対象が見つかりません。',
  'chat.inspect.noCommentTargets': 'コメント可能なテキストまたはビジュアルの対象が見つかりません。',
  'chat.inspect.editHint': '編集するには、プレビューでテキストまたはスタイルの対象を選択してください。',
  'chat.inspect.commentHint': 'コメントするには、プレビューでテキストまたは領域を選択してください。',
  'chat.composerPlaceholder': '生成したい内容を説明してください…',
  'chat.activeFileEditingLabel': '編集中',
  'chat.activeFilePlaceholder': 'OpenDesign に {file} の変更を依頼...',
  'chat.designArtifactsShowMore': 'さらに {count} 個のデザインファイルを表示',
  'chat.mode.chat.label': '質問',
  'chat.mode.chat.title': 'Ask モード',
  'chat.mode.chat.summary': 'デザイン成果物の作成を前提にせず、すばやい回答、修正、計画、相談に使えます。',
  'chat.mode.chat.solves': 'アイデアの整理、プロンプト改善、選択肢の比較、既存作業への質問に向いています。',
  'chat.mode.chat.query1': 'このドラフトを要約して、足りない点を教えて。',
  'chat.mode.chat.query2': 'このランディングページに最適な構成を一緒に決めて。',
  'chat.mode.chat.query3': 'このデザインをレビューして、具体的な改善案を出して。',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'デザイン',
  'chat.mode.design.title': 'Design モード',
  'chat.mode.design.summary': 'ページ、プロトタイプ、ライブ成果物、スライド、画像、動画、HyperFrames、音声、ダッシュボード、プロジェクトファイルなど具体的な出力を作成または変更します。',
  'chat.mode.design.solves': 'OpenDesign にファイル生成、workspace 更新、brief からマルチモーダルな成果物への変換を任せたいときに使います。',
  'chat.mode.design.query1': 'この brief から製品ローンチ用ランディングページと HyperFrames プロトタイプを作って。',
  'chat.mode.design.query2': 'スピーカーノート付きの10枚の投資家向けデッキを作って。',
  'chat.mode.design.query3': 'このキャンペーン向けに画像、動画、音声のコンセプトを生成して。',
  'chat.mode.cardBestFor': '向いている用途',
  'chat.mode.cardTry': '質問例',
  'chat.mode.cardCost': '想定される消費量',
  'chat.mode.chat.cost': '少なめ',
  'chat.mode.chat.costNote': '会話のみで、何も生成しないため消費量は最小です。',
  'chat.mode.plan.cost': '標準',
  'chat.mode.plan.costNote': '生成の前に、編集可能なプラン文書を1つ作成します。',
  'chat.mode.design.cost': '多め',
  'chat.mode.design.costNote': 'ファイルやマルチモーダルな成果物を生成するため、1回の消費量が最も多くなります。',
  'chat.modePicker.choose': 'モードを選択',
  'chat.modePicker.current': 'モード: {name}',
  'chat.modePicker.clear': 'モードをクリア',
  'chat.modePicker.mode': 'モード',
  'chat.composerHint': '⌘/Ctrl + Enter で送信 · 目的、内容、スタイル、形式を含める',
  'chat.cliSettingsTitle': 'CLI とモデルの設定',
  'chat.cliSettingsAria': 'CLI とモデルの設定を開く',
  'chat.attachTitle': 'ファイルを添付（または貼り付け / ドロップ）',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'ファイルを添付',
  'chat.importTitle': 'ソースをインポート（近日公開）',
  'chat.importLabel': 'インポート',
  'chat.importComingSoon': '近日公開',
  'chat.importSoon': '近日',
  'chat.importFig': '.fig ファイルをアップロード',
  'chat.importGitHub': 'GitHub に接続',
  'chat.importWeb': 'Web 要素を取得',
  'chat.importFolder': 'コードフォルダーをリンク',
  'chat.importSkills': 'スキルとデザインシステム',
  'chat.importProject': '別のプロジェクトを参照',
  'chat.importDesignSystemHeader': 'デザインシステムを選択',
  'chat.importDesignSystemBack': '戻る',
  'chat.importDesignSystemSearch': 'デザインシステムを検索…',
  'chat.importDesignSystemEmpty': '"{query}" に一致するデザインシステムはありません',
  'chat.importDesignSystemNone': '指定なし — フリーフォーム',
  'chat.importDesignSystemNoneSub': '今回はどのシステムにも合わせない',
  'chat.importDesignSystemActive': '現在',
  'chat.importDesignSystemSwitched': 'デザインシステムを {title} に切り替えました',
  'chat.importDesignSystemFailed': 'デザインシステムを切り替えられませんでした。もう一度お試しください。',
  'chat.importDesignSystemLoadFailed': 'デザインシステムを読み込めませんでした。',
  'browserUse.title': 'インスピレーション',
  'browserUse.summary': '{count} 件の Web アクション。アセット抽出、デザイン言語、モーション、ビジュアルチェック、コンポーネント構造を優先します。',
  'browserUse.searchAria': 'インスピレーションを検索',
  'browserUse.searchPlaceholder': 'スクリーンショット、フォント、カラー、a11y を検索…',
  'browserUse.empty': '一致するインスピレーションがありません',
  'browserUse.unavailable': 'ここではインスピレーションを利用できません',
  'browserUse.added': 'コンポーザーに追加しました',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': '読み込みを停止',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'OpenDesign browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'アセット抽出',
  'browserUse.category.tokens': 'デザイン言語',
  'browserUse.category.motion': 'モーション',
  'browserUse.category.visual': 'ビジュアルチェック',
  'browserUse.category.structure': 'コンポーネント',
  'browserUse.category.project': 'プロジェクト実行',
  'browserUse.category.general': '一般',
  'browserUse.input.none': '入力なし',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'セレクター（任意）',
  'browserUse.input.requirementSelector': '要件、セレクター（任意）',
  'browserUse.input.selectorOptional': 'セレクター（任意）',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'セレクター、scale=2',
  'browserUse.input.gridOverlay': '12 カラム、最大 1200、ギャップ 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL、ドメイン、または検索キーワード',
  'browserUse.input.selector': 'セレクター',
  'browserUse.input.selectorText': 'セレクターとテキスト',
  'browserUse.input.scroll': 'ピクセル、top、bottom、または page',
  'browserUse.input.terminalRun': 'コマンド、タイムアウト 120 秒',
  'browserUse.input.command': 'コマンド',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'ヘッダー、ナビ、クラス名、位置、OG 画像、favicon フォールバックから抽出した最適なロゴ候補。',
  'browserUse.action.list_images.output': 'すべての img、srcset、source、CSS 背景画像を寸法と alt テキストとともに取得。',
  'browserUse.action.download_assets.output': 'ダウンロードしたアセットフォルダと、referer・cookie に対応した _manifest.json。',
  'browserUse.action.extract_svgs.output': 'インライン SVG とリンクされた .svg ファイルを個別の SVG ファイルとして保存。',
  'browserUse.action.optimize_svgs.output': '最適化された SVG ファイルと圧縮率。',
  'browserUse.action.extract_colors.output': '重み付けされたパレットと :root の CSS カラー変数を palette.json および palette.html として出力。',
  'browserUse.action.extract_fonts.output': '主要なフォントファミリー、サイズ、ウェイト、@font-face ルールを typography.json として出力。',
  'browserUse.action.extract_design_tokens.output': '角丸、シャドウ、スペーシング、CSS 変数を tokens.json として出力。',
  'browserUse.action.extract_type_scale.output': '見出し、本文、ボタンのタイプスケールをサイズ、ウェイト、行の高さ、比率とともに出力。',
  'browserUse.action.extract_buttons.output': '重複を除いたボタンスタイルライブラリを buttons.html および buttons.json として出力。',
  'browserUse.action.extract_grid_system.output': 'グリッドおよび flex コンテナ、方向、ギャップ、カラム、最大幅を layout.json として出力。',
  'browserUse.action.extract_breakpoints.output': 'レスポンシブのメディアクエリブレークポイントを breakpoints.json として出力。',
  'browserUse.action.extract_gradients.output': 'CSS グラデーションを gradients.css、gradients.json、プレビュー HTML として出力。',
  'browserUse.action.extract_shadows.output': 'ボックスシャドウ、テキストシャドウ、ドロップシャドウを shadows.json およびプレビューとして出力。',
  'browserUse.action.extract_easings.output': 'トランジションおよびアニメーションのイージング関数を easings.json として出力。',
  'browserUse.action.export_tokens.output': 'tokens.css、tokens.scss、tailwind.theme.js、style-dictionary.tokens.json。',
  'browserUse.action.extract_animations.output': '@keyframes、transition および transform ルール、検出されたモーションライブラリ、motion.css、motion.json。',
  'browserUse.action.validate_view.output': 'スクリーンショットのパスと、構造化されたビジュアルおよびレイアウトの問題。',
  'browserUse.action.audit_layout.output': 'オーバーフロー、境界、重なり、テキストの切れなどのレイアウト不具合を audit.json として出力。',
  'browserUse.action.audit_accessibility.output': 'セレクター、ラベル、ロール、フォーカス、コントラストを含む a11y の問題と、必要に応じたスクリーンショット。',
  'browserUse.action.responsive_screenshots.output': 'モバイル 390、タブレット 834、デスクトップ 1440 のスクリーンショット。',
  'browserUse.action.screenshot_full.output': 'ビューポートを超えたページ全体のスクリーンショット。',
  'browserUse.action.screenshot_element.output': 'デフォルトで 2x の単一要素スクリーンショット。',
  'browserUse.action.screenshot_with_grid.output': 'レイアウトグリッドを重ねたスクリーンショット。',
  'browserUse.action.screenshot_dark_mode.output': 'prefers-color-scheme: dark でのスクリーンショット。',
  'browserUse.action.generate_styleguide.output': 'カラー、タイプスケール、角丸、シャドウを含む1ページのスタイルガイド。',
  'browserUse.action.extract_html.output': 'script、noscript、インラインのイベント属性を含まない、クリーンで自己完結型のHTML。',
  'browserUse.action.extract_component_inventory.output': '繰り返し使われるコンポーネントのパターン、セレクター、件数、スクリーンショット。',
  'browserUse.action.extract_copy.output': '見出し、CTA、本文、説明文を copy.md および copy.json として出力。',
  'browserUse.action.extract_nav.output': '主要なナビゲーションとフッターのリンクを sitemap.md および nav.json として出力。',
  'browserUse.action.extract_forms.output': 'フォームのフィールド、ラベル、バリデーションのヒント、送信アクションを forms.json として出力。',
  'browserUse.action.run_project.output': '検出された開発サーバーのURLをBrowserタブで開きます。',
  'browserUse.action.detect_project.output': 'フレームワーク、パッケージマネージャー、インストールコマンド、開発コマンド、ポート。',
  'browserUse.action.page_info.output': 'URL、タイトル、説明、OG画像、テーマカラー、favicon、ビューポート。',
  'browserUse.action.snapshot.output': 'タグ、ラベル、href、座標を含む、表示中のインタラクティブ要素およびテキスト要素を最大120件。',
  'browserUse.action.navigate.output': 'ページを開き、page_info を返します。',
  'browserUse.action.click.output': '最初に一致した要素を表示位置までスクロールしてからクリックします。',
  'browserUse.action.type_text.output': '入力欄に入力し、input イベントと change イベントを発火させます。',
  'browserUse.action.scroll.output': '現在のスクロール位置と最大スクロール位置。',
  'browserUse.action.extract_og_metadata.output': 'メタタイトル、説明、正規URL、OG/Twitterカード、ソーシャル画像、テーマカラー。',
  'browserUse.action.terminal_run.output': 'stdout、stderr、終了コード。',
  'browserUse.action.terminal_run_background.output': 'バックグラウンドタスクのIDと最近の出力。',
  'browserUse.action.terminal_read.output': '共有ターミナルの最近の出力。',
  'chat.designToolbox.title': 'デザインツールボックス',
  'chat.designToolbox.tooltip': 'デザインツールボックス',
  'chat.designToolbox.aria': 'デザインツールボックスを開く',
  'chat.designToolbox.searchPlaceholder': 'スキル / MCP / プラグイン / コネクタ / デザインファイルを検索...',
  'chat.designToolbox.searchAria': 'デザインツールボックスのリソースを検索',
  'chat.designToolbox.followupSection': 'フォローアップ',
  'chat.designToolbox.resourcesSection': 'グローバルリソース',
  'chat.designToolbox.selected': '選択済み',
  'chat.designToolbox.noResources': '「{query}」に一致するリソースが見つかりません。',
  'chat.designToolbox.badge.video': '動画',
  'chat.designToolbox.badge.image': '画像',
  'chat.designToolbox.badge.motion': 'モーション',
  'chat.designToolbox.badge.polish': '仕上げ',
  'chat.designToolbox.action.auto-match.title': '次のステップをマッチ',
  'chat.designToolbox.action.auto-match.badge': 'マッチ',
  'chat.designToolbox.action.auto-match.description': 'まずテイストの基準を定義し、次にスキル、MCP、プラグイン、コネクタ、ファイルをマッチします。',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'アニメーション／モーションを追加',
  'chat.designToolbox.action.motion.badge': 'モーション',
  'chat.designToolbox.action.motion.description': '現在のHTMLまたはページ要素に、登場・スクロール・状態遷移・マイクロインタラクションのモーションを追加します。',
  'chat.designToolbox.action.motion-polish.title': 'モーションを仕上げる',
  'chat.designToolbox.action.motion-polish.badge': 'タイミング',
  'chat.designToolbox.action.motion-polish.description': '既存のモーションについて、タイミング、イージング、パフォーマンス、reduced-motionのフォールバックを確認します。',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'AIっぽさを除去',
  'chat.designToolbox.action.anti-ai-polish.badge': 'テイスト',
  'chat.designToolbox.action.anti-ai-polish.description': 'テンプレート感、AIっぽいグラデーション、安っぽいカードの羅列、曖昧なコピーを取り除きます。',
  'chat.designToolbox.action.visual-polish.title': 'デザインの仕上げ／出荷準備',
  'chat.designToolbox.action.visual-polish.badge': '仕上げ',
  'chat.designToolbox.action.visual-polish.description': '視覚的な階層、タイポグラフィ、余白、レスポンシブ挙動、アクセシビリティ、納品品質を監査します。',
  'chat.designToolbox.action.image-gen.title': '画像／ビジュアルリファレンスを生成',
  'chat.designToolbox.action.image-gen.badge': '画像',
  'chat.designToolbox.action.image-gen.description': '現在のページ向けに、セクションのリファレンス、アセット、アイコン、ソーシャル画像、またはムードボードを生成します。',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': '動画／モーションスクリプトを生成',
  'chat.designToolbox.action.video-gen.badge': '動画',
  'chat.designToolbox.action.video-gen.description': 'デザインを短い動画、Remotion／Hyperframesのストーリーボード、または生成可能なプロンプトに変換します。',
  'chat.designToolbox.kind.skill': 'スキル',
  'chat.designToolbox.kind.plugin': 'プラグイン',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCPテンプレート',
  'chat.designToolbox.kind.connector': 'コネクタ',
  'chat.designToolbox.kind.designFile': 'デザインファイル',
  'chat.designToolbox.context.browser': 'ブラウザ',
  'chat.designToolbox.context.designFiles': 'デザインファイル',
  'chat.designToolbox.context.designSystem': 'デザインシステム',
  'chat.designToolbox.context.folder': 'フォルダ',
  'chat.designToolbox.context.terminal': 'ターミナル',
  'chat.designToolbox.context.sideChat': 'サイドチャット',
  'chat.designToolbox.context.liveArtifact': 'ライブアーティファクト',
  'chat.designToolbox.context.file': 'ファイル',
  'chat.designToolbox.prompt.contextGeneric': '現在の対象: 現在開いているHTML／デザインファイル／Web要素。',
  'chat.designToolbox.prompt.contextSpecific': '現在のターゲット: {kind} · {label}。',
  'chat.designToolbox.prompt.preserveDraft': 'コンポーザーにすでにある意図を保持してください: {draft}',
  'chat.designToolbox.prompt.selectedSkill': '選択されたスキル: {skill}。今回のターンの主要なワークフローとして使用してください。',
  'chat.designToolbox.prompt.noSkill': '特定のスキルが一致しない場合は、まず利用可能なスキル、MCP、プラグイン、コネクタ、デザインファイルの中から最適な組み合わせを選んでください。',
  'chat.designToolbox.prompt.autoMatchIntro': 'クリエイティブディレクターのオーケストレーターとして振る舞い、デザインワークフローを完了してください:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. まず「優れたデザイン」とは何かを定義します: 対象オーディエンス、ビジネス目標、ブランドの雰囲気、スタイルの参考、情報密度、カラー/タイポグラフィ/モーション/アセットの基準、避けるべき AI/テンプレートのパターン。',
  'chat.designToolbox.prompt.autoMatchStep2': '2. 上記のリソースインデックス全体を検索してマッチさせてください。design toolboxの推奨だけに頼らず、有用な場合はスキル、MCP、プラグイン、コネクタ、デザインファイルを組み合わせてください。',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. 次の順序でフローを完了してください: 診断 -> スタイルの方向性 -> リソースの選択 -> 具体的な編集／生成 -> 検証。各ステップで、なぜこれらのリソースを選んだか、次に何を確認する必要があるかを説明してください。',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': '既存のモーションのタイミング、イージング、パフォーマンス、アクセシビリティを確認・仕上げしてください。唐突で安っぽい、または可読性を損なうアニメーションを取り除き、必要に応じてより洗練されたタイムラインを使用してください。',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'AIっぽさを除去する仕上げを1回行ってください: テンプレート的なレイアウト、安っぽいグラデーション／グロー、意味のないカードの羅列、曖昧なコピーを取り除いてください。情報は保持し、本物のデザイナーが納品したように感じられるようにしてください。',
  'chat.designToolbox.prompt.visualPolish': 'このデザインを出荷準備が整うまで仕上げてください: 階層、タイポグラフィ、余白、レスポンシブ挙動、ボタンの状態、空／読み込み中／エラーの状態、アクセシビリティを確認し、最も重要な問題を直接修正してください。',
  'chat.designToolbox.prompt.imageGen': 'このデザインの次のビジュアルアセット計画を作成してください: セクションのリファレンス、ヒーローアセット、イラスト、アイコン、ソーシャル画像、またはムードボード。まずどの種類の画像が不足しているかを判断し、次に実行可能な生成プロンプト／ファイル計画を提示してください。',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'このデザインを動画へ展開します。ショート動画の絵コンテ、Hyperframes / Remotion のフレーム構成、または Sora/fal にすぐ使えるプロンプトを作成します。既存の HTML / ページコンテンツを自然にショットへ変換する方法を優先します。',
  'chat.designToolbox.prompt.useSkill': '現在のデザインに {skill} を使用します。',
  'chat.designToolbox.prompt.skillInstruction': 'まず最適な次の目標を決め、その上で具体的なパスを1つ完了します。外部アセットや API に依存する場合は、実行可能なフォールバックを用意するか、こちらが提供すべきものを明示してください。',
  'chat.designToolbox.prompt.selectedResource': '選択中のリソース: {kind} · {title}（{id}）。',
  'chat.designToolbox.prompt.resourceDescription': 'リソースの説明: {description}',
  'chat.designToolbox.prompt.pluginResource': 'このプラグインを現在のデザインフローの主要コンテキストとして使用します。入力や GenUI を提供する場合は、必要に応じて選択をガイドします。対象に適さない場合は、より適切なグローバルリソースを選び、その理由を説明します。',
  'chat.designToolbox.prompt.mcpResource': '次のデザインステップではこの MCP 機能を優先します。外部アセット、Web キャプチャ、画像/動画生成、データが必要な場合は、まずそれで対応できるか判断し、その上で実行可能なプランを提示します。',
  'chat.designToolbox.prompt.mcpTemplateResource': 'この MCP は設定可能なテンプレートです。このデザインステップで最も有用なツールであればまずセットアップをガイドします。設定済みの代替手段があれば、その代替手段で続行します。',
  'chat.designToolbox.prompt.connectorResource': '実データ、アセット、アカウントのコンテンツ、または外部ワークフローへのアクセスが必要な場合は、このコネクターを使用します。使用前に、何を読み書きするかを説明し、必要に応じて確認を求めます。',
  'chat.designToolbox.prompt.fileResource': 'このデザインファイルを現在のデザイン対象または参照アセットとして使用し、そこから次のステップを完了します。他のファイルとの比較が必要な場合は、すべてのデザインファイルを横断して検索を続けます。',
  'chat.designToolbox.prompt.resourceIndex': 'グローバルリソースインデックス: スキル({skills})、プラグイン({plugins})、MCP({mcpEnabled} 件有効 / {mcpTemplates} 件のテンプレート)、コネクター({connectors} 件接続済み)、デザインファイル({files})。',
  'chat.designToolbox.prompt.searchableSkills': '検索可能なスキル',
  'chat.designToolbox.prompt.searchablePlugins': '検索可能なプラグイン',
  'chat.designToolbox.prompt.availableMcp': '利用可能な MCP',
  'chat.designToolbox.prompt.connectedConnectors': '接続済みのコネクター',
  'chat.designToolbox.prompt.referenceDesignFiles': '参照デザインファイル',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} テンプレート',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ' 他 {count} 件',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}。',
  'chat.mentionTabsAria': 'メンション対象',
  'chat.mentionTabAll': 'すべて',
  'chat.mentionTabTabs': 'タブ',
  'chat.mentionTabPlugins': 'プラグイン',
  'chat.mentionTabSkills': 'スキル',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'コネクター',
  'chat.mentionTabFiles': 'デザインファイル',
  'chat.mentionNoResults': '「{query}」の結果はありません。',
  'chat.mentionSearchPrompt': 'デザインファイル、タブ、プラグイン、スキル、MCP サーバー、コネクターを検索します。',
  'chat.mentionSectionTabs': 'タブ',
  'chat.mentionSectionPlugins': 'プラグイン',
  'chat.mentionSectionSkills': 'スキル',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'コネクター',
  'chat.mentionSectionFiles': 'デザインファイル',
  'chat.mentionActiveSkill': '有効',
  'chat.mentionUseMcpTitle': '{name} を使用',
  'chat.mentionUseConnectorTitle': '{name} を使用',
  'chat.mentionPluginOfficial': '公式',
  'chat.mentionPluginMine': 'マイプラグイン',
  'chat.linkedFolderRemoveAria': 'リンクされたフォルダー {path} を削除',
  'chat.linkedFolderNotFound': 'フォルダーが存在しません',
  'chat.linkedFolderAlready': 'このフォルダーは既にリンクされています',
  'chat.linkedFolderPickError': 'フォルダー選択を開けません',
  'chat.queuedEditQueuedTaskAria': 'キュー内のタスクを編集',
  'chat.queuedSave': '保存',
  'chat.queuedCancel': 'キャンセル',
  'chat.queuedReorder': 'ドラッグで並べ替え',
  'chat.queuedEdit': '編集',
  'chat.queuedHeader': 'キュー済み',
  'chat.queuedSteer': 'この応答を誘導',
  'chat.queuedSteerInterrupts': 'この応答を誘導 — 実行中の処理を中断します',
  'chat.queuedSteerUnsupported': 'このエージェントは応答中にメッセージを受け取れません',
  'chat.queuedSteerClosed': 'この応答はすでに入力の受付を終了しました',
  'chat.queuedSteerFailed': '応答を誘導できませんでした',
  'chat.queuedSteerTextOnly': '実行中の応答に渡せるのはテキストだけです。添付付きのこれは個別に送ってください',
  'chat.queuedFollowUpFallback': 'キュー内のフォローアップ',
  'chat.send': '送信',
  'chat.stop': '停止',
  'chat.removeAria': '{name} を削除',
  'chat.example1Title': '編集ピッチデッキ',
  'chat.example1Tag': '雑誌',
  'chat.example1Prompt': 'シードラウンドを調達するデザインスタジオの10スライド編集ピッチデッキ — スイスグリッドレイアウト、大きなセリフ体の見出しにボールドドロップキャップ、等幅フォントのセクション番号、余白を活かしたデザイン、テキスト中心のスライドと交互に配置したフルブリード写真スライド。カバー、ビジョン、マーケット、プロダクト、トラクション、チーム、調達額、連絡先。',
  'chat.example2Title': 'SaaS 分析ダッシュボード',
  'chat.example2Tag': 'データ',
  'chat.example2Prompt': '開発者ツール SaaS の高密度な分析ダッシュボード — 前週比デルタ付き KPI ストリップ、積み上げ折れ線グラフ2本（MRR とアクティブワークスペース）、使用状況のワールドヒートマップ、コホートリテンショングリッド、トップ顧客リーダーボード、リアルタイムイベントフィード。ダークテーマ、表形式等幅数字、スパークラインアクセント。',
  'chat.example3Title': '年次報告書 長スクロール',
  'chat.example3Tag': '編集',
  'chat.example3Prompt': '気候系 NPO のインタラクティブ年次報告書 — 大きな引用ブロック、データビジュアライゼーション（積み上げ棒グラフ、アニメーションカウンター、プロジェクトサイトのコロプレスマップ）、写真ブレーカー、ドナーウォール、最後にコールトゥアクションを混在させた長スクロール編集レイアウト。モダンなセリフ体本文、サンセリフのチャートラベル、土のようなペーパーパレット。',
  'home.recommendation.eyebrow': 'あなたへのおすすめ',
  'home.recommendation.primaryCta': '作成を開始',
  'home.recommendation.change': '別のものを試す',
  'home.recommendation.browseAll': 'すべてのタイプ',
  'home.recommendation.defaultProjectName': '新規プロジェクト',
  'home.recommendation.startFailed': '作成を開始できませんでした。もう一度お試しください。',
  'studio.firstArtifactHint.title': '最初のデザインが完成しました',
  'studio.firstArtifactHint.body': 'そのまま編集や注釈を試してみましょう。満足したらいつでもエクスポート・共有できます。',
  'studio.firstArtifactHint.dismiss': 'OK',
  'home.starter.product_ui_prototype.title': '編集可能なプロダクトプロトタイプから始める',
  'home.starter.product_ui_prototype.desc': '目標に応じて、調整できるクリック可能なインターフェースから始めましょう。',
  'home.starter.product_ui_prototype.firstPrompt': '[あなたのプロダクト] 向けに、主要な画面と明確なメインフローを備えた編集可能なプロダクトプロトタイプをデザインして。',
  'home.starter.product_ui_component.title': '再利用可能なコンポーネントから始める',
  'home.starter.product_ui_component.desc': 'まず 1 つのコンポーネントを作り、それを組み合わせて画面全体を構成します。',
  'home.starter.product_ui_component.firstPrompt': '主要なステートとバリアントを備えた、再利用可能な [コンポーネント名] コンポーネントをデザインして。',
  'home.starter.product_ui_lowfi.title': 'ローファイプロトタイプから始める',
  'home.starter.product_ui_lowfi.desc': 'まず構造をスケッチし、その後で忠実度を高めていきます。',
  'home.starter.product_ui_lowfi.firstPrompt': '[あなたのプロダクト] の主要画面のローファイなワイヤーフレームを作成して。',
  'home.starter.marketing_landing.title': 'ランディングページから始める',
  'home.starter.marketing_landing.desc': 'キャンペーンを、そのまま公開できるランディングページに仕上げます。',
  'home.starter.marketing_landing.firstPrompt': '[あなたのプロダクト] 向けに、ヒーロー、主要なメリット、明確なコールトゥアクションを備えたランディングページをデザインして。',
  'home.starter.marketing_multivariant.title': '複数のランディングバリアントから始める',
  'home.starter.marketing_multivariant.desc': '決定する前に比較できるよう、いくつかのバージョンを生成します。',
  'home.starter.marketing_multivariant.firstPrompt': '[あなたのプロダクト] 向けに、ヒーローのメッセージが異なる 3 つのランディングページのバリアントを作成して比較できるようにして。',
  'home.starter.internal_dashboard.title': '社内ダッシュボードから始める',
  'home.starter.internal_dashboard.desc': 'あなたのワークフローに合わせたダッシュボードレイアウトから始めます。',
  'home.starter.internal_dashboard.firstPrompt': '[主要な指標] を表示し、フィルターとデータテーブルを備えた社内ダッシュボードをデザインして。',
  'home.starter.internal_report.title': 'レポートから始める',
  'home.starter.internal_report.desc': '見たいデータやフィールドを説明してください。',
  'home.starter.internal_report.firstPrompt': '[見たいデータ、フィールド、指標を説明してください] をまとめたレポートページを作成して。',
  'home.starter.general_menu.title': '最初のプロジェクトから始める',
  'home.starter.general_menu.desc': '作りたいものを説明してください。編集可能な最初のバージョンを生成します。',
  'home.starter.general_menu.firstPrompt': '[作りたいものを説明してください] の編集可能な最初のバージョンを作成して。',
  'chat.example4Title': 'プロダクトモーション動画',
  'chat.example4Tag': 'モーション',
  'chat.example4Prompt': '生産性アプリのローンチ向けに 15 秒のモーション動画ストーリーボードを作って。冒頭のフック、UI の寄り、キネティックタイポグラフィ、機能トランジション、最後の logo と CTA を含め、タイミング、シーン説明、カメラワーク、画面テキストも整理して。',
  'preview.usePlugin': 'プラグインを使う',
  'preview.usePluginOnly': 'プロンプトなしで使用',
  'preview.usePluginOnlyDesc': 'サンプルプロンプトを読み込まずにプラグイン構造を使用',
  'preview.replicateContent': '使用',
  'preview.replicateContentDesc': 'サンプルプロンプトでプレビューを再現',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'この例を編集可能な新しいプロジェクトに Remix',
  'preview.shareMenu': '共有',
  'preview.exportMenu': 'エクスポート',
  'preview.shareTemplateBadge': 'テンプレート',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'テンプレートリンクをコピー',
  'preview.copyShareText': '共有テキストをコピー',
  'preview.shareSocialGroup': 'ソーシャルに共有',
  'preview.shareCopyGroup': 'コピー',
  'preview.shareExportGroup': 'ファイルをエクスポート',
  'preview.shareCopied': 'コピーしました',
  'preview.shareCopyFailed': 'コピーに失敗しました',
  'preview.shareTextDefault': 'OpenDesign テンプレート: {title}',
  'preview.openInNewTab': '新しいタブで開く',
  'preview.exit': '⤓ 終了',
  'preview.fullscreen': '⤢ フルスクリーン',
  'preview.closeTitle': '閉じる (Esc)',
  'preview.loading': '{label} を読み込み中…',
  'preview.errorTitle': 'この例を読み込めませんでした。',
  'preview.errorBody': '例の HTML を取得できませんでした。OpenDesign が起動していることを確認して再試行してください。',
  'preview.retry': '再試行',
  'preview.unavailableTitle': '{noun}にはプレビューが同梱されていません。',
  'preview.unavailableBody': 'チャットでプロンプトを実行して {kind} 出力を生成してください。',
  'preview.nounSkill': 'このスキル',
  'preview.nounPlugin': 'このプラグイン',
  'preview.nounTemplate': 'このテンプレート',
  'preview.showSidebar': '{label} を表示',
  'preview.hideSidebar': '{label} を非表示',
  'misc.savedTemplate': '保存済みテンプレート',
  'misc.primary': 'プライマリ',
  'misc.designSystem': 'デザインシステム',
  'workspace.designFiles': 'デザインファイル',
  'workspace.focusMode': 'ワークスペースに集中',
  'workspace.showChat': 'チャットを表示',
  'workspace.closeTab': 'タブを閉じる',
  'workspace.fileSyncDownloading': 'チームからダウンロード中…',
  'workspace.fileSyncUploading': 'チームに同期中…',
  'workspace.deleteFileConfirm': 'プロジェクトフォルダーから "{name}" を削除しますか？',
  'workspace.readonlyNotice': 'これは共有プロジェクトです。閲覧とコメントはできますが、Chat や編集ツールで Artifact を変更することはできません。',
  'workspace.readonlyNoticeBy': 'これは {owner} が作成した共有プロジェクトです。閲覧とコメントはできますが、Chat や編集ツールで Artifact を変更することはできません。',
  'workspace.deleteSelectedFilesConfirm': 'プロジェクトフォルダーから選択した {n} 個のファイルを削除しますか？',
  'workspace.deleteSelectedFilesPartial': '{n} 個のファイルの削除に失敗しました。',
  'workspace.openFromDesignFiles': 'ファイルを開く: ',
  'workspace.designFilesLink': 'デザインファイル',
  'workspace.loadingSketch': 'スケッチを読み込み中…',
  'workspace.newTab': '新しいタブ',
  'workspace.searchFilesPlaceholder': 'ファイルを検索…',
  'workspace.openTabs': '開いているタブ',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'ファイルを開く',
  'workspace.noFilesMatch': '一致するファイルがありません',
  'workspace.allFiles': 'すべて',
  'workspace.createNew': '新規作成',
  'workspace.tabOpen': '開いています',
  'workspace.sideChatContextBanner': '現在の会話のコンテキストを引き継ぎました',
  'workspace.sideChatDefaultTitle': 'サイドチャット',
  'workspace.newTerminal': '新しいターミナル',
  'workspace.newTerminalDescription': 'プロジェクトディレクトリのシェルを新しいタブで開く',
  'workspace.newBrowser': '新しいブラウザ',
  'workspace.newBrowserDescription': '参照サイトやブラウザ作業用の内蔵ブラウザタブを開く',
  'workspace.newSketchDescription': 'ラフなレイアウトやメモを描き、エージェントのデザイン文脈にする',
  'workspace.terminalStarting': 'ターミナルを起動しています…',
  'workspace.terminalStartingDescription': 'プロジェクトのシェルを準備しています。通常は数秒で完了します。',
  'workspace.terminalSessionEnded': 'セッションが終了しました',
  'workspace.terminalReconnecting': '再接続しています…',
  'workspace.terminalStartFailed': 'ターミナルセッションを開始できませんでした',
  'workspace.terminalRestart': '再起動',
  'designFiles.title': 'デザインファイル',
  'designFiles.upload': 'ファイルをアップロード',
  'designFiles.pasteText': 'テキストファイルとして貼り付け',
  'designFiles.newSketch': '新しいスケッチ',
  'designFiles.newDocument': '新規ドキュメント',
  'designFiles.newDocumentTitle': '新しい Markdown ドキュメントを作成',
  'designFiles.empty': 'ここに作品が表示されます',
  'designFiles.buildingPreview': '全画面プレビュー',
  'designFiles.syncing': 'チームで共有されたファイルを同期中…',
  'designFiles.refresh': '更新',
  'designFiles.delete': '削除',
  'designFiles.searchPlaceholder': 'ファイルを検索…',
  'designFiles.up': '上へ',
  'designFiles.back': '戻る',
  'designFiles.crumbs': 'プロジェクト',
  'designFiles.rowMenu': '行メニュー',
  'designFiles.openInTab': 'タブで開く',
  'designFiles.download': 'ダウンロード',
  'designFiles.downloadSelected': '{n}件をZIPとしてダウンロード',
  'designFiles.deleteSelected': '{n} 件を削除',
  'designFiles.clearSelection': '選択をクリア',
  'designFiles.selectPage': 'このページをすべて選択',
  'designFiles.selectAll': 'すべて選択',
  'designFiles.dropTitle': '⤓ ファイルをここにドロップ',
  'designFiles.dropDesc': '画像、ドキュメント、参考資料、フォルダー — エージェントがコンテキストとして使用します。',
  'designFiles.dropLabel': 'ここにファイルをドロップ',
  'designFiles.upload.title': 'ファイルをアップロード',
  'designFiles.paste.title': "テキストをファイルとして貼り付け",
  'designFiles.upload.label': 'アップロード',
  'designFiles.paste.label': "貼り付け",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what OpenDesign should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The OpenDesign agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask OpenDesign to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': '開く',
  'designFiles.previewClose': 'プレビューを閉じる',
  'designFiles.modified': '{time} に変更 · {size}',
  'designFiles.weeksAgo': '{n}週間前',
  'designFiles.groupBy': 'グループ化',
  'designFiles.groupByKind': '種類',
  'designFiles.groupByModified': '更新日時',
  'designFiles.filterBy': '種類で絞り込み',
  'designFiles.filterClear': 'クリア',
  'designFiles.filterCount': '{n} 種類',
  'designFiles.expandGroup': '展開',
  'designFiles.collapseGroup': '折りたたむ',
  'designFiles.sectionPages': 'ページ',
  'designFiles.sectionScripts': 'スクリプト',
  'designFiles.sectionImages': '画像',
  'designFiles.sectionSketches': 'スケッチ',
  'designFiles.sectionLiveArtifacts': 'ライブアーティファクト',
  'designFiles.sectionOther': 'その他',
  'designFiles.modifiedToday': '今日',
  'designFiles.modifiedYesterday': '昨日',
  'designFiles.modifiedPrevious7Days': '過去7日間',
  'designFiles.modifiedPrevious30Days': '過去30日間',
  'designFiles.modifiedOlder': 'それ以前',
  'designFiles.showMore': 'さらに {n} 件表示',
  'designFiles.kindHtml': 'HTML ページ',
  'designFiles.kindImage': '画像',
  'designFiles.kindSketch': 'スケッチ',
  'designFiles.kindText': 'テキスト',
  'designFiles.kindCode': 'スクリプト',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'ドキュメント',
  'designFiles.kindPresentation': 'プレゼンテーション',
  'designFiles.kindSpreadsheet': 'スプレッドシート',
  'designFiles.kindLiveArtifact': 'ライブアーティファクト',
  'designFiles.kindBinary': 'バイナリ',
  'designFiles.kindFolder': 'フォルダ',
  'designFiles.folderCount': '{n} ファイル',
  'designFiles.newFolderTitle': '新しいフォルダ',
  'designFiles.newFolderLabel': 'フォルダ名',
  'designFiles.moveTitle': 'フォルダに移動',
  'designFiles.moveLabel': '移動先フォルダ',
  'designFiles.moveRoot': 'プロジェクトのルート',
  'designFiles.moveNewFolder': '新しいフォルダ…',
  'designFiles.move': '移動',
  'designFiles.copyPath': 'パスをコピー',
  'designFiles.copiedPath': 'パスをコピーしました',
  'designFiles.copyLocalPath': 'ローカルファイルパスをコピー',
  'designFiles.copiedLocalPath': 'ローカルファイルパスをコピーしました',
  'designFiles.deleteFolderConfirm': 'フォルダ「{name}」とそのすべての内容を削除しますか?',
  'designFiles.folderCreated': 'フォルダ「{name}」を作成しました',
  'designFiles.folderDeleted': 'フォルダ「{name}」を削除しました',
  'designFiles.filesMoved': '{n} 件を {dest} に移動しました',
  'designFiles.colName': '名前',
  'designFiles.colKind': '種類',
  'designFiles.colModified': '更新日',
  'designFiles.perPage': '表示',
  'designFiles.all': 'すべて',
  'designFiles.prev': '前へ',
  'designFiles.next': '次へ',
  'designFiles.jumpToPage': 'ページにジャンプ',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'designFiles.sectionFolders': 'フォルダ',
  'designFiles.sectionStylesheets': 'スタイルシート',
  'designFiles.sectionDocuments': 'ドキュメント',
  'designFiles.kindStylesheet': 'スタイルシート',
  'designFiles.modifiedExt': '更新日時 {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': '役立つ情報',
  'designFiles.usefulInfoTip': 'ファイルをダブルクリックすると、フルタブで開きます。',
  'designFiles.usefulInfoTip2': 'チャットで @ を入力すると、ファイルをコンテキストとして参照できます。',
  'designFiles.usefulInfoTip4': 'デザインシステムを選ぶと、ブランドに沿ったデザインを生成できます。',
  'designFiles.usefulInfoTip5': 'アイデアに迷ったら、ホームのコミュニティにあるプラグインテンプレートをお試しください。',
  'designFiles.usefulInfoTip6': '質問やご意見は、Discord でお気軽にどうぞ。',
  'designFiles.usefulInfoTip7': '気に入ったら、GitHub でスターをお願いします。',
  'designFiles.usefulInfoTip8': 'X で @OpenDesignHQ をフォローして最新情報をチェック。',
  'designFiles.usefulInfoTip9': '画像やドキュメント、フォルダーごとこのパネルにドラッグすると、エージェントがコンテキストとして使用します。',
  'designFiles.usefulInfoTip10': 'スケッチ機能でラフなレイアウトを描くと、エージェントがそれを元に生成します。',
  'designFiles.usefulInfoTip11': 'プレビューで要素を選択してコメントすると、エージェントがその箇所を修正します。',
  'designFiles.usefulInfoTip12': '結果がいまいち？言葉で説明し直すより、プレビューで囲んで指示するほうが速いです。',
  'designFiles.usefulInfoTip13': 'デザインは PDF・画像・単体 HTML にワンクリックで書き出せます。',
  'designFiles.usefulInfoTip14': '気に入ったプロジェクトは「共有」メニューからテンプレートとして保存し、再利用できます。',
  'designFiles.usefulInfoTip15': 'デプロイ後は、SNS シェア用カードをすぐに生成できます。',
  'designFiles.usefulInfoTip16': 'Threads で @opendesign.ai をフォローして、舞台裏の最新情報をチェック。',
  'designFiles.usefulInfoTip17': 'Instagram で @opendesign.ai をフォローして、デザインのヒントを。',
  'designFiles.usefulInfoTip18': 'YouTube で OpenDesign を登録して、チュートリアルやデモを視聴。',
  'designFiles.usefulInfoTip19': 'LinkedIn で OpenDesign をフォローして、製品ニュースをチェック。',
  'designFiles.usefulInfoTip20': 'Xiaohongshu で OpenDesign をフォローして、ヒントとインスピレーションを。',
  'quickSwitcher.placeholder': 'ファイルを開く…',
  'quickSwitcher.empty': 'このプロジェクトにファイルがありません',
  'quickSwitcher.noMatches': '一致なし',
  'quickSwitcher.navigate': '移動',
  'quickSwitcher.open': '開く',
  'quickSwitcher.close': '閉じる',
  'sketch.save': 'スケッチを保存',
  'sketch.cancel': 'キャンセル',
  'sketch.saving': '保存中…',
  'sketch.saved': '保存済み',
  'sketch.tooltipMainMenu': 'メインメニュー: 保存、書き出し、ヘルプ、キャンバス設定',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': '未保存の変更があります',
  'sketch.tooltipClean': '保存済み',
  'fileViewer.empty': 'ファイルを選択して表示します。',
  'fileViewer.loading': '読み込み中…',
  'fileViewer.exportPptx': 'PPTX としてエクスポート',
  'fileViewer.openInNewTab': '新しいタブで開く',
  'fileViewer.copyPath': 'パスをコピー',
  'fileViewer.copied': 'コピーしました！',
  'fileViewer.share': '共有',
  'fileViewer.binaryMeta': 'バイナリ · {size}',
  'fileViewer.binaryNote': 'バイナリファイル（{size} バイト）。ダウンロードするかディスクから開いて確認してください。',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'ドキュメント',
  'fileViewer.presentationMeta': 'プレゼンテーション',
  'fileViewer.spreadsheetMeta': 'スプレッドシート',
  'fileViewer.previewUnavailable': 'プレビューは利用できません。ファイルをダウンロードするか開いて確認してください。',
  'fileViewer.download': 'ダウンロード',
  'fileViewer.open': '開く',
  'fileViewer.imageMeta': '画像 · {size}',
  'fileViewer.reactMeta': 'React コンポーネント · {size}',
  'fileViewer.sketchMeta': 'スケッチ · {size}',
  'fileViewer.markdownStreamingMeta': 'ストリーミングプレビュー中…',
  'fileViewer.markdownErrorMeta': 'プレビューが不完全な場合があります（生成エラー）。',
  'fileViewer.markdownStreamingStatus': 'ストリーミング中… 部分的な Markdown を表示しています。',
  'fileViewer.markdownErrorStatus': '生成エラー。最後に利用可能なコンテンツを表示しています。',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': '動画 · {size}',
  'fileViewer.audioMeta': '音声 · {size}',
  'fileViewer.reload': '再読み込み',
  'fileViewer.reloadDisk': 'ディスクから再読み込み',
  'fileViewer.copy': 'コピー',
  'fileViewer.copyTitle': 'ファイルの内容をコピー',
  'fileViewer.saveDisabled': '保存（読み取り専用ビューアー）',
  'fileViewer.save': '保存',
  'fileViewer.preview': 'プレビュー',
  'fileViewer.source': 'ソース',
  'fileViewer.tweaks': '調整',
  'fileViewer.tweaksUnavailable': 'このアーティファクトには調整パネルがありません',
  'fileViewer.jsxModuleTitle': '単独プレビューはありません',
  'fileViewer.jsxModuleBody': 'このファイルは別のページから読み込まれるコンポーネントモジュールです。',
  'fileViewer.jsxModuleCta': '表示するページを開いてください:',
  'fileViewer.comment': 'コメント',
  'fileViewer.edit': '編集',
  'fileViewer.draw': '描画',
  'fileViewer.mark': 'マーク',
  'fileViewer.markTool': 'マークツール',
  'fileViewer.boxSelect': '範囲選択',
  'fileViewer.textTool': 'テキスト',
  'fileViewer.textAnnotationRemove': 'テキストを削除',
  'fileViewer.screenshot': 'スクリーンショット',
  'fileViewer.versions.entry': 'バージョン',
  'fileViewer.versions.entryFull': 'バージョン履歴',
  'fileViewer.versions.title': 'バージョン',
  'fileViewer.versions.countOne': '1件のバージョン',
  'fileViewer.versions.countMany': '{count}件のバージョン',
  'fileViewer.versions.current': '現在',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'バージョン {version}',
  'fileViewer.versions.listAria': 'ファイルのバージョン',
  'fileViewer.versions.loading': 'バージョンを読み込み中...',
  'fileViewer.versions.empty': 'まだバージョンはありません。',
  'fileViewer.versions.loadFailed': 'バージョンを読み込めませんでした。',
  'fileViewer.versions.previewFailed': 'このバージョンのプレビューを読み込めませんでした。',
  'fileViewer.versions.previewLoading': 'バージョンプレビューを読み込み中...',
  'fileViewer.versions.noPrompt': '記録されたプロンプトはありません',
  'fileViewer.versions.noPromptBody': 'このバージョンにはプロンプトが記録されていません。',
  'fileViewer.versions.promptTitle': 'プロンプト',
  'fileViewer.versions.copyPrompt': 'プロンプトをコピー',
  'fileViewer.versions.fullscreen': '全画面プレビュー',
  'fileViewer.versions.open': 'プレビューを新しいウィンドウで開く',
  'fileViewer.versions.currentHelp': 'これはすでに現在のバージョンです。',
  'fileViewer.versions.restoreHelp': '切り替えると、このHTMLが新しい現在のバージョンとして復元されます。',
  'fileViewer.versions.restore': 'このバージョンに切り替える',
  'fileViewer.versions.restoreConfirmTitle': 'このバージョンに切り替えますか？',
  'fileViewer.versions.restoreConfirmCta': '切り替える',
  'fileViewer.versions.restoring': '切り替え中...',
  'fileViewer.versions.restoreFailed': 'このバージョンに切り替えられませんでした。',
  'fileViewer.versions.restoreSuccess': 'このバージョンに切り替えました。',
  'fileViewer.editScreenshotToChat': 'スクリーンショットをチャットへ',
  'manualEdit.layers': 'レイヤー',
  'manualEdit.editableCount': '{count} 件編集可能',
  'manualEdit.hiddenBadge': '非表示',
  'manualEdit.title': '手動エディター',
  'manualEdit.fallbackTitle': '編集',
  'manualEdit.movePanel': '編集パネルを移動',
  'manualEdit.editParams': 'パラメーターを編集',
  'manualEdit.closePanel': '編集パネルを閉じる',
  'manualEdit.selectLayer': 'レイヤーを選択',
  'manualEdit.empty': 'プレビュー内の要素をクリックするか、レイヤーを選択してください。',
  'manualEdit.noEditableLayers': '編集可能なレイヤーが見つかりません。',
  'manualEdit.noClass': 'クラスなし',
  'manualEdit.tabsAria': '手動編集タブ',
  'manualEdit.tabContent': 'コンテンツ',
  'manualEdit.tabStyle': 'スタイル',
  'manualEdit.tabAttributes': '属性',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': 'ソース',
  'manualEdit.attributesJson': '属性 JSON',
  'manualEdit.selectedHtml': '選択中の要素の HTML',
  'manualEdit.fullSource': 'アーティファクト全体のソース',
  'manualEdit.applyContent': 'コンテンツを適用',
  'manualEdit.applyStyle': 'スタイルを適用',
  'manualEdit.applyAttributes': '属性を適用',
  'manualEdit.applyHtml': 'HTML を適用',
  'manualEdit.applySource': 'ソースを適用',
  'manualEdit.invalidAttributes': '属性 JSON が無効です。',
  'manualEdit.changes': '変更',
  'manualEdit.undo': '元に戻す',
  'manualEdit.redo': 'やり直す',
  'manualEdit.noChanges': 'まだ手動編集はありません。',
  'manualEdit.imageUrl': '画像 URL',
  'manualEdit.altText': '代替テキスト',
  'manualEdit.label': 'ラベル',
  'manualEdit.text': 'テキスト',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': '文字色',
  'manualEdit.background': '背景',
  'manualEdit.fontSize': 'フォントサイズ',
  'manualEdit.weight': '太さ',
  'manualEdit.align': '配置',
  'manualEdit.textAlignLeft': '左揃え',
  'manualEdit.textAlignCenter': '中央揃え',
  'manualEdit.textAlignRight': '右揃え',
  'manualEdit.padding': 'パディング',
  'manualEdit.margin': 'マージン',
  'manualEdit.radius': '角丸',
  'manualEdit.referenceValues': '参照値',
  'manualEdit.referenceValuesEmpty': '一致する参照値はありません',
  'manualEdit.referenceValuesLoading': '読み込み中…',
  'manualEdit.lineHeight': '行の高さ',
  'manualEdit.letterSpacing': '字間',
  'manualEdit.borderStyle': '枠線のスタイル',
  'manualEdit.borderStyleSolid': '実線',
  'manualEdit.borderStyleDashed': '破線',
  'manualEdit.borderStyleDotted': '点線',
  'manualEdit.borderStyleDouble': '二重線',
  'manualEdit.borderStyleNone': 'なし',
  'manualEdit.border': '枠線',
  'manualEdit.width': '幅',
  'manualEdit.minHeight': '最小の高さ',
  'manualEdit.deleteElement': '要素を削除',
  'manualEdit.deleteElementConfirm': '選択した要素を削除しますか？「元に戻す」で取り消せます。',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': '画像をアップロード',
  'manualEdit.uploadingImage': '画像をアップロード中…',
  'manualEdit.uploadImageFailed': '画像をアップロードできませんでした。',
  'manualEdit.focusSlides': 'スライドにフォーカス',
  'manualEdit.showPanels': 'パネルを表示',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'ズームアウト',
  'fileViewer.zoomIn': 'ズームイン',
  'fileViewer.resetZoom': 'ズームをリセット',
  'fileViewer.viewportAria': 'プレビューのビューポート',
  'fileViewer.viewportDesktop': 'デスクトップ',
  'fileViewer.viewportDesktopTitle': '全幅デスクトッププレビュー',
  'fileViewer.viewportTablet': 'タブレット',
  'fileViewer.viewportTabletTitle': 'タブレットプレビュー 820 × 1180（最新の縦向き基準）',
  'fileViewer.viewportMobile': 'モバイル',
  'fileViewer.viewportMobileTitle': 'モバイルプレビュー 390 × 844',
  'fileViewer.reloadAria': '再読み込み',
  'fileViewer.previousSlide': '前のスライド',
  'fileViewer.nextSlide': '次のスライド',
  'fileViewer.slideNavAria': 'スライドナビゲーション',
  'fileViewer.speakerNotes': 'スピーカーノート',
  'fileViewer.speakerNotesSlide': 'スライド {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'このスライドにはスピーカーノートがありません。',
  'fileViewer.speakerNotesEdit': '編集',
  'fileViewer.speakerNotesSave': 'ノートを保存',
  'fileViewer.speakerNotesSaving': '保存中…',
  'fileViewer.speakerNotesSaved': '保存済み',
  'fileViewer.speakerNotesSaveFailed': 'スピーカーノートを保存できませんでした。',
  'fileViewer.speakerNotesPlaceholder': 'このスライドのスピーカーノートを追加…',
  'fileViewer.previewAssetBlockedTitle': 'プレビューアセットがブロックされました',
  'fileViewer.previewAssetBlockedDetail': '{filePath} を読み込めませんでした。外部シンボリックリンクをこのプロジェクト内のファイルに置き換えてください。',
  'fileViewer.presenterReset': 'リセット',
  'fileViewer.present': 'プレゼン',
  'fileViewer.presentInTab': 'このタブで',
  'fileViewer.presentFullscreen': 'フルスクリーン',
  'fileViewer.presentNewTab': '新しいタブ',
  'fileViewer.presentFromBeginning': '最初から開始',
  'fileViewer.presentFromCurrentSlide': '現在のスライドから開始',
  'fileViewer.presenterMode': '発表者モード',
  'fileViewer.exitPresentation': 'プレゼンを終了',
  'fileViewer.shareLabel': '共有',
  'fileViewer.shareMenuShareLink': '共有',
  'fileViewer.shareMenuPublishOnline': '自社ホスティングで共有',
  'fileViewer.shareMenuDownload': 'ダウンロード',
  'fileViewer.shareMenuPresentation': 'プレゼンテーション',
  'fileViewer.shareMenuSourceFiles': 'ソースファイル',
  'fileViewer.shareMenuSave': '保存',
  'fileViewer.shareMenuPublishViaOd': 'クイック共有（OpenDesign ホスティング）',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': '共有リンクを作成',
  'fileViewer.publishSingleFileDescription': 'リンクを知っている人は誰でもオンラインで閲覧できます。現在は単一ファイルのみ共有でき、画像などの埋め込みローカルアセットには未対応です。',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': '作成中…',
  'fileViewer.unpublishFile': '共有を停止',
  'fileViewer.shareEmptyStateTitle': '共有できるものがまだありません',
  'fileViewer.shareEmptyStateDescription': 'チームを作成または参加すると、このファイルをメンバーと共有できます',
  'fileViewer.shareEmptyStateCreateTeam': 'チームを作成',
  'fileViewer.shareTeamMissingTitle': '共有できるチームがまだありません',

  'fileViewer.publishFileRequiresTeam': '公開リンクの発行にはチームワークスペースが必要です。チームワークスペースに切り替えるか、デプロイでこのファイルを公開してください。',
  'fileViewer.publishFileRequiresWorkspace': '共有リンクの作成にはサインイン済みのワークスペースが必要です。OpenDesign Cloud にサインインするか、デプロイでこのファイルを共有してください。',
  'fileViewer.publishFileFailed': '共有リンクを作成できませんでした。再試行するか、下のデプロイ方法をお試しください。',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': '共有リンクをコピー',
  'fileViewer.openSharePage': '共有ページを開く',
  'fileViewer.shareLinkRequiresDeploy': 'リンクを取得するには先にオンライン公開してください',
  'fileViewer.shareLinkPublishGuide': '上でオンライン公開すると共有できます ↑',
  'fileViewer.shareAfterGenerationComplete': '生成完了後に共有できます',
  'fileViewer.copyProviderLink': '{provider} リンクをコピー',
  'fileViewer.copyCloudflareLink': 'Cloudflare リンクをコピー',
  'fileViewer.screenshotCopying': 'スクリーンショットをコピー中…',
  'fileViewer.screenshotCopied': 'スクリーンショットをクリップボードにコピーしました',
  'fileViewer.screenshotClipboardDenied': 'ブラウザがクリップボードへのアクセスをブロックしました',
  'fileViewer.screenshotPreviewLoading': 'プレビューを読み込み中です。しばらくしてからもう一度お試しください。',
  'fileViewer.screenshotCaptureFailed': 'プレビューをキャプチャできませんでした。もう一度お試しください。',
  'fileViewer.exportPdf': 'PDFとしてエクスポート',
  'fileViewer.exportPdfAllSlides': 'PDFとしてエクスポート（全スライド）',
  'fileViewer.exportPptxBusy': '現在のターンが終わるまでお待ちください。',
  'fileViewer.exportPptxHint': 'エージェントにこのデザインを PPTX に変換するようリクエストを送信します。',
  'fileViewer.exportPptxNa': 'ここでは PPTX エクスポートは利用できません。',
  'fileViewer.exportDaemonUnreachable': 'デーモンに接続できませんでした。もう一度お試しください。',
  'fileViewer.exportZip': '.zip としてダウンロード',
  'fileViewer.exportHtml': 'スタンドアロン HTML としてエクスポート',
  'fileViewer.exportMd': 'Markdown としてエクスポート',
  'fileViewer.exportImage': '画像としてエクスポート',
  'fileViewer.exportPptxImages': 'PPTX（画像）として書き出し',
  'fileViewer.exportPptxEditable': 'PPTX（編集可能）として書き出し',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': '書き出し中…',
  'fileViewer.exportSlideProgress': 'スライド {current}/{total} を書き出し中…',
  'fileViewer.exportingElapsed': '書き出し中… {seconds}秒',
  'fileViewer.exportSlideEta': 'スライド {current}/{total} を書き出し中 · 残り約 {seconds}秒',
  'fileViewer.exportFailedTitle': '書き出しに失敗しました',
  'fileViewer.exportFailedDescription': '今回の書き出しは完了しませんでした。もう一度お試しください。',
  'fileViewer.exportDone': '書き出しが完了しました',
  'fileViewer.exportImageFailed': '画像のキャプチャに失敗しました。再試行するか、ブラウザのスクリーンショット機能をご利用ください。',
  'fileViewer.exportImageModalSubtitle': '形式を選択して、現在のプレビューを画像としてダウンロードします。',
  'fileViewer.exportImageFormatLabel': '形式',
  'fileViewer.exportImageSaving': '画像を保存中…',
  'fileViewer.exportImageSaved': '画像を保存しました',
  'fileViewer.exportImageDownloadStarted': 'ダウンロードを開始しました',
  'fileViewer.exportImageDownloadDetails': '保存ダイアログが表示されなかった場合は、ブラウザのダウンロードフォルダで {filename} を確認してください。',
  'fileViewer.exportJsx': 'JSX としてエクスポート',
  'fileViewer.exportReactHtml': 'プレビューを HTML としてエクスポート',
  'fileViewer.exportStarted': 'エクスポートを開始しました',
  'fileViewer.saveAsTemplate': 'テンプレートとして保存…',
  'fileViewer.savingTemplate': 'テンプレートを保存中…',
  'fileViewer.savedTemplate': '"{name}" として保存しました',
  'fileViewer.savedTemplateFail': 'テンプレートを保存できませんでした — もう一度試してください。',
  'fileViewer.templateNamePrompt': 'テンプレート名',
  'fileViewer.templateNameDefault': '無題のテンプレート',
  'fileViewer.templateDescPrompt': '短い説明（省略可 — このテンプレートの使いどころは？）',
  'liveArtifact.refresh.button': '更新',
  'liveArtifact.refresh.buttonTitle': 'このライブアーティファクトを更新',
  'liveArtifact.refresh.loadingTitle': 'ライブアーティファクトを読み込み中…',
  'liveArtifact.refresh.noSourceTitle': '利用可能な更新ソースがまだありません。',
  'liveArtifact.refresh.running': '更新中…',
  'liveArtifact.refresh.runningMessage': 'データとプレビューを更新しています。少し時間がかかる場合があります。',
  'liveArtifact.refresh.runningAction': '更新が成功するまで、前のプレビューが表示されたままになります。',
  'liveArtifact.refresh.successOne': '更新が完了しました。データを更新しました。',
  'liveArtifact.refresh.successMany': '更新が完了しました。データを更新しました。',
  'liveArtifact.refresh.successAction': '最新のコミット済みデータでプレビューを再読み込みしました。',
  'liveArtifact.refresh.previousFailure': '前回の更新に失敗しました: {message}',
  'liveArtifact.refresh.failureAction': '更新履歴を確認し、ソースまたは権限の問題を修正してから、もう一度お試しください。',
  'liveArtifact.refresh.networkFailure': '更新リクエストに失敗しました。接続を確認して、もう一度お試しください。',
  'liveArtifact.refresh.genericFailure': '更新に失敗しました。',
  'liveArtifact.refresh.statusNever': '更新不可',
  'liveArtifact.refresh.statusReady': '更新可能',
  'liveArtifact.refresh.statusSucceeded': '最新の状態',
  'liveArtifact.refresh.statusFailed': '更新に失敗',
  'liveArtifact.refresh.statusRunning': '更新中',
  'liveArtifact.refresh.statusRunningDescription': '現在、更新の実行が進行中です。',
  'liveArtifact.refresh.statusSucceededDescription': '前回の更新は正常に完了しました。',
  'liveArtifact.refresh.statusFailedDescription': '前回の更新は正常に完了しませんでした。',
  'liveArtifact.refresh.statusReadyDescription': '更新可能なソースが設定されていますが、実行は進行していません。',
  'liveArtifact.refresh.statusNeverDescription': 'このライブアーティファクトにはまだ更新ソースがありません。',
  'liveArtifact.refresh.eventStarted': '開始',
  'liveArtifact.refresh.eventSucceeded': '成功',
  'liveArtifact.refresh.eventFailed': '失敗',
  'liveArtifact.refresh.eventStartedDetail': '更新を開始しました…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n}件のソースを更新',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n}件のソースを更新',
  'liveArtifact.refresh.timelineEmpty': 'このセッションではまだ更新アクティビティがありません。更新を実行してタイムラインを記録するか、自動実行をお待ちください。',
  'liveArtifact.refresh.heroLastRefreshedLabel': '最終更新',
  'liveArtifact.refresh.heroLastRefreshedNever': 'なし',
  'liveArtifact.refresh.justNow': 'たった今',
  'liveArtifact.refresh.factCreated': '作成日時',
  'liveArtifact.refresh.factLastUpdated': '最終更新',
  'liveArtifact.refresh.factUnknown': '不明',
  'liveArtifact.refresh.persistedTitle': '保存された更新履歴',
  'liveArtifact.refresh.persistedHint': 'refreshes.jsonl から読み込まれたエントリ',
  'liveArtifact.refresh.persistedEmpty': '保存された更新履歴はまだありません。',
  'liveArtifact.refresh.persistedStatusSucceeded': '成功',
  'liveArtifact.refresh.persistedStatusRunning': '実行中',
  'liveArtifact.refresh.persistedStatusFailed': '失敗',
  'liveArtifact.refresh.persistedStatusCancelled': 'キャンセル',
  'liveArtifact.refresh.persistedStatusSkipped': 'スキップ',
  'liveArtifact.refresh.sessionTitle': 'セッションアクティビティ',
  'liveArtifact.refresh.sessionHint': 'このタブを開いている間に観測されたイベント',
  'liveArtifact.refresh.docSourceTitle': 'ドキュメントソース',
  'liveArtifact.refresh.docSourceHint': 'ソースを設定済み',
  'liveArtifact.refresh.docSourceType': 'タイプ',
  'liveArtifact.refresh.docSourceTool': 'ツール',
  'liveArtifact.refresh.docSourceConnector': 'コネクタ',
  'liveArtifact.refresh.debugSummary': '高度なデバッグメタデータ',
  'liveArtifact.refresh.debugNote': 'コネクタID、ファイル名、ソースメタデータ、内部アーティファクトパスが含まれる場合があります。',
  'liveArtifact.viewer.tabPreview': 'プレビュー',
  'liveArtifact.viewer.tabCode': 'コード',
  'liveArtifact.viewer.tabData': 'データ',
  'liveArtifact.viewer.tabRefreshHistory': '更新履歴',
  'liveArtifact.viewer.dataEmpty': 'data.json キャッシュはありません。',
  'liveArtifact.viewer.code.templateHeading': 'テンプレート HTML',
  'liveArtifact.viewer.code.renderedHeading': 'レンダリング済み HTML',
  'liveArtifact.viewer.code.templateHelp': 'data.json と共にプレビュー生成に使われる編集可能なテンプレートです。',
  'liveArtifact.viewer.code.renderedHelp': 'プレビューで現在読み込まれている生成済み index.html です。',
  'liveArtifact.viewer.code.variantAria': 'コードの種類',
  'liveArtifact.viewer.code.variantTemplate': 'テンプレート',
  'liveArtifact.viewer.code.variantRendered': 'レンダリング済み',
  'liveArtifact.viewer.code.loading': 'コードを読み込み中…',
  'liveArtifact.viewer.code.unavailable': 'コードはまだ利用できません。',
  'liveArtifact.viewer.code.empty': 'このコードファイルは空です。',
  'fileViewer.deployToVercel': 'Vercel にデプロイ',
  'fileViewer.redeployToVercel': '再デプロイ',
  'fileViewer.deployingToVercel': 'Vercel にデプロイ中…',
  'fileViewer.deployProviderLabel': 'プロバイダー',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'ターゲット',
  'fileViewer.deployTargetPreview': 'プレビュー',
  'fileViewer.deployTargetProduction': '本番環境',
  'fileViewer.deployToProvider': '{provider} にデプロイ',
  'fileViewer.redeployToProvider': '{provider} に再デプロイ',
  'fileViewer.deployingToProvider': '{provider} にデプロイ中…',
  'fileViewer.preparingPublicLink': '公開リンクを準備中…',
  'fileViewer.copyDeployLink': 'リンクをコピー',
  'fileViewer.deployModalTitle': 'デプロイ',
  'fileViewer.deployModalSubtitle': '選択したプロバイダーのアカウントを使用して、この HTML プレビューをデプロイします。',
  'fileViewer.vercelToken': 'Vercel トークン',
  'fileViewer.vercelTokenGetLink': 'Vercel トークンを取得',
  'fileViewer.vercelTokenPlaceholder': 'Vercel トークンを貼り付け',
  'fileViewer.vercelTokenReuseHint': '保存済みトークンが使用されます。新しいトークンを入力すると置き換えられます。',
  'fileViewer.vercelTokenRequired': '最初に Vercel トークンを入力して保存してください。',
  'fileViewer.cloudflareApiToken': 'Cloudflare API トークン',
  'fileViewer.cloudflareApiTokenGetLink': 'API トークンを取得',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cloudflare API トークンを貼り付け',
  'fileViewer.cloudflareApiTokenReuseHint': '保存済みの Cloudflare API トークンが使用されます。新しいトークンを入力すると置き換えられます。',
  'fileViewer.cloudflareApiTokenRequired': '最初に Cloudflare API トークンを入力して保存してください。',
  'fileViewer.cloudflareApiTokenScopeHint': 'API トークン作成時に Pages Edit を選択してください。カスタムドメインには Zone Read / DNS Edit が必要です。',
  'fileViewer.vercelTeamId': 'チーム ID',
  'fileViewer.vercelTeamSlug': 'チームスラッグ',
  'fileViewer.cloudflareAccountId': 'アカウント ID',
  'fileViewer.cloudflareAccountIdHint': 'Cloudflare ダッシュボードでアカウント ID を確認できます。',
  'fileViewer.cloudflareAccountIdRequired': '最初に Cloudflare Account ID を入力して保存してください。',
  'fileViewer.cloudflareZoneLabel': 'ドメイン',
  'fileViewer.cloudflareZonePlaceholder': 'Cloudflare 設定を保存するとドメインが読み込まれます',
  'fileViewer.cloudflareZoneRequired': '先に Cloudflare ドメインを選択してください。',
  'fileViewer.cloudflareZonesLoading': 'Cloudflare ドメインを読み込み中…',
  'fileViewer.cloudflareZonesRefresh': 'ドメインを更新',
  'fileViewer.cloudflareZonesLoadFailed': 'Cloudflare ドメインを読み込めませんでした。',
  'fileViewer.cloudflareZonesEmpty': 'このアカウントでは有効なフル Cloudflare ドメインが見つかりませんでした。',
  'fileViewer.cloudflareDomainPrefixLabel': 'サブドメインのプレフィックス',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'DNS ラベルは1つのみ使用してください：英小文字、数字、ハイフン。',
  'fileViewer.cloudflareHostnamePreview': 'カスタムドメインのプレビュー：{hostname}',
  'fileViewer.cloudflareCustomDomainHint': '任意: カスタムドメインを紐付けます。空欄のままでも pages.dev リンクは作成されます。',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'カスタムドメイン',
  'fileViewer.optional': '省略可',
  'fileViewer.vercelPreviewOnly': 'デプロイは現在 Preview のみです。',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages は Direct Upload を使用します。',
  'fileViewer.savingConfig': '保存中…',
  'fileViewer.deployConfigSaveFailed': 'Vercel の設定を保存できませんでした。',
  'fileViewer.deployFailed': 'デプロイに失敗しました。Vercel の設定を確認して再試行してください。',
  'fileViewer.deployProviderConfigSaveFailed': '{provider} の設定を保存できませんでした。',
  'fileViewer.deployProviderFailed': '{provider} のデプロイに失敗しました。設定を確認して再試行してください。',
  'fileViewer.deployResultLabel': 'デプロイ URL',
  'fileViewer.deployLinkReady': '準備完了',
  'fileViewer.deploySuccessToast': 'デプロイを正常にアップロードしました',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': '公開リンク準備中',
  'fileViewer.deployLinkDelayed': 'サイトはデプロイされました。プロバイダーが公開リンクを準備中です。',
  'fileViewer.deployLinkFailed': 'カスタムドメインに失敗しました',
  'fileViewer.deployLinkProtectedLabel': 'デプロイ保護が有効',
  'fileViewer.deployLinkProtected': 'サイトはデプロイされましたが、このプレビューリンクには認証が必要です。Deployment Protection を無効にするか、カスタムドメインを使用してください。',
  'fileViewer.retryLink': '今すぐ再試行',
  'questionForm.submit': '送信',
  'questionForm.skip': 'スキップ',
  'questionForm.locked': '回答済み',
  'tool.openInTab': '{name} をタブで開く',
  'tool.open': '開く',
  'tool.todos': 'To-Do',
  'tool.todosExpand': 'タスクを表示',
  'tool.todosCollapse': 'タスクを非表示',
  'tool.todosDone': '完了',
  'tool.todosDismiss': 'タスクリストを閉じる',
  'tool.write': '書き込み',
  'tool.edit': '編集',
  'tool.read': '読み取り',
  'tool.delete': '削除',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'フェッチ',
  'tool.search': '検索',
  'tool.lines': '{n} 行',
  'tool.changeSingular': '変更',
  'tool.changePlural': '変更',
  'tool.in': '{path} 内',
  'tool.hide': '隠す',
  'tool.output': '出力',
  'tool.running': '実行中…',
  'tool.error': 'エラー',
  'tool.done': '完了',
  'assistant.role': 'アシスタント',
  'assistant.workingLabel': '作業中',
  'assistant.doneLabel': '完了',
  'assistant.awaitingReplyLabel': '返信待ち',
  'assistant.canceledLabel': 'タスクを停止しました',
  'assistant.canceledDetail': '今回の実行はあなたの操作により停止しました。',
  'assistant.copyMarkdown': 'コピー',
  'assistant.forkConversation': '新しい会話',
  'assistant.forkingConversation': '新しい会話を開始中…',
  'assistant.forkNote': '前の会話からの続き',
  'assistant.shareToOpenDesign': 'OpenDesign に共有',
  'assistant.shareToOpenDesignBusy': 'パッケージを準備中…',
  'assistant.feedbackPrompt': 'フィードバック',
  'assistant.feedbackPositive': '役に立った',
  'assistant.feedbackNegative': '役に立たなかった',
  'assistant.feedbackReasonTitle': '理由をお聞かせください',
  "assistant.feedbackReasonTitleNegative": "どこが問題でしたか?",
  "assistant.feedbackDiscordNegative": "{discord} で詳しい状況を共有してください。チームが原因を把握して直接フォローできます。",
  "assistant.feedbackDiscordPositive": "作ったものを {discord} コミュニティで共有するか、スクリーンショットと一緒に良かった点を教えてください。",
  'assistant.feedbackReasonPositiveMatched': '要望どおりだった',
  'assistant.feedbackReasonPositiveVisual': '見た目が良い',
  'assistant.feedbackReasonPositiveUseful': '構造が役立つ',
  'assistant.feedbackReasonPositiveEasy': '編集を続けやすい',
  'assistant.feedbackReasonPositiveDesignSystem': 'デザインシステムに準拠している',
  'assistant.feedbackReasonNegativeMissed': '指示どおりに修正されていない',
  'assistant.feedbackReasonNegativeVisual': '見た目に一貫性がない',
  'assistant.feedbackReasonNegativeIncomplete': '出力が不完全',
  'assistant.feedbackReasonNegativeHard': '使いにくい',
  'assistant.feedbackReasonNegativeCouldNotRun': '実行できない',
  'assistant.feedbackReasonNegativeTooSlow': '遅すぎる',
  'assistant.feedbackReasonNegativeDesignSystem': 'デザインシステムに準拠していない',
  'assistant.feedbackReasonOther': 'その他',
  'assistant.feedbackReasonPlaceholder': '補足する（任意）',
  'assistant.feedbackReasonSubmit': '送信',
  "assistant.emptyResponseLabel": "タスクを完了できませんでした",
  "assistant.emptyResponseMessage": "今回のタスクの実行に失敗しました。もう一度お試しください。再度失敗する場合は、サポートにお問い合わせください。",
  'assistant.unfinishedLabel': 'タスクはまだ完了していません',
  'assistant.unfinishedDetail': '今回のタスクには未完了の項目が {n} 件あります。',
  'assistant.unfinishedSummary': '{n} 件のタスクが残っています',
  'assistant.unfinishedMore': '+{n} 件',
  'assistant.continueRemaining': '残りのタスクを続ける',
  'chat.resumeRunCta': '実行を続ける',
  'chat.runError.contactSupportCta': "お問い合わせ",
  'chat.runError.exportLogsCta': "ログを書き出す",
  'chat.runError.switchModelCta': "モデルを変更",
  'chat.runError.openSettingsCta': '設定を開く',
  "chat.runError.title.readOnlyAccess": "プロジェクトの編集権限がありません",
  "chat.runError.title.messagesUnavailable": "会話の内容を読み込めませんでした",
  "chat.runError.actionBlocked.readOnly": "現在、このプロジェクトの閲覧権限のみがあるため、タスクを実行できません。",
  "chat.runError.actionBlocked.messagesUnavailable": "現在、会話の内容を読み取れません。もう一度お試しください。再び失敗する場合は、サポートにお問い合わせください。",
  'chat.runError.actionBlocked.billing': "このプロジェクトの費用を負担するワークスペースを確認しています。しばらくしてからお試しください。",
  'chat.runError.actionBlocked.busy': "この会話ではまだ実行中のタスクがあります。終了後に再試行できます。",
  'chat.support.channel.feishu': "Feishu コミュニティ",
  'chat.support.channel.discord': "Discord",
  'chat.amrBalanceOwner.title': 'チームの残高が不足しています',
  'chat.amrBalanceOwner.message': 'チームの残高が不足しています。チーム管理者にチャージまたはサブスクリプションのアップグレードを依頼してください。',
  'chat.amrBalanceOwner.messageNoOwnerName': 'チームの残高が不足しています。チーム管理者にチャージまたはサブスクリプションのアップグレードを依頼してください。',
  'chat.amrBalanceOwner.dismissCta': "了解",
  'assistant.outTokens': '{n} 出力',
  'assistant.producedFiles': 'このターンのファイル',
  'assistant.openFile': '開く',
  'assistant.downloadFile': 'ダウンロード',
  "nextStep.imageContinue": "さらに改善",
  "nextStep.imageVariants": "バリエーション生成 / 別のセット",
  "nextStep.imageStyle": "スタイル / 構図を調整",
  'nextStep.title': '次のステップ',
  'nextStep.suggestionsLabel': '次のステップの提案',
  'nextStep.more': 'もっと見る',
  'nextStep.share': '共有',
  'nextStep.download': 'ダウンロード',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'コミュニティに貢献',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'デザインを作成中...',
  'assistant.thinking': '考え中',
  'assistant.thought': '思考完了',
  'assistant.thoughtFor': '{s}秒間思考',
  'assistant.designSystemDirectionLocked': '有効なデザインシステムが選択されています。ビジュアルの方向性はすでに確定しています。',
  'assistant.waitingFirstOutput': '最初の出力を待っています',
  'assistant.statusBootingAgent': 'エージェントを起動中',
  'assistant.statusPreparing': '準備中...',
  'assistant.statusStarting': '開始中',
  'assistant.statusRequesting': 'リクエストを送信中',
  'assistant.statusThinking': '考え中',
  'assistant.statusStreaming': 'ストリーミング中',
  'assistant.statusCompactingContext': 'コンテキストを圧縮中',
  'assistant.slowHint': '通常より時間がかかっています。フォームは通常 5〜10 秒で表示されます — 停止して言い換えることもできます。',
  'assistant.verbEditing': '編集中',
  'assistant.verbWriting': '生成中',
  'assistant.verbReading': '読み取り中',
  'assistant.verbSearching': '検索中',
  'assistant.verbRunning': '実行中',
  'assistant.verbTodos': 'To Do',
  'assistant.verbFetching': 'フェッチ中',
  'assistant.verbCalling': '呼び出し中',
  'qf.answered': '回答済み',
  "qf.unanswered": "未回答",
  "qf.unansweredContinued": "この質問には回答されず、会話が続行されました。",
  'qf.answeredConfirmed': '確定しました',
  'qf.answeredSkipped': 'スキップ',
  "chat.att.cancelUpload": "{name} のアップロードをキャンセル",
  "chat.att.retry": "再試行",
  "chat.attachments.scrollNext": "次の添付ファイルを表示",
  "chat.attachments.scrollPrev": "前の添付ファイルを表示",
  "chat.input.collapse": "折りたたむ",
  "chat.input.expandFull": "メッセージ全文を表示",
  "chat.input.viewAll": "すべて表示",
  "chat.artifact.export": "エクスポート",
  "chat.artifact.pending": "生成中…",
  "chat.artifact.publish": "共有",
  "chat.edge.paused": "タスクを手動で一時停止しました",
  "chat.edge.reconnectCta": "再接続",
  "chat.edge.reconnectDetail": "詳細を表示",
  "chat.edge.reconnectFailed": "ネットワーク接続を復旧できませんでした",
  "chat.edge.reconnectFailedDescription": "ネットワーク接続を確認してから、もう一度お試しください。",
  "chat.edge.reconnecting": "ネットワーク接続を復旧しています",
  "chat.edge.reconnectingDescription": "接続を試行しています（{attempt}/{max} 回目）。しばらくお待ちください。",
  "chat.edge.retrying": "再試行しています",
  "chat.edge.retryingRateLimitedTitle": "モデルサービスが混雑しています",
  "chat.edge.retryingRateLimitedDescription": "現在このモデルサービスへのリクエストが多く、プロバイダーのリクエスト頻度の上限に達しました。しばらくしてから再試行するか、別のモデルに切り替えてください。",
  "qf.visualNext": "次のスタイル",
  "qf.visualPrev": "前のスタイル",
  "qf.visualRandom": "ランダム",
  "qf.visualReshuffle": "別の候補",
  "qf.visualViewFan": "重ねて表示",
  "qf.visualViewGrid": "グリッド表示",
  "qf.confirmed": "確認済み",
  "qf.picked": "{count} 件選択",
  "qf.moreOptions": "その他の選択肢",
  "qf.colorPresets": "プリセットカラー",
  "qf.colorCustom": "カスタムカラー",
  "qf.colorPickerLabel": "カラーピッカーを開く",
  "qf.colorHexLabel": "16 進数カラー値",
  "qf.colorPreview": "プレビュー:アクセントカラーは画面上でこのように表示されます。",
  "qf.colorInvalid": "6 桁の 16 進数カラーを入力してください(例:#3b82f6)",
  'qf.choose': '選択…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'その他',
  'qf.ownAnswer': '自分で書く',
  'qf.required': '必須',
  'qf.lockedSubmitted': '回答を送信しました — エージェントがセッション終了まで参照します。',
  'qf.lockedPrev': 'このフォームは前のターンのものです。',
  'qf.hint': '適切なものを選んでください。気にしない任意フィールドはスキップしてください — エージェントが適切なデフォルト値を使用します。',
  'qf.submitDefault': "次へ",
  'qf.submitDisabledTitle': '最初に必須フィールドを入力してください',
  'qf.submitTitle': "次へ",
  'questions.tabLabel': '質問',
  'questions.banner': 'いくつか簡単な質問をしてもよろしいですか？',
  'questions.bannerAnswered': '質問に回答済み',
  'questions.strategyBlockedNotice': "このタスクはストラテジーの品質ゲートによって停止されたため、このフォームは送信できなくなりました。続けるには新しいリクエストを開始してください。",
  'questions.continue': '続ける',
  'questions.generating': '質問を生成中…',
  'questions.skipAll': "スキップ · おまかせ",
  'questions.autoSkipHint': 'タイマー終了時に自動で続行します',
  'questions.submitting': '送信中…',
  'sketch.toolSelect': '選択（操作なし）',
  'sketch.toolPen': 'ペン',
  'sketch.toolText': 'テキスト',
  'sketch.toolRect': '四角形',
  'sketch.toolArrow': '矢印',
  'sketch.toolEraser': '消しゴム',
  'sketch.color': '色',
  'sketch.strokeSize': 'ストロークサイズ',
  'sketch.undo': '元に戻す',
  'sketch.clear': 'クリア',
  'sketch.close': '閉じる',
  'sketch.closeConfirm': 'スケッチを閉じて未保存の変更を破棄しますか？',
  'sketch.textPrompt': 'テキスト:',
  'sketch.textModalTitle': 'テキストを追加',
  'critiqueTheater.userFacingName': 'デザイン陪審',
  'critiqueTheater.roleDesigner': 'デザイナー',
  'critiqueTheater.roleCritic': '批評家',
  'critiqueTheater.roleBrand': 'ブランド',
  'critiqueTheater.roleA11y': 'アクセシビリティ',
  'critiqueTheater.roleCopy': 'コピー',
  'critiqueTheater.roundLabel': 'ラウンド {n} / {m}',
  'critiqueTheater.mustFix': '要修正 {n} 件',
  'critiqueTheater.composite': '総合スコア',
  'critiqueTheater.threshold': 'しきい値',
  'critiqueTheater.consensus': '合意',
  'critiqueTheater.interrupt': '中断',
  'critiqueTheater.interrupting': '中断中…',
  'critiqueTheater.interrupted': '中断済み',
  'critiqueTheater.degradedHeading': 'この実行ではパネル無効',
  'critiqueTheater.degradedReasonMalformed': 'パネル出力の形式が不正です（パーサーが拒否）。',
  'critiqueTheater.degradedReasonOversize': 'パネル出力が安全なバイト予算を超えました。',
  'critiqueTheater.degradedReasonAdapter': 'アダプター {adapter} は批評プロトコルをサポートしていません。',
  'critiqueTheater.degradedReasonProtocol': 'アダプター {adapter} はサポート対象外のプロトコルバージョンを使用しています。',
  'critiqueTheater.degradedReasonMissingArtifact': '実行は完了しましたが最終成果物がありません。',
  'critiqueTheater.replay': 'リプレイ',
  'critiqueTheater.replaySpeed': 'リプレイ速度',
  'critiqueTheater.readOnly': '読み取り専用',
  'critiqueTheater.shippedSummary': 'ラウンド {round} で出荷 · 総合 {composite}',
  'critiqueTheater.interruptedSummary': 'ラウンド {round} で中断 · 最高総合 {composite}',
  'critiqueTheater.shippedBadge': '出荷済み',
  'critiqueTheater.belowThresholdBadge': 'しきい値未達',
  'critiqueTheater.timedOutBadge': 'タイムアウト',
  'critiqueTheater.failedHeading': '実行に失敗しました',
  'critiqueTheater.failedReasonCliExit': 'エージェント CLI がパネル完了前に異常終了しました。',
  'critiqueTheater.failedReasonPerRoundTimeout': 'いずれかのラウンドが時間予算を超過しました。',
  'critiqueTheater.failedReasonTotalTimeout': '実行全体が時間予算を超過しました。',
  'critiqueTheater.failedReasonOrchestrator': 'オーケストレーターの内部エラー。',
  'critiqueTheater.transcriptEmpty': '再生できるトランスクリプトがありません。批評を実行して記録してください。',
  'critiqueTheater.transcriptLoading': 'トランスクリプトを読み込み中…',
  'critiqueTheater.transcriptError': 'トランスクリプトを読み込めませんでした: {error}',
  'critiqueTheater.replaySpeedPaused': '一時停止',
  'critiqueTheater.replaySpeedInstant': '即時',
  'critiqueTheater.replaySpeedLive': 'ライブ',
  'critiqueTheater.replaySpeedFast': '高速',
  'critiqueTheater.settingsNav': 'デザイン陪審',
  'critiqueTheater.settingsNavHint': 'エージェント実行中の 5 名パネルレビュー',
  'critiqueTheater.settingsEnabledLabel': 'エージェント実行中にデザイン陪審を表示',
  'critiqueTheater.settingsEnabledDescription': '有効にすると、エージェント生成中に 5 名のパネルレビューが並走し、出荷前に結果を採点します。いつでも中断できます。',
  'critiqueTheater.settingsEnabledProjectHint': 'このプロジェクトに保存しました。今後の実行はサーバ側でデザイン陪審を通ります。',
  'critiqueTheater.settingsEnabledNoProjectHint': 'サーバ側に保存するにはプロジェクトを開いてください。それまではブラウザ内の設定のみ変更されます。',
  'pet.title': 'ペット',
  'pet.subtitle': 'ワークスペースに浮かぶ小さな相棒を迎えましょう。',
  'pet.navTitle': 'ペット',
  'pet.navHint': '迎える・カスタマイズ',
  'pet.tabBuiltIn': '組み込み',
  'pet.tabBuiltInHint': 'OpenDesign に同梱された厳選コンパニオン — 選んで迎え入れよう。',
  'pet.builtInEmpty': '組み込みペットを今は読み込めません。デーモンが復帰したらコミュニティタブを更新してください。',
  'pet.tabCustom': 'カスタム',
  'pet.tabCustomHint': '名前・絵文字・色・スプライトを自分で設定。',
  'pet.tabCommunity': 'コミュニティ',
  'pet.tabCommunityHint': 'Codex で孵ったペット — 養子に取るか AI で新しく作る。',
  'pet.tabsAria': 'ペットのソース',
  'pet.adopt': '迎える',
  'pet.adoptedBadge': '迎え済み',
  'pet.adoptCallout': 'ペットを迎える',
  'pet.changePet': 'ペットを変更',
  'pet.wake': '呼び出す',
  'pet.tuck': 'しまう',
  'pet.wakeTitle': 'ペットを呼び出す — 浮かぶオーバーレイを表示。',
  'pet.tuckTitle': 'ペットをしまう — オーバーレイを非表示。',
  'pet.settingsTitle': 'ペット設定を開く',
  'pet.useCustom': 'マイペットを使う',
  'pet.customTitle': '自分で作る',
  'pet.customHint': '名前、アイコン、アクセントカラーを選ぶと、オーバーレイが即時に更新されます。',
  'pet.customGreetingPlaceholder': 'ペットからのあいさつ…',
  'pet.fieldName': '名前',
  'pet.fieldGlyph': 'アイコン',
  'pet.fieldGlyphHint': '絵文字 1 つが最適です（例：🐝、🦄、🐢）。',
  'pet.fieldGreeting': 'あいさつ',
  'pet.fieldAccent': 'アクセントカラー',
  'pet.fieldAccentCustom': 'カスタムカラー',
  'pet.fieldAccentDefault': 'デフォルトのアクセントカラー',
  'pet.overlayAria': 'ペットの相棒',
  'pet.spriteAria': '{name} — ドラッグで移動、クリックで会話',
  'pet.spriteTitle': '{name} からこんにちは！クリックで会話。',
  'pet.taskSummarySingle': '{count} 件の Agent タスクを実行中です。',
  'pet.taskSummaryMultiple': '{projects} 個のプロジェクトで {count} 件の Agent タスクを実行中です。',
  'pet.taskSummaryRecentSingle': '{count} 件の Agent タスクが最近完了しました。',
  'pet.taskSummaryRecentMultiple': '{count} 件の Agent タスクが最近完了しました。',
  'pet.taskListAria': '実行中の Agent タスク',
  'pet.taskOpenProject': '{project} を開く',
  'pet.taskGroup.running': '実行中',
  'pet.taskGroup.queued': '待機中',
  'pet.taskGroup.recent': '最近完了',
  'pet.idleQuote.leonardo.text': '学ぶことに、心が尽きることはない。',
  'pet.idleQuote.leonardo.author': 'レオナルド・ダ・ヴィンチ',
  'pet.idleQuote.michelangelo.text': '私は大理石の中に天使を見出し、彼を解き放つまで彫り続けた。',
  'pet.idleQuote.michelangelo.author': 'ミケランジェロ',
  'pet.idleQuote.bernini.text': '彫刻家を助ける手段は二つある。光と影だ。',
  'pet.idleQuote.bernini.author': 'ジャン・ロレンツォ・ベルニーニ',
  'pet.idleQuote.raphael.text': '絵を描いているとき、人は何も考えていない。',
  'pet.idleQuote.raphael.author': 'ラファエロ',
  'pet.idleQuote.caravaggio.text': 'いかなる作品も、誰が描いたものであれ、生身の対象から作り描かれたものでなければ、取るに足らない児戯にすぎない。',
  'pet.idleQuote.caravaggio.author': 'カラヴァッジョ',
  'pet.idleQuote.rodin.text': '大切なのは、心を動かされること、愛すること、希望を抱くこと、震えること、生きることだ。',
  'pet.idleQuote.rodin.author': 'オーギュスト・ロダン',
  'pet.composerTitle': 'ペット — 呼び出す・しまう・選ぶ',
  'pet.composerMenuTitle': 'ペット',
  'pet.composerMenuHint': 'ヒント：/pet と入力で切替',
  'pet.composerOpenSettings': 'ペットを管理',
  'pet.welcomeTeaserTitle': 'ペットを迎える',
  'pet.welcomeTeaserBody': 'ワークスペースに浮かぶ小さな相棒です。',
  'pet.welcomeTeaserCta': '選ぶ',
  'pet.imageUpload': 'スプライトをアップロード',
  'pet.imageReplace': 'スプライトを差し替える',
  'pet.imageRemove': '絵文字に戻す',
  'pet.imageHintIdle': 'PNG / JPG / WebP / GIF / SVG に対応。スプライトシート？横長の帯をアップしてフレーム数を指定してください。',
  'pet.imageHintActive': 'アップしたスプライトを表示中。フレーム数を 1 より大きくすると横スプライトシートが動きます。',
  'pet.fieldFrames': 'フレーム数',
  'pet.fieldFramesHint': '1 = 静止。2 以上 = 横スプライトシート。',
  'pet.fieldFps': '速度 (fps)',
  'pet.fieldFpsHint': 'フレーム切替の速さ。',
  'pet.atlasImport': 'Codex スプライトを取り込む',
  'pet.atlasImportTitle': 'hatch-pet の 8x9 / 192x208 アトラス(PNG または WebP)を取り込みます。',
  'pet.atlasPickerTitle': 'アニメーション行を選択',
  'pet.atlasPickerHint': 'Codex ペットは 9 種類のアニメーション行を持っています。デフォルトはアトラス全体を保持し、ホバー・ドラッグ方向・長時間アイドルに応じて行が切り替わります。1 行だけにロックすることもできます。',
  'pet.atlasCancel': 'アトラスを破棄',
  'pet.atlasAdopt': 'この行に固定',
  'pet.atlasAdoptFull': 'アトラス全体を使う(アニメーション)',
  'pet.atlasAdoptFullTitle': 'すべての行を保持して、ホバー・ドラッグ方向・長時間アイドルに反応させます。',
  'pet.atlasAdoptRowTitle': 'ハイライト中の行だけをループするストリップに切り出します。',
  'pet.atlasActiveHint': 'アニメーションアトラス有効 — 操作(ホバー・ドラッグ・アイドル)に応じてペットが行を切り替えます。',
  'pet.atlasRow.idle': 'アイドル',
  'pet.atlasRow.running-right': '右に走る',
  'pet.atlasRow.running-left': '左に走る',
  'pet.atlasRow.waving': '手を振る',
  'pet.atlasRow.jumping': 'ジャンプ',
  'pet.atlasRow.failed': '失敗',
  'pet.atlasRow.waiting': '待機',
  'pet.atlasRow.running': '走る',
  'pet.atlasRow.review': 'レビュー',
  'pet.hatchTitle': 'AI で新しいペットを孵化',
  'pet.hatchHint': '同梱の hatch-pet スキルをチャットで実行して Codex 風のスプライトシートを生成し、ここから取り込んでください。',
  'pet.hatchConcept': 'ペットのコンセプト(任意)',
  'pet.hatchConceptPlaceholder': '例: セーターを着た小さなピクセル風の柴犬',
  'pet.hatchCopy': 'プロンプトをコピー',
  'pet.hatchCopied': 'コピー済み!',
  'pet.hatchFoot': 'スキルがペットを保存したら、ここに戻って「Codex スプライトを取り込む」を選んでください。',
  'pet.slashPopoverAria': 'スラッシュコマンド',
  'pet.slashPopoverTitle': 'コマンド',
  'pet.slashPopoverHint': '↑↓ で移動 · enter で選択 · esc で閉じる',
  'pet.slashPet': 'ペットを切替・採用、または設定を開く。',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': '浮遊ペットを起こす。',
  'pet.slashPetTuck': 'ペットを一旦しまう。',
  'pet.slashHatch': 'hatch-pet スキルで Codex ペットを生成。',
  'pet.slashHatchArg': '<コンセプト>',
  'pet.slashSearch': 'OD research コマンドで Web 検索します。',
  'pet.slashSearchArg': '<検索クエリ>',
  'pet.codexTitle': '最近の孵化',
  'pet.codexSubtitle': 'hatch-pet スキルがパッケージしたペットがここに表示され、ワンクリックで採用できます。',
  'pet.codexSubtitleWithDir': '{dir} を hatch-pet スキルのパッケージのために走査中。',
  'pet.codexEmpty': '孵化したペットはまだありません。チャットで /hatch を入力して生成しましょう。',
  'pet.codexLoading': '孵化したペットを探しています…',
  'pet.codexRefresh': '更新',
  'pet.codexAdopt': '採用',
  'pet.codexAdopting': '採用中…',
  'pet.communitySync': 'コミュニティペットをダウンロード',
  'pet.communitySyncing': 'ダウンロード中…',
  'pet.communitySyncTitle': 'Codex Pet Share と j20 Hatchery の最新ペットを ~/.codex/pets/ に同期します。',
  'pet.communitySyncDone': '{wrote} 体の新しいペットを同期しました（合計 {total} 体）。',
  'pet.communitySyncFailed': '同期に失敗しました: {error}',
  'pet.codexBundled': '同梱',
  'pet.codexBundledTitle': 'OpenDesign に同梱 — ダウンロード不要。',
  'settings.systemPrefsTitle': 'システム設定',
  'settings.systemPrefsHint': '完了サウンド、ブラウザ通知、タスク状態のアラート。',
  'settings.notifications': '通知',
  'settings.notificationsHint': 'タスク完了時の効果音とデスクトップ通知',
  'settings.notifyCompletionSound': '完了サウンド',
  'settings.notifyCompletionSoundHint': '1ターン終了時に再生されます。既定ではオフです。',
  'settings.notifySuccessSound': '成功サウンド',
  'settings.notifyFailureSound': '失敗サウンド',
  'settings.notifyDesktop': 'デスクトップ通知',
  'settings.notifyDesktopHint': 'ウィンドウが非アクティブのときに送信されます。',
  'settings.notifyDesktopBlocked': 'ブラウザにブロックされています。サイト設定で許可してください。',
  'settings.notifyDesktopUnsupported': 'この環境ではデスクトップ通知に対応していません。',
  'settings.notifyTest': 'テスト送信',
  'settings.notifyTestSent': 'テスト通知を送信しました。バナーが出ない場合は、ブラウザとシステムの通知設定を確認してください。',
  'settings.notifyTestFailed': '通知の呼び出しに失敗しました。ブラウザとシステムの通知設定を確認してください。',
  'settings.notifySoundDing': 'ティン',
  'settings.notifySoundChime': 'チャイム',
  'settings.notifySoundTwoToneUp': '上昇2音',
  'settings.notifySoundPluck': 'プラック',
  'settings.notifySoundBuzz': 'ブザー',
  'settings.notifySoundTwoToneDown': '下降2音',
  'settings.notifySoundThud': 'ドスン',
  'settings.skills': 'スキル',
  'settings.skillsHint': 'エージェントがタスク中に呼び出せる機能スキル',
  'settings.skillsNew': '新規スキル',
  'settings.skillsEmpty': '左からスキルを選ぶか、新規作成してください。',
  'settings.skillsEdit': '編集',
  'settings.skillsDelete': '削除',
  'settings.skillsDeleteConfirm': '削除を確定',
  'settings.skillsName': '名前',
  'settings.skillsTriggers': 'トリガー（カンマ／改行区切り）',
  'settings.skillsDescription': '説明',
  'settings.skillsBody': 'SKILL.md 本文',
  'settings.skillsCreate': '作成',
  'settings.skillsSave': '保存',
  'settings.skillsSaving': '保存中…',
  'settings.skillsOverrideCreate': 'ユーザー上書きを作成',
  'settings.skillsOverrideSave': 'ユーザー上書きとして保存',
  'settings.skillsBuiltInOverrideWarning': 'この組み込みスキルを編集すると、ユーザー上書きが作成されます。上書きを削除するまで、組み込みの項目は一覧から非表示になります。続行しますか？',
  'settings.skillsFiles': 'ファイル',
  'settings.skillsNoFiles': 'このスキルフォルダーにファイルはありません。',
  'settings.skillsNameRequired': 'スキル名は必須です。',
  'settings.skillsBodyRequired': 'スキルの内容は必須です。',
  'settings.designSystems': 'デザインシステム',
  'settings.designSystemsHint': 'エージェントが利用できるデザインシステムを管理',
  'settings.designSystemsInstalled': 'インストール済み',
  'settings.designSystemsAdd': 'デザインシステムを追加',
  'settings.designSystemsHiddenCount': '{count} 件をホームギャラリーから非表示',
  'settings.designSystemsShowAll': 'すべて表示',
  'settings.designSystemsShowHidden': '非表示を表示',
  'settings.designSystemsSource': 'ソース',
  'settings.designSystemsSourceLocal': 'ローカル',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn レジストリ参照',
  'settings.designSystemsImportShadcn': 'shadcn からインポート',
  'settings.designSystemsStructure': '構造',
  'settings.designSystemsModeHybrid': 'ハイブリッド',
  'settings.designSystemsModeNormalized': '正規化',
  'settings.designSystemsModeVerbatim': 'そのまま',
  'settings.designSystemsCraft': 'クラフト',
  'settings.designSystemsCraftColor': 'カラー',
  'settings.designSystemsCraftAccessibility': 'アクセシビリティ',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'プロジェクトパス',
  'settings.designSystemsImportGithub': 'GitHub からインポート',
  'settings.designSystemsImportProject': 'プロジェクトからインポート',
  'settings.designSystemsImportedStatus': '{title} をインポートしました',
  'settings.designSystemsViewImported': 'インポートしたデザインシステムを表示',
  'settings.designSystemsCategory': 'カテゴリー',
  'settings.designSystemsAllCategories': 'すべてのカテゴリー',
  'settings.designSystemsShowInHomeGallery': 'ホームギャラリーに表示',
  'settings.projectLocations': 'プロジェクトの場所',
  'settings.projectLocationsHint': 'ワークスペース保存ルート',
  'settings.projectLocationsDescription': '複数の OpenDesign プロジェクトフォルダを含められる作業ベースを追加します。新しいプロジェクトは選択したベース内の 1 つのフォルダとして保存されます。',
  'settings.projectLocationsSaveError': 'プロジェクトの場所を保存できませんでした。各パスがアクセス可能なフォルダであることを確認してください。',
  'settings.projectLocationsSaved': 'プロジェクトの場所を保存しました。',
  'settings.projectLocationsScanError': 'プロジェクトの場所をスキャンできませんでした。',
  'settings.projectLocationsScanComplete': 'スキャン完了: {imported} 件をインポート、{existing} 件は登録済みです。',
  'settings.projectLocationsNoFolderSelected': 'フォルダが選択されていません。',
  'settings.projectLocationsDuplicate': 'その作業ベースはすでに追加されています。',
  'settings.projectLocationsWorkBaseMeta': '作業ベース · プロジェクトはここにサブフォルダとして作成されます',
  'settings.projectLocationsAddFolder': 'フォルダを追加…',
  'settings.projectLocationsDefaultBadge': 'デフォルトの場所',
  'settings.projectLocationsMakeDefault': 'デフォルトにする',
  'settings.projectLocationsDefaultSaved': 'デフォルトのプロジェクト場所を更新しました。',
  'settings.librarySkills': 'スキル',
  'settings.libraryDesignSystems': 'デザインシステム',
  'settings.librarySearch': '検索...',
  'settings.libraryAll': 'すべて',
  'settings.libraryPreview': 'プレビュー',
  'settings.libraryPreviewClose': '閉じる',
  'settings.libraryLoading': '読み込み中...',
  'settings.libraryNoResults': '検索条件に一致する項目がありません。',
  'settings.libraryEnabled': '有効',
  'settings.libraryDisabled': '無効',
  'settings.connectorsNavHint': '外部システム接続',
  'settings.connectorsHint': 'このデバイスのコネクターとツールプロバイダー設定を管理します。',
  'settings.connectorsComposioApiKey': 'Composio API キー',
  'settings.connectorsSavedTitle': 'ローカル daemon に保存済み',
  'settings.connectorsSavedWithTail': '保存済み · ••••{tail}',
  'settings.connectorsSaved': '保存済み',
  'settings.connectorsGetApiKey': 'API キーを取得',
  'settings.connectorsReplaceKeyPlaceholder': '保存済みキーを置き換えるには新しいキーを貼り付け',
  'settings.connectorsApiKeyPlaceholder': 'Composio API キーを貼り付け',
  'settings.connectorsClear': 'クリア',
  'settings.connectorsClearConfirmTitle': '保存された Composio API キーを削除しますか？',
  'settings.connectorsClearConfirmBody': 'キーを削除すると、このワークスペースに紐づくすべての Composio コネクタが切断されます。接続中のアカウント、OAuth 認可、ツールへのアクセス権はすべて取り消されます。',
  'settings.connectorsClearConfirmContinue': '続行',
  'settings.connectorsClearFinalTitle': 'すべてのコネクタが切断されます',
  'settings.connectorsClearFinalBody': '元には戻せません。新しいキーを貼り付けたあと、各インテグレーションをイチから接続し直す必要があります。',
  'settings.connectorsClearFinalConfirm': 'キーを削除して切断',
  'settings.connectorsClearArming': '少々お待ちを…',
  'settings.connectorsClearCancel': 'キャンセル',
  'settings.connectorsSaveKey': 'キーを保存',
  'settings.connectorsSaveKeyTitle': 'このキーをローカルの daemon に送信',
  'settings.connectorsKeySaving': '保存中…',
  'settings.connectorsKeySaved': '保存完了 ✓',
  'settings.connectorsKeyError': 'キーを保存できませんでした。ローカルの daemon が起動しているか確認して、もう一度お試しください。',
  'settings.connectorsHelpSaved': 'キーは下のカタログを有効にし、ローカル daemon に保持されます。置き換えるには新しいキーを貼り付け、削除するにはクリアしてください。',
  'settings.connectorsHelpUnsaved': '未保存の変更があります — 「キーを保存」をクリックすると、この資格情報がローカル daemon に保存され、下のカタログが解除されます。',
  'settings.connectorsHelpEmpty': '下のカタログを有効にするにはキーを追加してください。キーは daemon にローカル保存され、環境変数経由で送信されることはありません。',
  'settings.connectorsLoadingSavedKey': 'ローカル daemon に保存されたキーを確認しています…',
  'settings.autosaveSaving': '保存中…',
  'settings.autosaveSaved': 'すべての変更を保存しました',
  'settings.autosaveError': '変更を保存できませんでした。ローカル daemon がオフラインの可能性があります。',
  'settings.libraryToggleLabel': '切り替え',
  'settings.memory': 'メモリ',
  'settings.memoryHint': 'チャットから自動抽出された個人情報',
  'settings.customInstructionsTitle': 'グローバルルール',
  'settings.customInstructionsHint': 'OpenDesignがすべてのチャットで従うべき固定の指示。事実、設定、プロジェクトのコンテキストをメモリとして保存します。',
  'settings.customInstructionsPlaceholder': '例:「常にTypeScriptを使用。関数コンポーネントを優先。回答は簡潔に。」',
  'settings.memoryDescription': 'あなたの好みや背景情報を自動的に抽出し、Markdown ファイルとして保存します。次回以降のチャットに自動で反映されます。',
  'settings.memoryEnabled': '有効',
  'settings.memoryDisabled': '無効',
  'settings.memoryEnableLabel': 'メモリの挿入を有効にする',
  'settings.memoryDisabledBanner': 'メモリは現在オフです。既存の事実はディスク上に残りますが、新しい会話には注入されず、新しい情報の抽出も行われません。',
  'settings.memoryNew': '新規メモリ',
  'settings.memoryEdit': '編集',
  'settings.memoryDelete': '削除',
  'settings.memoryPreview': 'プレビュー',
  'settings.memoryEmpty': 'まだメモリはありません。',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'ダークモードが好みです',
  'settings.memoryName': '名前',
  'settings.memoryDesc': '1 行の説明',
  'settings.memoryBody': 'メモリ本文（Markdown 対応）',
  'settings.memoryBodyHint': 'ルール本体を先に書き、Why と How to apply の 2 行を続けて。',
  'settings.memoryStartersLabel': '出発点が必要ですか？クリックしてフォームに入力:',
  'settings.memoryStarterUserName': '私の役割',
  'settings.memoryStarterUserDesc': '私はSaaSデザインツールに取り組むフロントエンドエンジニアです',
  'settings.memoryStarterUserBody': '- 役割: シニアフロントエンドエンジニア\n- スタック: React, TypeScript, Vite\n- 領域: デザイン / コラボレーションツール\n- タイムゾーン: GMT+8 (Asia/Shanghai)\n\n適用タイミング: あらゆるチャット — Webフロントエンドを軸に例示する。',
  'settings.memoryStarterFeedbackName': 'UIの好み',
  'settings.memoryStarterFeedbackDesc': 'ダークモード、大きな本文テキスト、低い情報密度',
  'settings.memoryStarterFeedbackBody': '- テーマ: デフォルトはダーク\n- 本文テキスト: 18px以上\n- 情報密度: 余白を優先し、画面あたりの項目を少なく\n\n理由: 長時間の作業中の目の疲れを軽減するため。\n適用タイミング: UI、Webページ、スライドを生成するとき。',
  'settings.memoryStarterProjectName': '現在のプロジェクト',
  'settings.memoryStarterProjectDesc': 'OpenDesign v0.5 — チャット駆動のデザインエディター',
  'settings.memoryStarterProjectBody': '- 目標: 今四半期にチャット駆動エディターをリリースする\n- 優先事項: ストリーミングレンダリング、ローカルマルチモーダル、オフラインファースト\n- スタック: Next.js 16、Express デーモン、SQLite\n\n適用するタイミング: このプロジェクトに関するあらゆる会話で。',
  'settings.memorySaveHint': '自動保存されません — 適用するには「作成」/「保存」をクリックしてください。',
  'settings.memoryIndexSaveHint': 'インデックスへの編集は自動保存されません — 適用するには「インデックスを保存」をクリックしてください。',
  'settings.memoryIndexUnsaved': '未保存の変更',
  'settings.memoryFlashCreated': '✓ メモリを作成しました',
  'settings.memoryFlashSaved': '✓ メモリを保存しました',
  'settings.memoryFlashDeleted': '✓ メモリを削除しました',
  'settings.memoryFlashIndexSaved': '✓ インデックスを保存しました',
  'settings.memoryFlashPathCopied': '✓ パスをコピーしました',
  'settings.memoryNameLabel': 'タイトル',
  'settings.memoryTypeLabel': 'タイプ',
  'settings.memoryDescLabel': '説明',
  'settings.memoryBodyLabel': '内容',
  'settings.memoryTypeUser': 'ユーザー',
  'settings.memoryTypeFeedback': 'フィードバック',
  'settings.memoryTypeProject': 'プロジェクト',
  'settings.memoryTypeReference': '参照',
  'settings.memoryTypeProfile': 'プロフィール',
  'settings.memoryTypeRule': 'ルール',
  'settings.memoryTabMemories': 'メモリ',
  'settings.memoryTabMemoriesCaption': '保存したメモリの表示と管理',
  'settings.memoryTabHow': '仕組み',
  'settings.memoryTabHowCaption': '2 つのループとその制御',
  'settings.memoryAddDisclosure': 'メモリの追加またはインポート',
  'settings.memoryAddDisclosureHint': 'プロフィール、手動入力、または連携アプリ',
  'settings.memoryProfileTab': 'ワークプロフィール',
  'settings.memoryProfileTabCaption': 'あなたの情報とデフォルト設定',
  'settings.memoryProfileTitle': 'あなたのワークプロフィール',
  'settings.memoryProfileHint':
    'あなた自身とデフォルト設定に関するいくつかの事実です。メモリはこれを毎回のタスク前に注入するため、短い依頼からでもエージェントが意図を推測できます。',
  'settings.memoryProfileName': 'ワークプロフィール',
  'settings.memoryProfileDescription':
    'アシスタントが再利用すべき役割、会社、領域、対象読者、好み、デフォルト設定。',
  'settings.memoryProfileSave': 'プロフィールを保存',
  'settings.memoryProfileSaving': '保存中…',
  'settings.memoryProfileSaved': 'プロフィールを保存しました',
  'settings.memoryProfileRole': '役割',
  'settings.memoryProfileRolePlaceholder': '例: Founder, designer, PM',
  'settings.memoryProfileCompany': '会社 / チーム',
  'settings.memoryProfileCompanyPlaceholder': '例: Acme, growth team',
  'settings.memoryProfileDomain': '領域',
  'settings.memoryProfileDomainPlaceholder': '例: B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': '主な対象読者',
  'settings.memoryProfileAudiencePlaceholder': '例: executives, engineers, end users',
  'settings.memoryProfileAesthetic': '美意識 / 好み',
  'settings.memoryProfileAestheticPlaceholder':
    '例: clean and editorial, light backgrounds, generous whitespace',
  'settings.memoryProfileDeliverables': 'デフォルトの成果物',
  'settings.memoryProfileDeliverablesPlaceholder': '例: landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'ロケール / 言語',
  'settings.memoryProfileLocalePlaceholder': '例: English (US), Simplified Chinese',
  'settings.memoryProfileGoals': '現在の目標',
  'settings.memoryProfileGoalsPlaceholder':
    '例: ship the new pricing page, raise conversion on the trial flow',
  'settings.memoryHooksTitle': 'メモリフック',
  'settings.memoryHooksHint':
    'メモリのどの部分を自動実行するか選びます。上部のマスタースイッチですべてオフにできます。',
  'settings.memoryHooksProfileLabel': 'プロフィールを使う',
  'settings.memoryHooksProfileDesc': 'ワークプロフィールをすべてのタスクに注入します。',
  'settings.memoryHooksRewriteLabel': '短い依頼を書き直す',
  'settings.memoryHooksRewriteDesc': 'PRE: 短い依頼を完全なタスクブリーフに展開します。',
  'settings.memoryHooksVerifyLabel': '出力をセルフ検証',
  'settings.memoryHooksVerifyDesc': 'POST: 結果をあなたのルールと照合し、スコアカードを表示します。',
  'settings.memoryHooksExtractionLabel': 'チャットから学習',
  'settings.memoryHooksExtractionDesc': 'チャットのやり取りから有用な事実や好みを取り込みます。',
  'settings.memoryIndex': 'MEMORY.md（索引）',
  'settings.memoryIndexSave': '索引を保存',
  'settings.memoryIndexReset': 'リセット',
  'settings.memoryToastChanged': 'メモリを更新しました',
  'settings.memoryToastClickHint': '表示',
  'settings.memoryAll': 'すべて',
  'settings.memoryExtractions': '抽出履歴',
  'settings.memoryExtractionsHint': '正規表現が最初に実行され、LLM はバックグラウンドで実行されます。',
  'settings.memoryExtractionsEmpty': 'まだ抽出はありません。次のチャットのやり取りでこのリストに反映されます。',
  'settings.memoryExtractionsRefresh': '更新',
  'settings.memoryExtractionsRefreshing': '更新中…',
  'settings.memoryExtractionPhaseRunning': '実行中…',
  'settings.memoryExtractionPhaseSuccess': '成功',
  'settings.memoryExtractionPhaseSkipped': 'スキップ',
  'settings.memoryExtractionPhaseFailed': '失敗',
  'settings.memoryExtractionSkipNoProvider': 'LLM メモリ抽出用の API key が設定されていません。',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'メモリは無効になっています。',
  'settings.memoryExtractionSkipEmpty': 'ユーザーメッセージが空です — 抽出する内容がありません。',
  'settings.memoryExtractionSkipNoMatch': 'このやり取りに一致する正規表現パターンはありませんでした。',
  'settings.memoryExtractionKindHeuristic': '正規表現',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'メディア設定',
  'settings.memoryExtractionProviderOverride': 'メモリ設定',
  'settings.memoryExtractionProposed': '提案済み',
  'settings.memoryExtractionWritten': '書き込み済み',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': '削除',
  'settings.memoryExtractionsClear': 'クリア',
  'settings.memoryExtractionsClearTitle': 'すべての抽出履歴をクリア',
  'settings.memoryExtractionsClearConfirm': 'すべての抽出履歴をクリアしますか？この操作は元に戻せません。',
  'settings.memoryNoProviderBannerTitle': 'LLM メモリ抽出が実行されていません',
  'settings.memoryNoProviderBannerBody': 'メモリ抽出用の API key が見つかりません。LLM 駆動の抽出を有効にするには、メディアプロバイダーで OpenAI key を追加するか、環境変数に ANTHROPIC_API_KEY / OPENAI_API_KEY を設定してください。ヒューリスティックな正規表現抽出は引き続き有効です。',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'インストール',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'ローカルパス',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'インストール',
  'settings.libraryUninstall': 'アンインストール',
  'settings.libraryBuiltIn': '内蔵',
  'settings.libraryInstalled': 'インストール済み',
  'notify.successTitle': 'タスクが完了しました',
  'notify.failureTitle': 'タスクが失敗しました',
  'notify.successBody': '1ターンが終了しました。',
  'notify.failureBody': 'タスクはエラーで終了しました。',
  'updater.available': 'アップデートがあります',
  'updater.activeRunsTitle': 'OpenDesign はまだ作業中です',
  'updater.activeRunsBody': '{count} 件のアクティブなタスクが実行中です。今すぐ再起動すると中断されます。',
  'updater.activeRunsUnknownBody': '実行中のタスクがあるか確認できませんでした。再起動すると作業が中断される可能性があります。',
  'updater.availableBody': 'OpenDesign {version} を利用できます。インストーラーを開く前にダウンロードします。',
  'updater.checking': 'アップデートを確認中',
  'updater.download': 'アップデートをダウンロード',
  'updater.downloading': 'アップデートをダウンロード中',
  'updater.downloadingPercent': 'アップデートをダウンロード中 {percent}%',
  'updater.done': '完了',
  'updater.failed': 'アップデートに失敗しました',
  'updater.installerOpenBody': 'インストーラーが開いています。更新を完了できるよう OpenDesign を終了しています。',
  'updater.installerOpened': 'インストーラーを開きました',
  'updater.later': '後で',
  "updater.allowSilentUpdates": "今後のアプリ内更新を自動インストールする",
  'updater.openFailedFallback': 'インストーラーを開けませんでした。',
  'updater.installRestart': 'インストールして再起動',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': '更新をインストール',
  'updater.opening': 'インストーラーを開いています...',
  'updater.dialogAvailableGeneric': '新しいバージョンを利用できます。\nダウンロード後にインストールできます。',
  'updater.dialogAvailableVersion': 'v{version} を利用できます。\nダウンロード後にインストールできます。',
  'updater.dialogCheckFailed': '更新を確認できませんでした\nバージョン情報を一時的に取得できません。ネットワーク接続を確認してからもう一度お試しください。',
  'updater.dialogDownloadFailed': 'アップデートのダウンロードが完了しませんでした\nネットワーク接続が正常か確認してから、もう一度お試しください。',
  'updater.downloadFailedTitle': 'アップデートのダウンロードが完了しませんでした',
  'updater.dialogReadyGeneric': '新しいバージョンの準備ができました。\nより快適でスマートなデザインをお楽しみください。',
  'updater.dialogReadyVersion': 'v{version} の準備ができました。\nより快適でスマートなデザインをお楽しみください。',
  'updater.dialogUnsupported': 'この環境ではアプリ内更新を利用できません。\nリリースページから手動でダウンロードできます。',
  'updater.payloadReadyGeneric': 'A new OpenDesign update is ready. OpenDesign will close and restart automatically.',
  'updater.payloadReadyVersion': 'OpenDesign {version} is ready. OpenDesign will close and restart automatically.',
  'updater.quitButton': 'OpenDesign を終了',
  'updater.quitFailedBody': 'インストーラーは開いていますが、OpenDesign を終了できませんでした。アプリを置き換える前に OpenDesign を終了してください。',
  'updater.quitFailedTitle': '終了できませんでした',
  'updater.quitting': '終了しています...',
  'updater.ready': 'アップデート準備完了',
  'updater.readyGeneric': '新しいバージョンの準備ができました。OpenDesign を閉じてインストーラーを開きます。',
  'updater.readyVersion': 'OpenDesign {version} の準備ができました。OpenDesign を閉じてインストーラーを開きます。',
  'updater.reinstallLearnMore': '詳細を見る',
  'updater.reinstallReadyGeneric': 'このアップデートには完全な再インストールが必要です。OpenDesign を終了してインストーラーを開きます。',
  'updater.reinstallReadyVersion': 'OpenDesign {version} には完全な再インストールが必要です。OpenDesign を終了してインストーラーを開きます。',
  'updater.restartAnyway': '再起動する',
  'updater.upToDate': 'すでに最新バージョンです。',
  'updater.viewVersionFeatures': '新バージョンの機能を見る',
  'updater.manualDownload': '手動でダウンロード',
  'whatsNew.updatedTitle': 'OpenDesign {version} に更新しました',
  'whatsNew.cta': 'リリースノートを見る',
  'newsletter.label': 'ニュースレター（任意）',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': '自動化',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': '日次コネクターサマリー',
  'settings.orbit.lede': 'コネクターのアクティビティをスケジュールで収集し、結果を更新可能な live artifact として公開します。',
  'settings.orbit.statusOnTitle': '毎日のスケジュール実行はオンです',
  'settings.orbit.statusOffTitle': '毎日のスケジュール実行はオフです',
  'settings.orbit.statusActive': '有効',
  'settings.orbit.statusOff': 'オフ',
  'settings.orbit.runTitle': 'Orbit 実行を開始してライブ会話を開く',
  'settings.orbit.running': '実行中…',
  'settings.orbit.runOpen': '今すぐ実行',
  'settings.orbit.dailySummaryTitle': '日次サマリー',
  'settings.orbit.dailySummarySub': 'スケジュールされたローカル時刻に 1 日 1 回実行します。',
  'settings.orbit.on': 'オン',
  'settings.orbit.off': 'オフ',
  'settings.orbit.runTimeTitle': '実行時刻',
  'settings.orbit.runTimeSub': '既定は 08:00。保存すると daemon のスケジュールに適用されます。',
  'settings.orbit.runTimeAria': '毎日の Orbit 実行時刻',
  'settings.orbit.nextRun': '次の実行',
  'settings.orbit.nextRunScheduledAfterSave': '保存後にスケジュール',
  'settings.orbit.schedule': 'スケジュール',
  'settings.orbit.pausedManualOnly': '一時停止 — 手動実行のみ',
  'settings.orbit.templateTitle': 'プロンプトテンプレート',
  'settings.orbit.templateMissing': 'テンプレート {id} はインストールされていません。',
  'settings.orbit.templateMissingOption': '{id}（不足）',
  'settings.orbit.templateMissingInstall': 'プロンプトを制御するには Orbit skill をインストールしてください。',
  'settings.orbit.templateMissingPickAnother': 'ドロップダウンから別のテンプレートを選択してください。',
  'settings.orbit.templateResetTitle': '{id} にリセット',
  'settings.orbit.templateReset': 'リセット',
  'settings.orbit.templateHelp': 'skill で Orbit を制御します — 選択したテンプレートのサンプルプロンプトが各 Orbit 実行に挿入され、サマリーがそのテンプレートの形に従います。',
  'settings.orbit.templateAria': 'Orbit プロンプトテンプレート',
  'settings.orbit.templatesLoading': 'テンプレートを読み込み中…',
  'settings.orbit.templatesOptgroup': 'Orbit skill テンプレート',
  'settings.orbit.lastRun': '前回の実行',
  'settings.orbit.triggerManual': '手動',
  'settings.orbit.triggerScheduled': 'スケジュール済み',
  'settings.orbit.meterAria': 'チェック {checked} 件中、成功 {succeeded} 件、スキップ {skipped} 件、失敗 {failed} 件',
  'settings.orbit.countChecked': 'チェック済み',
  'settings.orbit.countSucceeded': '成功',
  'settings.orbit.countSkipped': 'スキップ',
  'settings.orbit.countFailed': '失敗',
  'settings.orbit.runError': 'Orbit を実行できませんでした。ローカル daemon が実行中で、コネクターが設定されていることを確認してください。',
  'settings.orbit.gateAriaLabel': 'Orbit を使うにはコネクタが必要です',
  'settings.orbit.gateEyebrow': 'セットアップが必要',
  'settings.orbit.gateTitle': 'ツールを接続して Orbit を動かしましょう',
  'settings.orbit.gateBody': 'Orbit はコネクタの活動を要約します。まだ何も接続されていません — 少なくとも 1 つの連携を追加すると、Orbit が報告できるようになります。',
  'settings.orbit.gateBodyNoKey': 'Orbit はコネクタの活動を要約し、コネクタは Composio を通して動作します。コネクタ画面で Composio API キーを追加すると、カタログが解放され最初の連携を選べます。',
  'settings.orbit.gateAction': 'コネクタを開く',
  'settings.orbit.gateActionNoKey': 'Composio を設定',
  'settings.orbit.gateLoading': 'コネクタを確認中…',
  'settings.orbit.controlsLockedBadge': 'ロック中',
  'settings.orbit.controlsLockedHint': 'ツールを接続すると、Orbit のスケジュールとテンプレート設定が有効になります。',
  'settings.orbit.artifactKickerLive': 'ライブアーティファクト',
  'settings.orbit.artifactKickerLegacy': 'レガシーサマリー',
  'settings.orbit.artifactTitle': '日次 Orbit アクティビティサマリー',
  'settings.orbit.artifactMetaLive': 'コネクターアクティビティから生成された更新可能な HTML artifact。',
  'settings.orbit.artifactMetaLegacy': 'live artifact サポートが有効になる前に生成されました — 公開するには Orbit をもう一度実行してください。',
  'settings.orbit.copyMarkdownTitle': 'Markdown サマリーをクリップボードにコピー',
  'settings.orbit.copied': 'コピー済み',
  'settings.orbit.copy': 'コピー',
  'settings.orbit.openArtifact': 'artifact を開く',
  'settings.orbit.sourceMarkdown': 'ソース Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'メモリはチャットとは別のモデルを使用します。デフォルトはチャットモデルです。',
  'diagnostics.exportTitle': '診断情報をエクスポート',
  'diagnostics.exportButton': '診断情報をエクスポート',
  'diagnostics.exportHint': '最近のアプリログとマシン情報を zip にまとめて、チームに共有できるようにします。',
  'diagnostics.exporting': 'エクスポート中…',
  'diagnostics.exportSuccess': '診断情報を {path} に保存しました',
  'diagnostics.exportFailed': '診断情報のエクスポートに失敗しました: {message}',
  'automations.eyebrow': 'スケジュール実行のエージェントセッション',
  'automations.title': 'オートメーション',
  'automations.lede': 'プロジェクト作業・Orbit ダイジェスト・ライブアーティファクトの定期会話を計画します。',
  'automations.summaryAria': 'オートメーションの概要',
  'automations.metricActive': '有効',
  'automations.metricPaused': '一時停止',
  'automations.metricTemplates': 'テンプレート',
  'automations.newAutomation': 'オートメーションを作成',
  'automations.yourAutomations': 'あなたのオートメーション',
  'automations.loading': '読み込み中',
  'automations.emptyTitle': 'オートメーションはまだありません',
  'automations.emptyBody': 'テンプレートから作成するか、空のスケジュールから始めましょう。',
  'automations.targetNewEachRun': '実行ごとに新規プロジェクト',
  'automations.targetCreateEachRun': '実行ごとに新規プロジェクト',
  'automations.lastRun': '前回の実行 {time}',
  'automations.openResult': '結果を開く',
  'automations.run': '実行',
  'automations.runNowTitle': '今すぐ実行して会話を開く',
  'automations.history': '履歴',
  'automations.hideHistory': '履歴を隠す',
  'automations.edit': '編集',
  'automations.pause': '一時停止',
  'automations.resume': '再開',
  'automations.deleteAria': 'オートメーションを削除',
  'automations.deleteTitle': 'このオートメーションを削除',
  'automations.deleteConfirm': 'このオートメーションを削除しますか？過去の実行とそのプロジェクトは保持されます。',
  'automations.proposalsTitle': '進化の提案',
  'automations.proposalsSub': 'メモリ・スキル・デザインシステムを変更する前に、オートメーションの出力を確認します。',
  'automations.proposalsPending': '{n} 件保留中',
  'automations.apply': '適用',
  'automations.reject': '却下',
  'automations.proposalsDismissReason': 'オートメーションで却下しました',
  'automations.templatesTitle': 'テンプレート',
  'automations.templatesSub': 'Orbit とライブアーティファクトは、同じオートメーションフロー内のテンプレートです。',
  'automations.templatesCount': '{total} 件中 {filtered} 件',
  'automations.templateFiltersAria': 'テンプレートのフィルター',
  'automations.templatesEmptyTitle': 'このカテゴリにはまだテンプレートがありません。',
  'automations.templatesEmptyBody': '別のフィルターを試すか、空のオートメーションから始めましょう。',
  'automations.useTemplate': 'テンプレートを使う',
  'automations.runHistoryLoading': '実行履歴を読み込み中…',
  'automations.runHistoryEmpty': 'まだ実行はありません。',
  'automations.runHistoryTitle': '実行履歴',
  'automations.runHistoryLatest': '最新 10 件',
  'automations.crystallize': '結晶化',
  'automations.crystallizing': '結晶化中',
  'automations.crystallizeTitle': 'この実行からスキルとメモリの提案を作成',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': '会話を開く',
  'automations.runHistoryAria': 'オートメーションの実行履歴',
  'automations.proposalsAria': 'オートメーションの進化提案',
  'automations.templatesAria': 'オートメーションのテンプレート',
  'automations.runInProgress': '進行中',
  'automations.promptPlaceholder': '昨日の GitHub と Linear のアクティビティを取得し、変更点を要約します。',
  'automations.scheduleStatusPaused': '一時停止',
  'automations.nextRunManualOnly': '手動のみ',
  'automations.nextRunScheduled': 'スケジュール済み',
  'automations.nextRunAt': '次回 {time}',
  'automations.statusSucceeded': '成功',
  'automations.statusFailed': '失敗',
  'automations.statusRunning': '実行中',
  'automations.statusQueued': 'キュー待ち',
  'automations.statusCanceled': 'キャンセル済み',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'ライブアーティファクト',
  'automations.kindAutomation': 'オートメーション',
  'automations.proposalTargetMemory': 'メモリ',
  'automations.proposalTargetDesignSystem': 'デザインシステム',
  'automations.proposalTargetSkill': 'スキル',
  'automations.proposalTargetTemplate': 'オートメーションテンプレート',
  'automations.proposalActionCreate': '作成',
  'automations.proposalActionUpdate': '更新',
  'automations.proposalActionMerge': 'マージ',
  'automations.proposalActionMove': '移動',
  'automations.proposalActionDelete': '削除',
  'automations.proposalActionPromote': '昇格',
  'automations.filterAll': 'すべて',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'ライブアーティファクト',
  'automations.filterMemory': 'メモリ',
  'automations.filterDesignSystems': 'デザインシステム',
  'automations.filterSkills': 'スキル',
  'automations.filterConnectors': 'コネクター',
  'automations.filterCompression': '圧縮',
  'automations.filterRelease': 'リリース',
  'automations.filterQuality': '品質',
  'automations.tpl.memoryRefresh.title': '最近の作業からプロジェクトメモリを更新します。',
  'automations.tpl.memoryRefresh.desc': '繰り返される決定・好み・フィードバックを、再利用可能なメモリ更新に変えます。',
  'automations.tpl.designSystemRefresh.title': '出荷済みのアーティファクトからデザインシステムを更新します。',
  'automations.tpl.designSystemRefresh.desc': '最近のデザイン作業から再利用可能な Token・コンポーネント・ルールを見つけます。',
  'automations.tpl.liveArtifactRegistry.title': 'ライブアーティファクトを点検し、古いバージョンを更新します。',
  'automations.tpl.liveArtifactRegistry.desc': '永続的なダッシュボード・レポート・プレビューを複製せず最新に保ちます。',
  'automations.tpl.orbitDashboard.title': 'コネクターのアクティビティダッシュボードを作成します。',
  'automations.tpl.orbitDashboard.desc': '選択したコネクターを Orbit スタイルのライブダッシュボードに集約します。',
  'automations.tpl.releaseNotes.title': '出荷済みのデザイン作業からリリースノートを作成します。',
  'automations.tpl.releaseNotes.desc': 'マージ済みの PR・アーティファクト・プロダクト向けの変更をリリースノートにまとめます。',
  'automations.tpl.qualityRegressionWatch.title': 'デザインと実装のリグレッションを監視します。',
  'automations.tpl.qualityRegressionWatch.desc': '最近の変更をベンチマーク・トレース・承認済みの参照と比較します。',
  'automations.tpl.orbitDaily.title': 'コネクターの日次ダイジェスト。',
  'automations.tpl.orbitDaily.desc': 'コネクターのアクティビティダイジェストをスケジュールで更新します。',
  'automations.tpl.liveStatusBoard.title': 'ライブのステータスアーティファクトを最新に保ちます。',
  'automations.tpl.liveStatusBoard.desc': '実行ごとに新しいレポートを作らず、ひとつの永続アーティファクトを更新します。',
  'dsManager.areaAria': 'デザインシステム領域',
  'dsManager.tabDesignSystem': 'デザインシステム',
  'dsManager.tabTemplate': 'テンプレート',
  'dsManager.sourceAria': 'デザインシステムのソース',
  'dsManager.templateSourceAria': 'テンプレートのソース',
  'dsManager.yourSystems': 'あなたのシステム',
  'dsManager.officialPresets': '公式プリセット',
  'dsManager.shareToTeam': 'チームに共有',
  'dsManager.shareToTeamFailed': 'チームへの共有に失敗しました',
  'dsManager.syncToTeam': 'チームに同期',
  'dsManager.syncToTeamFailed': 'チームへの同期に失敗しました',
  'dsManager.unshareFromTeam': 'チームから削除',
  'dsManager.unshareFromTeamFailed': 'チームからの削除に失敗しました',
  'dsManager.teamSyncedReadOnly': '共有者またはワークスペース管理者のみ変更できます',
  'dsManager.enterprise': 'エンタープライズ',
  'dsManager.yourTemplates': 'あなたのテンプレート',
  'dsManager.yourSystemsAria': 'あなたのデザインシステム',
  'dsManager.eyebrowDesignSystems': 'デザインシステム',
  'dsManager.yourSystemsHeading': 'あなたのシステム',
  'dsManager.filterAria': 'デザインシステムを絞り込む',
  'dsManager.filterAll': 'すべて',
  'dsManager.filterPublished': '公開済み',
  'dsManager.filterDraft': '下書き',
  'dsManager.createTitle': '新しいデザインシステムを作成',
  'dsManager.createBody': 'ブランド・プロダクト・コード・アセット・デザインの参考資料を OpenDesign に学習させます。',
  'dsManager.createAction': '作成',
  'dsManager.emptyMine': 'デザインシステムはまだありません。実際のプロダクトのコンテキストから作成し、下書きを確認してから今後のプロジェクト向けに公開します。',
  'dsManager.badgeDefault': 'デフォルト',
  'dsManager.rowMetaUpdated': 'あなた · 更新 {date}',
  'dsManager.edit': '編集',
  'dsManager.openSystem': '開く',
  'dsManager.editWithAgent': 'Agent で編集',
  'dsManager.downloadTitle': 'デザインシステムをダウンロード（.zip + SKILLS.md）',
  'dsManager.downloadAria': '{title} を .zip としてダウンロード',
  'dsManager.downloadFailed': 'デザインシステムをダウンロードできませんでした。もう一度お試しください。',
  'dsManager.deleteConfirm': '「{title}」を削除しますか？このデバイスからデザインシステムの下書きが削除されます。',
  'dsManager.makeDefault': 'デフォルトに設定',
  'dsManager.statusPublished': '公開済み',
  'dsManager.statusDraft': '下書き',
  'dsManager.openSystemAria': '{title} を開く',
  'dsManager.deleteSystemAria': '{title} を削除',
  'dsManager.deletePermissionDenied': 'このデザインシステムを削除する権限がありません。',
  'dsManager.presetsAria': '公式デザインシステムのプリセット',
  'dsManager.eyebrowLibrary': 'ライブラリ',
  'dsManager.eyebrowTemplates': 'テンプレート',
  'dsManager.yourTemplatesAria': 'あなたのテンプレート',
  'dsManager.emptyTemplates': 'テンプレートはまだありません。テンプレート公開が有効になると、生成済みのプロジェクトから「共有」で作成できます。',
  'dsManager.templateDescFallback': 'プロジェクトから作成',
  'dsManager.comingSoonBadge': '近日公開',
  'dsManager.enterpriseDsTitle': 'エンタープライズデザインシステム',
  'dsManager.enterpriseDsBody': 'チームで共有するデザインシステムと、ガバナンス付きのブランドライブラリは近日公開です。',
  'dsManager.enterpriseTplTitle': 'エンタープライズテンプレート',
  'dsManager.enterpriseTplBody': 'チーム承認のテンプレートと組織全体への公開は近日公開です。',
  'settings.instructionsTitle': '指示とルール',
  'settings.instructionsSubtitle': 'アシスタントが常に従う固定の振る舞い',
  'settings.instructionsNavSub': '固定のアシスタント挙動',
  'settings.customInstructionsDesc': 'OpenDesign がすべてのチャットで従う固定の指示です。これらは保存されたメモリではありません。事実・好み・プロジェクトのコンテキストには「メモリ」を使用してください。',
  'mcpClient.forwardedToLabel': '転送先：',
  'mcpClient.notForwardedToLabel': '転送されない先：',
  'mcpClient.forwardedAcpNote': 'stdio only と表示された ACP アダプターは、このリストから stdio タイプの MCP サーバーのみを受け取ります。HTTP と SSE のエントリは起動時に破棄されます。',
  'mcpClient.notForwardedNote': 'これらのエージェントについては、各エージェント自身の設定ファイル（例：~/.codex/config.toml、~/.gemini/settings.json）で MCP サーバーを設定してください。以下のサーバーはそこでは使用されません。',

  // Brands library + extraction
  'brand.libraryTitle': 'ブランドキット',
  'brand.librarySubtitle': 'Teach OpenDesign your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'ウェブサイトを貼り付けるか、下からブランドを選ぶと、その色・フォント・ロゴを抽出します。',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'ブランドキット',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'アップデートキャッシュをクリア',
  'settings.clearUpdaterCacheHint': 'ダウンロード済みのアップデートと古いアップデートキャッシュを削除し、更新状態をリセットします。アップデートが止まっているように見えるときに使用してください。',
  'settings.clearUpdaterCacheButton': 'キャッシュをクリア',
  'settings.clearUpdaterCacheConfirmButton': 'クリアを確認',
  'settings.clearUpdaterCacheSuccess': 'アップデートキャッシュをクリアしました。',
  'settings.clearUpdaterCacheFailed': 'アップデートキャッシュをクリアできませんでした。',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': '一度作れば、どこでも構築',
  'onboarding.buildBody': 'OpenDesign はあなたのブランドを再利用可能なデザインシステムに変え、作るものすべてをブランドに沿って一貫させます。',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'デザインシステムを作成',
  'onboarding.buildHome': 'ホームへ',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. OpenDesign first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': '好きなブランドから始める',
  'brandPicker.subtext': 'ブランドをクリックすると、その Web サイトから直接ブランドキットを抽出できます。',
  'brandPicker.quickPicksLabel': '人気のブランド — クリックして抽出',
  'brandPicker.searchPlaceholder': 'ブランドを検索…',
  'brandPicker.allCategories': 'すべて',
  'brandPicker.extractAction': '抽出',
  'brandPicker.showMore': 'もっと見る',
  'brandPicker.opening': '抽出を開始しています — {brand} を開いています…',
  'ds.kitVisualize': 'ビジュアル',
  'ds.kitEdit': '編集',
  'ds.kitSource': 'ソース',
  'ds.saveDesignMd': 'DESIGN.md を保存',
  'ds.saving': '保存中…',
  'ds.copyDesignMd': 'DESIGN.md をコピー',
  'ds.editDesignMd': 'DESIGN.md を編集',
  'ds.openDesignMd': 'DESIGN.md を開く',
  'ds.copyDesignMdModule': '{module} セクションをコピー',
  'ds.editDesignMdModule': '{module} セクションを編集',
  'ds.openDesignMdModule': '{module} セクションを開く',
  'ds.uploadMd': 'MD をアップロード',
  'ds.uploadFont': 'フォントファイルを追加',
  'ds.pasteImage': '画像をペースト',
  'ds.refresh': '更新',
  'ds.download': 'ダウンロード',
  'ds.importFolder': 'フォルダをインポート',
  'ds.reset': 'リセット',
  'ds.editingDesignMdHint': 'この Markdown を編集すると、レンダリング済みのキットモジュールが更新されます。',
  'ds.editingModuleHint': '{module} モジュールのみ編集中です。',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'モジュールを保存',
  'ds.uploadLogo': 'ロゴをアップロード',
  'ds.uploadImage': '画像をアップロード',
  'ds.uploading': 'アップロード中…',
  'ds.moduleEmptyLogo': 'ロゴはまだありません',
  'ds.moduleEmptyFonts': '取得されたフォントはありません。',
  'ds.actionDone': '完了',
  'ds.actionFailed': '問題が発生しました。もう一度お試しください。',
  'ds.uploadDone': 'アップロード済み',
  'ds.uploadFailed': 'アップロードに失敗しました。もう一度お試しください。',
  'ds.deleteLogo': 'ロゴを削除',
  'ds.deleteImage': '{caption} を削除',
  'ds.deleteProjectConfirm': '「{title}」を削除しますか？このデバイスからこのデザインシステムとそのプロジェクトが完全に削除されます。',
  'ds.deleteProjectAction': '{title} を削除',
  'ds.editColor': '{name} を編集',
  'ds.colorLabel': '色',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Hex 値',
  'ds.saveColor': '色を保存',
  'ds.invalidHexColor': '#FF6A3D のような有効な Hex カラーを入力してください。',
  'ds.colorSaveFailed': 'この色を保存できませんでした。',
  'ds.colorResetFailed': 'この色をリセットできませんでした。',
  'ds.designMdSectionLabel': '{module} DESIGN.md セクション',
  'ds.kitErrorTitle': 'このビューで問題が発生しました。',
  'ds.kitErrorRetry': '再読み込み',
  'ds.shortcutsLabel': 'キーボードショートカット',
  'ds.shortcutsHint': 'ショートカット: E 編集 · C コピー · U アップロード · R 更新 · ⌫ ロゴ削除',
  'ds.moduleEmptyImages': '画像はまだありません',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'OpenDesign is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so OpenDesign can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': '開始方法',
  'newproj.startBlank': '白紙',
  'newproj.startBlankHint': 'ゼロから作成',
  'workspace.pages': 'ページ',
  'workspace.allProjectFiles': 'プロジェクトの全ファイル',
  'workspace.newBlankPage': '新しい空白ページ',
  'workspace.noPagesYet': 'ページはまだありません',
  'workspace.pageCreateFailed': 'ページを作成できませんでした。',
  'workspace.pageCreatorTitle': 'ページを作成',
  'workspace.pageCreatorSearch': 'テンプレートを検索',
  'workspace.pageCreatorCategoryAll': 'すべてのシーン',
  'workspace.pageCreatorEmpty': '検索に一致するページタイプはありません。',
  'workspace.pageCreatorPreview': 'プレビュー',
  'workspace.pageCreatorUse': '使用',
  'fileViewer.presentInTabDeckHint': 'スピーカーノートをポップアップで表示',
  'fileViewer.presentEscHint': 'Esc キーで終了',
  'fileViewer.presenterPause': '一時停止',
  'fileViewer.presenterResume': '再開',
  'fileViewer.presenterPrevious': '前へ',
  'fileViewer.presenterNext': '次へ',
  'questions.uploadingFiles': 'ファイルをアップロード中…',
  'questions.uploadNeedsProject': 'ファイルのアップロードにはアクティブなプロジェクトが必要です。',
  'questions.uploadPartialFailed': '{uploaded} 件のファイルをアップロードしましたが、{failed} 件が失敗しました。',
  'questions.uploadFailed': '{failed} 件のファイルのアップロードに失敗しました。',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeDocument': 'Document',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.typeWebGL': 'WebGL',
  'community.usePrompt': '同じものを作る',
  'community.emptyTitle': '{type}のテンプレートはまだありません',
  'community.emptyBody': 'コミュニティに公開されたテンプレートがここに表示されます。',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the OpenDesign Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the OpenDesign Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and OpenDesign will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'OpenDesign will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'OpenDesign account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by OpenDesign; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'OpenDesign is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'OpenDesign is rebuilding tokens',
  'dsFlow.jobRevising': 'OpenDesign is revising',
  'dsFlow.jobStillWorking': 'OpenDesign is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask OpenDesign to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'OpenDesign is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'OpenDesign is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'OpenDesign is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'OpenDesign official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': '今回は最高峰の知性を、思いきり。無制限。',
  'campaign.deepseekV4Flash.description': 'LP、サイト、スライド、画像——納得いくまで何度でも。',
  'campaign.deepseekV4Flash.benefit': 'DeepSeek V4 Pro と V4 Flash 無制限',
  'campaign.deepseekV4Flash.timing': '8/13–8/27：キャンペーン期間中無料',
  'campaign.deepseekV4Flash.ruleSummary': '8/13–8/27、有料プランのユーザーは OpenDesign 内で DeepSeek V4 Pro と V4 Flash を無料利用できます。大規模な不正利用は停止される場合があります。',
  'campaign.deepseekV4Flash.windowLabel': '8/13–8/27',
  'campaign.deepseekV4Flash.weekFreeSuffix': '2週間無料',
  'campaign.deepseekV4Flash.boundary': 'プラン内の無制限モデル枠と無料生成回数は OpenDesign 内のみ。MCP / CLI / API など他経路では使えません。最終解釈は公式に帰属します。一部のモデルはピーク時に待ち時間が発生する場合があります。',
  'campaign.deepseekV4Flash.countdownLabel': 'キャンペーン残り時間',
  'campaign.deepseekV4Flash.countdownEnded': 'キャンペーン終了',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}日 {hms}',
  'campaign.deepseekV4Flash.closeAria': '閉じる',
  'campaign.deepseekV4Flash.unlocked': '利用可能',
  'campaign.deepseekV4Flash.locked': 'ロック中',
  'campaign.deepseekV4Flash.later': 'あとで',
  'campaign.deepseekV4Flash.paid.eyebrow': '2週間無料',
  'campaign.deepseekV4Flash.paid.status': '利用可能 · 8/13–8/27',
  'campaign.deepseekV4Flash.paid.cta': '今すぐ使う',
  'campaign.deepseekV4Flash.paid.modelBadge': '無制限',
  'campaign.deepseekV4Flash.unpaid.eyebrow': '有料プラン向け無料開放',
  'campaign.deepseekV4Flash.unpaid.status': 'アップグレード後に利用 · 8/27まで',
  'campaign.deepseekV4Flash.unpaid.cta': 'プランをアップグレードして使う',
  'campaign.deepseekV4Flash.unpaid.modelBadge': '要アップグレード',
  'campaign.deepseekV4Flash.unpaid.tooltip': '期間中に有料プランへ加入すると無料で利用できます。8/27終了。',
  'campaign.deepseekV4Flash.restricted.modelBadge': '一時停止',
  'campaign.deepseekV4Flash.restricted.tooltip': '異常な大量利用を検知したため特典を停止しました。ご不明点はサポートへ。',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash 無制限で無料',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro と V4 Flash が無制限で無料 — 料金ページを見る',

  'experienceSurvey.tag': "ご意見をお聞かせください。一緒に OpenDesign を良くしていきましょう",
  'experienceSurvey.close': "閉じる",
  'experienceSurvey.recommendation': "OpenDesign を同僚や友人にすすめる可能性はどのくらいですか？",
  'experienceSurvey.recommendationLow': "まったくすすめない",
  'experienceSurvey.recommendationHigh': "必ずすすめる",
  'experienceSurvey.improvement': "どれを最初に改善すべきですか？",
  'experienceSurvey.improvement.wrongOutput': "頼んだものと違う",
  'experienceSurvey.improvement.falseDone': "完了と言うが変化がない",
  'experienceSurvey.improvement.hardToUse': "使いにくい",
  'experienceSurvey.improvement.upgradePrompts': "課金の案内が多すぎる",
  'experienceSurvey.improvement.stuck': "途中で止まる・失敗する",
  'experienceSurvey.improvement.slow': "遅すぎる",
  'experienceSurvey.improvement.looks': "見た目がよくない",
  'experienceSurvey.improvement.regression': "他の部分を壊す",
  'experienceSurvey.improvement.other': "その他",
  'experienceSurvey.otherPlaceholder': "自由にお書きください",
  'experienceSurvey.submit': "送信",
  'experienceSurvey.skip': "スキップ",
  'experienceSurvey.thanksTitle': "ありがとうございます！",
  'experienceSurvey.thanksBody': "いただいた声はチームに直接届きます。",
  'chat.record.verb.read': "読み取り",
  'chat.record.verb.write': "作成",
  'chat.record.verb.edit': "編集",
  'chat.record.verb.search': "検索",
  'chat.record.verb.exec': "実行",
  'chat.record.failed': "失敗",
  'chat.record.hits': "{count} 件",
  'chat.record.slowUpstream': 'プロバイダーの応答が遅く、{seconds} 秒待機中',
  'chat.record.running': "実行中",
  'chat.record.thinking': "思考中",
  'chat.record.thinkingTokens': "{count} トークン",
  'chat.record.thoughts': "思考プロセス",
  'chat.record.done': "完了",
  'chat.record.failedTurn': "実行失敗",
  'chat.record.plan': "実行計画 · {count} ステップ",
  'chat.record.planStep': "ステップ {current} / {total}",
  'chat.record.imageBatch': "イラストを生成",
  'chat.record.imageCount': "{count} 枚",
  'chat.record.retry': "再試行",
  'chat.record.viewImage': "{index} 枚目を表示",
  'chat.record.viewLarge': "拡大表示",
  'chat.record.imagePending': "画像を生成中…",
  'chat.record.audioBatch': "音声を生成中",
  'chat.record.videoBatch': "動画を生成中",
  'chat.record.audioCount': "{count} 件",
  'chat.record.videoCount': "{count} 本",
  'chat.record.audioPending': "音声を生成中…",
  'chat.record.videoPending': "動画を生成中…",
  'chat.record.viewAudio': "音声 {index} を開く",
  'chat.record.viewVideo': "動画 {index} を開く",
  'chat.designSystemStatus.title': "デザインシステムのワークスペースを作成中",
  'chat.designSystemStatus.description': "Open Design がセットアップのソースを使ってこのプロジェクトを生成しています。",
  'labs.title': "Open Design ラボ",
  'labs.itemAbout': "{name} について",
  'labs.navHint': "未リリースの機能をひと足先に。",
  'labs.pageDesc': "まだ正式リリースされていない機能をひと足先に試せます。多くの場合は現在の挙動より優れており、オフにすればすぐに元の状態へ戻ります。",
  'labs.harnessName': "Design Harness",
  'labs.harnessHint': "オンにすると、次回の生成から OpenDesign の最新生成戦略を使用します。仕上がりがより洗練されます（ベータ）",
  'labs.harnessTooltip': "Open Design がデザイン用途に構築した agent harness に切り替えます。レイアウト・構成・完成度が目に見えて良くなります。",
  'labs.harnessScope': "現在はプロトタイプ、スライド、マーケティング素材、Hyperframes に対応しています。一部の agent は未対応です。",
  'labs.envOverrideNotice': "環境変数が優先されているため、ここでは変更できません。",
  'labs.loadFailedNotice': "この設定を読み込めませんでした。ローカルの daemon が起動しているか確認してください。",
  'labs.optOutPrompt': "元の生成方式に戻しました。どこが合いませんでしたか？",
  'labs.optOutWorseOutput': "成果物の質が下がった",
  'labs.optOutTooSlow': "遅い",
  'labs.optOutNotWhatIWanted': "求めていたものと違う",
  'labs.optOutOther': "その他",
  'labs.optOutSkip': "スキップ",
  'labs.optOutOtherPlaceholder': "具体的にどこが合いませんでしたか？",
  'labs.optOutSubmit': "送信",
  'chat.conversationsSearchPlaceholder': "会話を検索",
  'chat.conversationsNoMatches': "一致する会話はありません。",
  'chat.attachments.preview': "{name}をプレビュー",
  'chat.record.canceled': "キャンセル済み",
  'chat.record.pending': "未開始",
  'chat.record.unfinished': "未完了",
};
